var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _g2, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _g3, _path269, _path270, _path271, _path272, _path273, _path274, _g4, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 219,
    viewBox: "0 0 231 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6987 122.494L28.6339 168.101C27.2247 168.958 24.7562 167.047 23.4928 166.355C22.126 165.606 21.1317 164.124 21.1317 162.281V87.9883C21.1317 85.2619 22.5197 82.7404 24.7747 81.3682L96.9651 37.4619C98.3902 36.5951 99.9691 36.5563 101.312 37.1102C103.116 37.8552 106.542 38.8715 106.542 41.1839L104.492 113.783C104.492 117.371 102.667 120.687 99.6987 122.493V122.494Z",
    fill: "url(#paint0_linear_620_3722)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M46.8626 194.876C39.379 205.885 59.3521 216.345 91.4742 218.241C123.596 220.135 155.702 212.746 163.186 201.738C170.67 190.729 150.696 180.269 118.574 178.373C86.4524 176.479 54.3463 183.868 46.8626 194.876Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M47.6143 194.869C40.2301 205.732 59.9382 216.053 91.6333 217.924C123.328 219.793 155.009 212.503 162.392 201.64C169.776 190.777 150.068 180.456 118.373 178.585C86.6778 176.716 54.9972 184.006 47.6143 194.869Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M48.3662 194.861C41.0814 205.578 60.5243 215.759 91.7925 217.605C123.061 219.45 154.314 212.258 161.599 201.54C168.884 190.823 149.441 180.642 118.173 178.796C86.9046 176.951 55.651 184.143 48.3662 194.861Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M49.1179 194.854C41.9326 205.424 61.1103 215.469 91.9517 217.287C122.793 219.106 153.62 212.011 160.805 201.442C167.991 190.872 148.813 180.827 117.971 179.009C87.1301 177.19 56.3033 184.285 49.1179 194.854Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.8693 194.847C42.7833 205.271 61.696 215.177 92.1104 216.97C122.525 218.764 152.926 211.768 160.012 201.344C167.098 190.92 148.185 181.014 117.771 179.221C87.3564 177.427 56.9552 184.423 49.8693 194.847Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M50.621 194.84C43.6345 205.118 62.282 214.884 92.2696 216.653C122.259 218.421 152.232 211.524 159.218 201.245C166.205 190.967 147.557 181.201 117.569 179.433C87.5806 177.665 57.6075 184.562 50.621 194.84Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M51.3727 194.833C44.4856 204.965 62.8666 214.592 92.4286 216.336C121.991 218.079 151.538 211.28 158.424 201.147C165.311 191.016 146.93 181.388 117.368 179.645C87.8059 177.901 58.2584 184.7 51.3727 194.833Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M52.1245 194.826C45.3369 204.811 63.4527 214.3 92.5879 216.019C121.723 217.737 150.844 211.035 157.631 201.05C164.419 191.066 146.303 181.576 117.168 179.858C88.0328 178.14 58.9122 184.842 52.1245 194.826Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M52.8763 194.818C46.188 204.657 64.0388 214.007 92.747 215.7C121.455 217.394 150.149 210.79 156.837 200.951C163.525 191.111 145.675 181.762 116.966 180.069C88.2582 178.375 59.5645 184.979 52.8763 194.818Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.6276 194.811C47.0389 204.503 64.6244 213.714 92.9058 215.381C121.187 217.05 149.455 210.545 156.044 200.851C162.633 191.158 145.047 181.947 116.766 180.28C88.4846 178.612 60.2164 185.117 53.6276 194.811Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M54.3794 194.804C47.89 204.351 65.2104 213.422 93.065 215.064C120.919 216.708 148.761 210.3 155.25 200.754C161.739 191.207 144.419 182.136 116.565 180.493C88.71 178.85 60.8687 185.258 54.3794 194.804Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M55.1311 194.797C48.7411 204.198 65.7964 213.13 93.2241 214.748C120.652 216.365 148.066 210.056 154.456 200.656C160.846 191.255 143.791 182.323 116.363 180.706C88.9354 179.088 61.521 185.397 55.1311 194.797Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M55.8829 194.79C49.5924 204.044 66.3812 212.838 93.3833 214.43C120.384 216.022 147.373 209.812 153.663 200.557C159.954 191.303 143.165 182.509 116.163 180.917C89.1622 179.325 62.1734 185.535 55.8829 194.79Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M56.6346 194.783C50.4435 203.892 66.9672 212.546 93.5424 214.113C120.116 215.681 146.678 209.567 152.869 200.46C159.06 191.352 142.537 182.698 115.962 181.13C89.3876 179.563 62.8257 185.676 56.6346 194.783Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M57.3874 194.776C51.2958 203.738 67.5543 212.254 93.7027 213.796C119.851 215.339 145.986 209.324 152.078 200.362C158.169 191.401 141.911 182.885 115.763 181.342C89.6142 179.8 63.4791 185.815 57.3874 194.776Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M58.1391 194.768C52.1469 203.583 68.1403 211.96 93.8618 213.478C119.583 214.995 145.291 209.079 151.284 200.262C157.276 191.448 141.283 183.07 115.561 181.553C89.8396 180.035 64.1314 185.952 58.1391 194.768Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M58.8909 194.761C52.9981 203.43 68.7263 211.668 94.0209 213.159C119.316 214.652 144.597 208.833 150.49 200.164C156.382 191.494 140.654 183.257 115.36 181.766C90.065 180.273 64.7837 186.091 58.8909 194.761Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.6427 194.754C53.8494 203.277 69.3125 211.376 94.1802 212.842C119.048 214.308 143.904 208.588 149.697 200.066C155.49 191.543 140.027 183.444 115.16 181.978C90.2919 180.511 65.4361 186.232 59.6427 194.754Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M60.394 194.747C54.7 203.125 69.898 211.084 94.3388 212.525C118.78 213.966 143.209 208.345 148.902 199.967C154.596 191.59 139.398 183.631 114.958 182.19C90.5168 180.748 66.0879 186.37 60.394 194.747Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M61.1458 194.74C55.5513 202.971 70.4827 210.791 94.498 212.208C118.512 213.624 142.515 208.101 148.11 199.87C153.704 191.64 138.773 183.819 114.758 182.403C90.7436 180.986 66.7403 186.51 61.1458 194.74Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M61.8973 194.733C56.4023 202.817 71.0686 210.499 94.6557 211.891C118.243 213.282 141.819 207.856 147.314 199.772C152.809 191.688 138.143 184.006 114.556 182.615C90.9689 181.223 67.3924 186.65 61.8973 194.733Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M62.6491 194.726C57.2534 202.665 71.6546 210.207 94.8148 211.574C117.975 212.94 141.125 207.612 146.52 199.674C151.916 191.736 137.515 184.193 114.354 182.827C91.1943 181.46 68.0447 186.788 62.6491 194.726Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M63.4009 194.718C58.1047 202.51 72.2408 209.914 94.9741 211.254C117.709 212.594 140.431 207.366 145.728 199.574C151.024 191.783 136.888 184.379 114.154 183.039C91.4198 181.698 68.6971 186.927 63.4009 194.718Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M64.1526 194.711C58.9558 202.357 72.8268 209.621 95.1332 210.937C117.441 212.252 139.737 207.122 144.934 199.476C150.13 191.83 136.259 184.566 113.953 183.25C91.6453 181.935 69.3494 187.065 64.1526 194.711Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M64.904 194.704C59.8067 202.204 73.4125 209.329 95.292 210.619C117.173 211.91 139.043 206.877 144.141 199.377C149.238 191.878 135.632 184.753 113.753 183.462C91.8717 182.172 70.0014 187.205 64.904 194.704Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M65.6562 194.697C60.6582 202.05 73.9975 209.037 95.4515 210.303C116.906 211.568 138.349 206.633 143.347 199.281C148.345 191.928 135.005 184.941 113.551 183.675C92.0975 182.41 70.6541 187.345 65.6562 194.697Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M66.4075 194.691C61.509 201.898 74.5832 208.745 95.6103 209.986C116.637 211.226 137.654 206.39 142.554 199.182C147.452 191.975 134.378 185.128 113.351 183.887C92.3239 182.647 71.3074 187.483 66.4088 194.691H66.4075Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M67.1593 194.684C62.3602 201.744 75.1692 208.453 95.7695 209.669C116.37 210.884 136.961 206.145 141.76 199.084C146.559 192.024 133.75 185.315 113.15 184.099C92.5493 182.884 71.9583 187.623 67.1593 194.684Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M67.911 194.675C63.2113 201.589 75.7552 208.159 95.9286 209.348C116.102 210.538 136.266 205.898 140.966 198.984C145.665 192.071 133.121 185.5 112.948 184.311C92.7747 183.122 72.6106 187.762 67.911 194.675Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M68.6628 194.668C64.0626 201.437 76.3414 207.867 96.0879 209.032C115.834 210.196 135.573 205.654 140.173 198.886C144.773 192.118 132.495 185.687 112.748 184.523C93.0016 183.358 73.2631 187.9 68.6628 194.668Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M69.4146 194.662C64.9138 201.283 76.9274 207.575 96.247 208.715C115.567 209.854 134.878 205.411 139.379 198.788C143.88 192.166 131.866 185.874 112.547 184.735C93.227 183.595 73.9154 188.039 69.4146 194.662Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M70.1659 194.654C65.7645 201.13 77.5116 207.282 96.4057 208.397C115.3 209.512 134.183 205.165 138.586 198.691C142.987 192.215 131.24 186.062 112.346 184.948C93.452 183.833 74.5686 188.18 70.1659 194.654Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M70.9176 194.647C66.6157 200.977 78.0977 206.99 96.5648 208.08C115.032 209.17 133.49 204.922 137.792 198.592C142.094 192.263 130.612 186.249 112.145 185.16C93.6774 184.07 75.2195 188.318 70.9176 194.647Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M71.6693 194.641C67.4668 200.823 78.6837 206.698 96.7239 207.763C114.764 208.828 132.795 204.678 136.998 198.494C141.2 192.312 129.983 186.437 111.943 185.372C93.9028 184.307 75.8718 188.457 71.6693 194.641Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M72.4212 194.634C68.3181 200.671 79.2698 206.406 96.8832 207.446C114.497 208.484 132.102 204.433 136.205 198.397C140.308 192.36 129.357 186.625 111.743 185.585C94.1297 184.546 76.5242 188.598 72.4212 194.634Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M73.1729 194.625C69.1692 200.516 79.8558 206.112 97.0423 207.126C114.229 208.14 131.407 204.186 135.411 198.296C139.415 192.406 128.728 186.809 111.542 185.795C94.3551 184.782 77.1765 188.735 73.1729 194.625Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M73.9243 194.618C70.0201 200.362 80.4415 205.82 97.2011 206.809C113.961 207.798 130.712 203.943 134.618 198.198C138.522 192.454 128.101 186.996 111.341 186.007C94.5815 185.019 77.8298 188.873 73.9243 194.618Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M74.6759 194.612C70.8711 200.21 81.0261 205.528 97.3602 206.492C113.693 207.456 130.019 203.698 133.824 198.101C137.629 192.503 127.474 187.184 111.14 186.221C94.8069 185.257 78.4807 189.015 74.6759 194.612Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M75.4277 194.605C71.7223 200.056 81.6121 205.236 97.5193 206.175C113.425 207.114 129.324 203.454 133.03 198.003C136.735 192.551 126.845 187.371 110.938 186.433C95.0323 185.494 79.133 189.153 75.4277 194.605Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M76.1795 194.598C72.5736 199.904 82.1982 204.944 97.6786 205.858C113.159 206.77 128.63 203.21 132.237 197.904C135.843 192.598 126.219 187.558 110.738 186.644C95.2578 185.732 79.7868 189.292 76.1795 194.598Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.9312 194.591C73.4247 199.75 82.7842 204.652 97.8377 205.541C112.891 206.428 127.937 202.967 131.443 197.807C134.95 192.648 125.59 187.747 110.537 186.858C95.4832 185.97 80.4377 189.432 76.9312 194.591Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M77.6826 194.583C74.2755 199.595 83.3699 204.358 97.9965 205.221C112.623 206.084 127.242 202.719 130.65 197.706C134.057 192.694 124.963 187.931 110.336 187.068C95.7096 186.205 81.091 189.57 77.6826 194.583Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M78.4343 194.576C75.1267 199.443 83.9559 204.066 98.1556 204.904C112.355 205.742 126.548 202.475 129.856 197.608C133.164 192.741 124.334 188.118 110.135 187.28C95.935 186.442 81.742 189.709 78.4343 194.576Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M79.1861 194.569C75.9778 199.289 84.5419 203.774 98.3148 204.587C112.088 205.399 125.854 202.231 129.062 197.511C132.27 192.791 123.706 188.306 109.933 187.493C96.1605 186.68 82.3943 189.848 79.1861 194.569Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M79.9377 194.562C76.8289 199.137 85.1265 203.482 98.4725 204.27C111.818 205.057 125.158 201.986 128.268 197.413C131.377 192.838 123.079 188.493 109.733 187.705C96.3871 186.917 83.0478 189.988 79.9377 194.562Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.6894 194.555C77.68 198.983 85.7125 203.191 98.6316 203.953C111.551 204.714 124.464 201.743 127.474 197.315C130.483 192.886 122.451 188.678 109.532 187.917C96.6125 187.155 83.6988 190.127 80.6894 194.555Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M81.4413 194.548C78.5313 198.829 86.2987 202.899 98.7909 203.635C111.283 204.372 123.77 201.499 126.681 197.217C129.591 192.936 121.824 188.866 109.332 188.13C96.8394 187.393 84.3525 190.266 81.4413 194.548Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M82.193 194.541C79.3825 198.677 86.8847 202.607 98.95 203.318C111.015 204.03 123.077 201.255 125.887 197.119C128.698 192.983 121.195 189.054 109.13 188.342C97.0648 187.63 85.0035 190.405 82.193 194.541Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M82.9447 194.533C80.2336 198.522 87.4707 202.313 99.1091 202.998C110.749 203.685 122.382 201.007 125.093 197.018C127.804 193.029 120.567 189.238 108.929 188.552C97.2889 187.865 85.6558 190.543 82.9447 194.533Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M83.6961 194.526C81.0844 198.368 88.0564 202.021 99.2679 202.682C110.481 203.343 121.687 200.764 124.3 196.921C126.912 193.079 119.94 189.426 108.728 188.766C97.5153 188.104 86.3091 190.683 83.6961 194.526Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4478 194.519C81.9355 198.216 88.641 201.729 99.427 202.364C110.213 203 120.994 200.52 123.506 196.823C126.018 193.126 119.313 189.613 108.527 188.977C97.7407 188.342 86.96 190.822 84.4478 194.519Z",
    fill: "#0F0A26"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0293 174.563L103.973 128.79C106.733 127.127 110.135 127.133 112.889 128.805L165.955 161.036C168.394 162.518 168.389 166.201 165.944 167.674L89.7213 213.616C86.236 215.717 81.9421 215.71 78.4634 213.597L28.0161 182.957C24.9312 181.083 24.9391 176.427 28.0293 174.563Z",
    fill: "url(#paint1_linear_620_3722)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4014 172.66L103.973 128.62C106.733 126.957 110.135 126.962 112.89 128.635L167.081 157.824C167.995 158.379 167.441 162.286 167.669 163.228C168.048 164.798 167.473 166.582 165.946 167.502L89.7227 213.444C86.2374 215.545 81.9434 215.538 78.4647 213.425L28.0174 182.785C26.3444 181.769 25.5808 179.934 25.7253 178.17C25.8472 176.681 24.9882 173.512 26.4027 172.659L26.4014 172.66Z",
    fill: "url(#paint2_linear_620_3722)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0288 169.546L103.972 123.774C106.732 122.111 110.134 122.116 112.889 123.789L165.955 156.02C168.394 157.501 168.389 161.184 165.944 162.658L89.7208 208.599C86.2356 210.7 81.9416 210.693 78.4629 208.58L28.0156 177.94C24.9307 176.067 24.9386 171.41 28.0288 169.546Z",
    fill: "url(#paint3_linear_620_3722)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.016 177.594L78.4633 208.234C81.9419 210.347 86.2359 210.354 89.7212 208.253L165.944 162.311C167.112 161.608 167.706 160.398 167.761 159.166C167.816 160.514 167.222 161.886 165.944 162.656L89.7212 208.598C86.2359 210.699 81.9419 210.692 78.4633 208.579L28.016 177.939C26.4198 176.97 25.6681 175.255 25.7278 173.567C25.7795 175.139 26.5298 176.69 28.016 177.593V177.594Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 129.983C102.934 129.983 103.244 129.957 103.785 129.913L105.814 128.77C106.2 128.536 106.677 128.538 107.062 128.776L108.918 129.9C109.237 129.866 109.489 129.838 109.489 129.838V130.629H109.485C109.469 130.798 109.382 130.96 109.223 131.057L106.612 132.551C106.313 132.732 105.943 132.731 105.645 132.546L103.123 131.011C102.997 130.933 102.935 130.8 102.934 130.667V129.983Z",
    fill: "url(#paint4_linear_620_3722)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 129.953C102.934 129.953 103.244 129.927 103.785 129.883L105.814 128.74C106.2 128.506 106.677 128.508 107.062 128.746L108.918 129.87C109.237 129.835 109.489 129.808 109.489 129.808V130.598H109.485C109.469 130.767 109.382 130.929 109.223 131.026L106.612 132.52C106.313 132.702 105.943 132.7 105.645 132.516L103.123 130.981C102.997 130.903 102.935 130.77 102.934 130.637V129.953Z",
    fill: "url(#paint5_linear_620_3722)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.126 129.581L105.813 128.04C106.199 127.806 106.676 127.807 107.06 128.045L109.225 129.361C109.577 129.578 109.575 130.111 109.221 130.326L106.611 131.82C106.311 132.001 105.942 132 105.643 131.816L103.122 130.28C102.867 130.122 102.869 129.736 103.124 129.581H103.126Z",
    fill: "url(#paint6_linear_620_3722)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5938 133.199C97.5938 133.199 97.904 133.172 98.4449 133.128L100.475 131.986C100.86 131.752 101.338 131.753 101.722 131.991L103.578 133.116C103.898 133.081 104.149 133.053 104.149 133.053V133.844H104.145C104.13 134.013 104.042 134.175 103.883 134.272L101.273 135.766C100.973 135.947 100.603 135.946 100.305 135.762L97.7833 134.226C97.6574 134.149 97.5951 134.016 97.5938 133.883V133.199Z",
    fill: "url(#paint7_linear_620_3722)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5938 133.167C97.5938 133.167 97.904 133.141 98.4449 133.096L100.475 131.954C100.86 131.72 101.338 131.721 101.722 131.96L103.578 133.084C103.898 133.049 104.149 133.022 104.149 133.022V133.812H104.145C104.13 133.981 104.042 134.143 103.883 134.24L101.273 135.734C100.973 135.916 100.603 135.914 100.305 135.73L97.7833 134.194C97.6574 134.117 97.5951 133.984 97.5938 133.851V133.167Z",
    fill: "url(#paint8_linear_620_3722)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7873 132.796L100.475 131.255C100.86 131.021 101.338 131.022 101.722 131.26L103.887 132.576C104.238 132.793 104.237 133.326 103.883 133.541L101.273 135.035C100.973 135.216 100.603 135.215 100.305 135.031L97.7833 133.495C97.5288 133.337 97.5301 132.951 97.786 132.796H97.7873Z",
    fill: "url(#paint9_linear_620_3722)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2549 136.414C92.2549 136.414 92.5651 136.387 93.106 136.343L95.1357 135.201C95.5215 134.967 95.9987 134.968 96.3832 135.206L98.2392 136.331C98.5587 136.296 98.8105 136.268 98.8105 136.268V137.059H98.8066C98.7907 137.228 98.7032 137.39 98.5441 137.487L95.9338 138.981C95.6341 139.162 95.2643 139.161 94.966 138.977L92.4445 137.441C92.3185 137.364 92.2562 137.231 92.2549 137.098V136.414Z",
    fill: "url(#paint10_linear_620_3722)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2549 136.382C92.2549 136.382 92.5651 136.356 93.106 136.311L95.1357 135.169C95.5215 134.935 95.9987 134.936 96.3832 135.174L98.2392 136.299C98.5587 136.264 98.8105 136.237 98.8105 136.237V137.027H98.8066C98.7907 137.196 98.7032 137.358 98.5441 137.455L95.9338 138.949C95.6341 139.13 95.2643 139.129 94.966 138.945L92.4445 137.409C92.3185 137.332 92.2562 137.199 92.2549 137.066V136.382Z",
    fill: "url(#paint11_linear_620_3722)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.447 136.011L95.1342 134.47C95.52 134.236 95.9972 134.237 96.3817 134.475L98.5466 135.791C98.8979 136.008 98.8966 136.541 98.5426 136.756L95.9323 138.25C95.6327 138.431 95.2628 138.43 94.9645 138.246L92.443 136.71C92.1885 136.552 92.1898 136.166 92.4457 136.011H92.447Z",
    fill: "url(#paint12_linear_620_3722)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9151 139.629C86.9151 139.629 87.2253 139.603 87.7662 139.558L89.7958 138.416C90.1816 138.182 90.6589 138.183 91.0433 138.422L92.8993 139.546C93.2188 139.511 93.4707 139.484 93.4707 139.484V140.274H93.4667C93.4508 140.443 93.3633 140.605 93.2042 140.702L90.5939 142.196C90.2943 142.378 89.9244 142.376 89.6261 142.192L87.1046 140.656C86.9787 140.579 86.9164 140.446 86.9151 140.313V139.629Z",
    fill: "url(#paint13_linear_620_3722)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9151 139.597C86.9151 139.597 87.2253 139.571 87.7662 139.527L89.7958 138.384C90.1816 138.15 90.6589 138.152 91.0433 138.39L92.8993 139.514C93.2188 139.48 93.4707 139.452 93.4707 139.452V140.242H93.4667C93.4508 140.411 93.3633 140.573 93.2042 140.67L90.5939 142.164C90.2943 142.346 89.9244 142.344 89.6261 142.16L87.1046 140.625C86.9787 140.547 86.9164 140.414 86.9151 140.281V139.597Z",
    fill: "url(#paint14_linear_620_3722)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1086 139.226L89.7958 137.685C90.1816 137.451 90.6589 137.452 91.0433 137.691L93.2082 139.006C93.5595 139.223 93.5582 139.757 93.2042 139.971L90.5939 141.465C90.2943 141.647 89.9244 141.645 89.6261 141.461L87.1046 139.925C86.8501 139.768 86.8514 139.381 87.1073 139.226H87.1086Z",
    fill: "url(#paint15_linear_620_3722)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5762 142.843C81.5762 142.843 81.8864 142.817 82.4273 142.772L84.457 141.63C84.8427 141.396 85.32 141.397 85.7045 141.635L87.5605 142.76C87.88 142.725 88.1318 142.697 88.1318 142.697V143.488H88.1279C88.112 143.657 88.0245 143.819 87.8654 143.916L85.255 145.41C84.9554 145.591 84.5856 145.59 84.2873 145.406L81.7658 143.87C81.6398 143.793 81.5775 143.66 81.5762 143.527V142.843Z",
    fill: "url(#paint16_linear_620_3722)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5762 142.813C81.5762 142.813 81.8864 142.786 82.4273 142.742L84.457 141.6C84.8427 141.366 85.32 141.367 85.7045 141.605L87.5605 142.729C87.88 142.695 88.1318 142.667 88.1318 142.667V143.458H88.1279C88.112 143.627 88.0245 143.789 87.8654 143.886L85.255 145.38C84.9554 145.561 84.5856 145.56 84.2873 145.376L81.7658 143.84C81.6398 143.762 81.5775 143.63 81.5762 143.497V142.813Z",
    fill: "url(#paint17_linear_620_3722)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7683 142.44L84.4555 140.899C84.8413 140.665 85.3185 140.666 85.703 140.904L87.8679 142.22C88.2192 142.437 88.2179 142.97 87.8639 143.185L85.2536 144.679C84.954 144.86 84.5841 144.859 84.2858 144.675L81.7643 143.139C81.5098 142.981 81.5111 142.595 81.7669 142.44H81.7683Z",
    fill: "url(#paint18_linear_620_3722)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2363 146.058C76.2363 146.058 76.5466 146.032 77.0874 145.988L79.1171 144.845C79.5029 144.611 79.9801 144.613 80.3646 144.851L82.2206 145.975C82.5401 145.94 82.792 145.913 82.792 145.913V146.703H82.788C82.7721 146.872 82.6846 147.034 82.5255 147.131L79.9152 148.625C79.6156 148.807 79.2457 148.805 78.9474 148.621L76.4259 147.086C76.3 147.008 76.2377 146.875 76.2363 146.742V146.058Z",
    fill: "url(#paint19_linear_620_3722)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2363 146.028C76.2363 146.028 76.5466 146.002 77.0874 145.957L79.1171 144.815C79.5029 144.581 79.9801 144.582 80.3646 144.82L82.2206 145.945C82.5401 145.91 82.792 145.883 82.792 145.883V146.673H82.788C82.7721 146.842 82.6846 147.004 82.5255 147.101L79.9152 148.595C79.6156 148.776 79.2457 148.775 78.9474 148.591L76.4259 147.055C76.3 146.978 76.2377 146.845 76.2363 146.712V146.028Z",
    fill: "url(#paint20_linear_620_3722)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4299 145.655L79.1171 144.114C79.5029 143.88 79.9802 143.882 80.3646 144.12L82.5295 145.435C82.8808 145.653 82.8795 146.186 82.5255 146.4L79.9152 147.894C79.6156 148.076 79.2457 148.074 78.9474 147.89L76.4259 146.355C76.1714 146.197 76.1727 145.81 76.4286 145.655H76.4299Z",
    fill: "url(#paint21_linear_620_3722)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.898 149.273C70.898 149.273 71.2082 149.247 71.7491 149.202L73.7787 148.06C74.1645 147.826 74.6418 147.827 75.0262 148.066L76.8822 149.19C77.2017 149.155 77.4536 149.128 77.4536 149.128V149.918H77.4496C77.4337 150.087 77.3462 150.249 77.1871 150.346L74.5768 151.84C74.2772 152.022 73.9073 152.02 73.609 151.836L71.0875 150.3C70.9616 150.223 70.8993 150.09 70.898 149.957V149.273Z",
    fill: "url(#paint22_linear_620_3722)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.898 149.243C70.898 149.243 71.2082 149.216 71.7491 149.172L73.7787 148.03C74.1645 147.796 74.6418 147.797 75.0262 148.035L76.8822 149.16C77.2017 149.125 77.4536 149.097 77.4536 149.097V149.888H77.4496C77.4337 150.057 77.3462 150.219 77.1871 150.316L74.5768 151.81C74.2772 151.991 73.9073 151.99 73.609 151.806L71.0875 150.27C70.9616 150.193 70.8993 150.06 70.898 149.927V149.243Z",
    fill: "url(#paint23_linear_620_3722)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0901 148.87L73.7773 147.329C74.1631 147.095 74.6403 147.096 75.0248 147.335L77.1897 148.65C77.541 148.867 77.5396 149.401 77.1857 149.615L74.5753 151.109C74.2757 151.291 73.9059 151.289 73.6076 151.105L71.0861 149.569C70.8315 149.412 70.8329 149.025 71.0887 148.87H71.0901Z",
    fill: "url(#paint24_linear_620_3722)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5576 152.488C65.5576 152.488 65.8678 152.462 66.4087 152.418L68.4384 151.275C68.8242 151.041 69.3014 151.043 69.6859 151.281L71.5419 152.405C71.8614 152.371 72.1133 152.343 72.1133 152.343V153.134H72.1093C72.0934 153.303 72.0059 153.465 71.8468 153.561L69.2365 155.056C68.9369 155.237 68.567 155.236 68.2687 155.051L65.7472 153.516C65.6213 153.438 65.559 153.305 65.5576 153.172V152.488Z",
    fill: "url(#paint25_linear_620_3722)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5576 152.458C65.5576 152.458 65.8678 152.432 66.4087 152.387L68.4384 151.245C68.8242 151.011 69.3014 151.012 69.6859 151.251L71.5419 152.375C71.8614 152.34 72.1133 152.313 72.1133 152.313V153.103H72.1093C72.0934 153.272 72.0059 153.434 71.8468 153.531L69.2365 155.025C68.9369 155.207 68.567 155.205 68.2687 155.021L65.7472 153.485C65.6213 153.408 65.559 153.275 65.5576 153.142V152.458Z",
    fill: "url(#paint26_linear_620_3722)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7512 152.086L68.4384 150.544C68.8242 150.31 69.3014 150.312 69.6859 150.55L71.8508 151.865C72.2021 152.083 72.2008 152.616 71.8468 152.831L69.2365 154.325C68.9369 154.506 68.567 154.505 68.2687 154.32L65.7472 152.785C65.4927 152.627 65.494 152.241 65.7499 152.086H65.7512Z",
    fill: "url(#paint27_linear_620_3722)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2193 155.704C60.2193 155.704 60.5295 155.677 61.0704 155.633L63.1 154.491C63.4858 154.257 63.9631 154.258 64.3475 154.496L66.2035 155.621C66.523 155.586 66.7749 155.558 66.7749 155.558V156.349H66.7709C66.755 156.518 66.6675 156.68 66.5084 156.777L63.8981 158.271C63.5985 158.452 63.2286 158.451 62.9303 158.267L60.4088 156.731C60.2829 156.654 60.2206 156.521 60.2193 156.388V155.704Z",
    fill: "url(#paint28_linear_620_3722)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2193 155.673C60.2193 155.673 60.5295 155.647 61.0704 155.603L63.1 154.46C63.4858 154.226 63.9631 154.228 64.3475 154.466L66.2035 155.59C66.523 155.556 66.7749 155.528 66.7749 155.528V156.319H66.7709C66.755 156.488 66.6675 156.65 66.5084 156.747L63.8981 158.241C63.5985 158.422 63.2286 158.421 62.9303 158.236L60.4088 156.701C60.2829 156.623 60.2206 156.49 60.2193 156.357V155.673Z",
    fill: "url(#paint29_linear_620_3722)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4128 155.301L63.1 153.76C63.4858 153.526 63.9631 153.527 64.3475 153.765L66.5124 155.081C66.8637 155.298 66.8624 155.831 66.5084 156.046L63.8981 157.54C63.5985 157.721 63.2286 157.72 62.9303 157.536L60.4088 156C60.1543 155.842 60.1556 155.456 60.4115 155.301H60.4128Z",
    fill: "url(#paint30_linear_620_3722)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8794 158.919C54.8794 158.919 55.1896 158.893 55.7305 158.848L57.7602 157.706C58.146 157.472 58.6232 157.473 59.0077 157.712L60.8637 158.836C61.1832 158.801 61.4351 158.774 61.4351 158.774V159.564H61.4311C61.4152 159.733 61.3277 159.895 61.1686 159.992L58.5583 161.486C58.2587 161.668 57.8888 161.666 57.5905 161.482L55.069 159.946C54.9431 159.869 54.8807 159.736 54.8794 159.603V158.919Z",
    fill: "url(#paint31_linear_620_3722)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8794 158.889C54.8794 158.889 55.1896 158.862 55.7305 158.818L57.7602 157.676C58.146 157.442 58.6232 157.443 59.0077 157.681L60.8637 158.806C61.1832 158.771 61.4351 158.743 61.4351 158.743V159.534H61.4311C61.4152 159.703 61.3277 159.865 61.1686 159.962L58.5583 161.456C58.2587 161.637 57.8888 161.636 57.5905 161.452L55.069 159.916C54.9431 159.839 54.8807 159.706 54.8794 159.573V158.889Z",
    fill: "url(#paint32_linear_620_3722)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.073 158.516L57.7602 156.975C58.146 156.741 58.6232 156.742 59.0077 156.981L61.1726 158.296C61.5239 158.513 61.5225 159.047 61.1686 159.261L58.5583 160.755C58.2587 160.937 57.8888 160.935 57.5905 160.751L55.069 159.215C54.8145 159.058 54.8158 158.671 55.0716 158.516H55.073Z",
    fill: "url(#paint33_linear_620_3722)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5405 162.134C49.5405 162.134 49.8508 162.108 50.3916 162.063L52.4213 160.921C52.8071 160.687 53.2843 160.688 53.6688 160.926L55.5248 162.051C55.8443 162.016 56.0962 161.988 56.0962 161.988V162.779H56.0922C56.0763 162.948 55.9888 163.11 55.8297 163.207L53.2194 164.701C52.9198 164.882 52.5499 164.881 52.2516 164.697L49.7301 163.161C49.6042 163.084 49.5419 162.951 49.5405 162.818V162.134Z",
    fill: "url(#paint34_linear_620_3722)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5405 162.104C49.5405 162.104 49.8508 162.077 50.3916 162.033L52.4213 160.891C52.8071 160.657 53.2843 160.658 53.6688 160.896L55.5248 162.021C55.8443 161.986 56.0962 161.958 56.0962 161.958V162.749H56.0922C56.0763 162.918 55.9888 163.08 55.8297 163.177L53.2194 164.671C52.9198 164.852 52.5499 164.851 52.2516 164.667L49.7301 163.131C49.6042 163.053 49.5419 162.921 49.5405 162.788V162.104Z",
    fill: "url(#paint35_linear_620_3722)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7341 161.731L52.4213 160.19C52.8071 159.956 53.2844 159.957 53.6688 160.195L55.8337 161.511C56.185 161.728 56.1837 162.261 55.8297 162.476L53.2194 163.97C52.9198 164.151 52.5499 164.15 52.2516 163.966L49.7301 162.43C49.4756 162.272 49.4769 161.886 49.7328 161.731H49.7341Z",
    fill: "url(#paint36_linear_620_3722)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2022 165.349C44.2022 165.349 44.5124 165.323 45.0533 165.279L47.0829 164.136C47.4687 163.902 47.946 163.904 48.3304 164.142L50.1864 165.266C50.5059 165.231 50.7578 165.204 50.7578 165.204V165.994H50.7538C50.7379 166.163 50.6504 166.325 50.4913 166.422L47.881 167.916C47.5814 168.098 47.2115 168.096 46.9132 167.912L44.3917 166.377C44.2658 166.299 44.2035 166.166 44.2022 166.033V165.349Z",
    fill: "url(#paint37_linear_620_3722)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2022 165.317C44.2022 165.317 44.5124 165.291 45.0533 165.247L47.0829 164.104C47.4687 163.87 47.946 163.872 48.3304 164.11L50.1864 165.234C50.5059 165.2 50.7578 165.172 50.7578 165.172V165.963H50.7538C50.7379 166.132 50.6504 166.294 50.4913 166.391L47.881 167.885C47.5814 168.066 47.2115 168.065 46.9132 167.88L44.3917 166.345C44.2658 166.267 44.2035 166.134 44.2022 166.001V165.317Z",
    fill: "url(#paint38_linear_620_3722)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3943 164.946L47.0815 163.405C47.4673 163.171 47.9445 163.173 48.329 163.411L50.4939 164.726C50.8452 164.944 50.8438 165.477 50.4899 165.691L47.8795 167.185C47.5799 167.367 47.2101 167.365 46.9118 167.181L44.3903 165.646C44.1357 165.488 44.1371 165.101 44.3929 164.946H44.3943Z",
    fill: "url(#paint39_linear_620_3722)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8618 168.565C38.8618 168.565 39.172 168.538 39.7129 168.494L41.7426 167.352C42.1284 167.118 42.6056 167.119 42.9901 167.357L44.8461 168.481C45.1656 168.447 45.4175 168.419 45.4175 168.419V169.21H45.4135C45.3976 169.379 45.3101 169.541 45.151 169.638L42.5407 171.132C42.2411 171.313 41.8712 171.312 41.5729 171.128L39.0514 169.592C38.9255 169.514 38.8632 169.381 38.8618 169.249V168.565Z",
    fill: "url(#paint40_linear_620_3722)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8618 168.533C38.8618 168.533 39.172 168.506 39.7129 168.462L41.7426 167.32C42.1284 167.086 42.6056 167.087 42.9901 167.325L44.8461 168.45C45.1656 168.415 45.4175 168.387 45.4175 168.387V169.178H45.4135C45.3976 169.347 45.3101 169.509 45.151 169.606L42.5407 171.1C42.2411 171.281 41.8712 171.28 41.5729 171.096L39.0514 169.56C38.9255 169.483 38.8632 169.35 38.8618 169.217V168.533Z",
    fill: "url(#paint41_linear_620_3722)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0554 168.162L41.7426 166.621C42.1284 166.387 42.6056 166.388 42.9901 166.626L45.155 167.942C45.5063 168.159 45.505 168.692 45.151 168.907L42.5407 170.401C42.2411 170.582 41.8712 170.581 41.5729 170.397L39.0514 168.861C38.7969 168.703 38.7982 168.317 39.0541 168.162H39.0554Z",
    fill: "url(#paint42_linear_620_3722)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5235 171.778C33.5235 171.778 33.8337 171.752 34.3746 171.708L36.4042 170.565C36.79 170.331 37.2673 170.333 37.6517 170.571L39.5077 171.695C39.8272 171.661 40.0791 171.633 40.0791 171.633V172.424H40.0751C40.0592 172.593 39.9717 172.755 39.8126 172.851L37.2023 174.346C36.9027 174.527 36.5328 174.526 36.2345 174.341L33.713 172.806C33.5871 172.728 33.5248 172.595 33.5235 172.462V171.778Z",
    fill: "url(#paint43_linear_620_3722)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5235 171.748C33.5235 171.748 33.8337 171.722 34.3746 171.677L36.4042 170.535C36.79 170.301 37.2673 170.303 37.6517 170.541L39.5077 171.665C39.8272 171.63 40.0791 171.603 40.0791 171.603V172.393H40.0751C40.0592 172.562 39.9717 172.724 39.8126 172.821L37.2023 174.315C36.9027 174.497 36.5328 174.495 36.2345 174.311L33.713 172.776C33.5871 172.698 33.5248 172.565 33.5235 172.432V171.748Z",
    fill: "url(#paint44_linear_620_3722)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7155 171.376L36.4028 169.834C36.7885 169.6 37.2658 169.602 37.6503 169.84L39.8151 171.155C40.1665 171.373 40.1651 171.906 39.8112 172.121L37.2008 173.615C36.9012 173.796 36.5314 173.795 36.2331 173.61L33.7116 172.075C33.457 171.917 33.4584 171.531 33.7142 171.376H33.7155Z",
    fill: "url(#paint45_linear_620_3722)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M108.88 133.66C108.88 133.66 109.191 133.633 109.732 133.589L111.761 132.447C112.147 132.213 112.624 132.214 113.009 132.452L114.865 133.577C115.184 133.542 115.436 133.514 115.436 133.514V134.305H115.432C115.416 134.474 115.329 134.636 115.17 134.733L112.559 136.227C112.26 136.408 111.89 136.407 111.591 136.223L109.07 134.687C108.944 134.61 108.882 134.477 108.88 134.344V133.66Z",
    fill: "url(#paint46_linear_620_3722)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.88 133.629C108.88 133.629 109.191 133.603 109.732 133.559L111.761 132.416C112.147 132.182 112.624 132.184 113.009 132.422L114.865 133.546C115.184 133.512 115.436 133.484 115.436 133.484V134.275H115.432C115.416 134.444 115.329 134.606 115.17 134.703L112.559 136.197C112.26 136.378 111.89 136.377 111.591 136.192L109.07 134.657C108.944 134.579 108.882 134.446 108.88 134.313V133.629Z",
    fill: "url(#paint47_linear_620_3722)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M109.074 133.257L111.761 131.716C112.147 131.482 112.624 131.483 113.009 131.721L115.174 133.037C115.525 133.254 115.524 133.787 115.17 134.002L112.559 135.496C112.26 135.677 111.89 135.676 111.591 135.492L109.07 133.956C108.815 133.798 108.817 133.412 109.073 133.257H109.074Z",
    fill: "url(#paint48_linear_620_3722)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.542 136.875C103.542 136.875 103.852 136.849 104.393 136.804L106.422 135.662C106.808 135.428 107.285 135.429 107.67 135.668L109.526 136.792C109.845 136.757 110.097 136.73 110.097 136.73V137.52H110.093C110.077 137.689 109.99 137.851 109.831 137.948L107.22 139.442C106.921 139.624 106.551 139.622 106.253 139.438L103.731 137.902C103.605 137.825 103.543 137.692 103.542 137.559V136.875Z",
    fill: "url(#paint49_linear_620_3722)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M103.542 136.845C103.542 136.845 103.852 136.818 104.393 136.774L106.422 135.632C106.808 135.398 107.285 135.399 107.67 135.637L109.526 136.762C109.845 136.727 110.097 136.699 110.097 136.699V137.49H110.093C110.077 137.659 109.99 137.821 109.831 137.918L107.22 139.412C106.921 139.593 106.551 139.592 106.253 139.408L103.731 137.872C103.605 137.795 103.543 137.662 103.542 137.529V136.845Z",
    fill: "url(#paint50_linear_620_3722)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M103.734 136.472L106.421 134.931C106.807 134.697 107.284 134.699 107.668 134.937L109.833 136.252C110.185 136.47 110.183 137.003 109.829 137.217L107.219 138.711C106.919 138.893 106.549 138.891 106.251 138.707L103.73 137.172C103.475 137.014 103.476 136.627 103.732 136.472H103.734Z",
    fill: "url(#paint51_linear_620_3722)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2017 140.09C98.2017 140.09 98.5119 140.064 99.0528 140.019L101.082 138.877C101.468 138.643 101.945 138.644 102.33 138.882L104.186 140.007C104.505 139.972 104.757 139.945 104.757 139.945V140.735H104.753C104.737 140.904 104.65 141.066 104.491 141.163L101.881 142.657C101.581 142.838 101.211 142.837 100.913 142.653L98.3913 141.117C98.2653 141.04 98.203 140.907 98.2017 140.774V140.09Z",
    fill: "url(#paint52_linear_620_3722)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2017 140.06C98.2017 140.06 98.5119 140.033 99.0528 139.989L101.082 138.847C101.468 138.613 101.945 138.614 102.33 138.852L104.186 139.977C104.505 139.942 104.757 139.914 104.757 139.914V140.705H104.753C104.737 140.874 104.65 141.036 104.491 141.133L101.881 142.627C101.581 142.808 101.211 142.807 100.913 142.623L98.3913 141.087C98.2653 141.01 98.203 140.877 98.2017 140.744V140.06Z",
    fill: "url(#paint53_linear_620_3722)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3952 139.687L101.082 138.146C101.468 137.912 101.945 137.913 102.33 138.152L104.495 139.467C104.846 139.684 104.845 140.217 104.491 140.432L101.881 141.926C101.581 142.108 101.211 142.106 100.913 141.922L98.3912 140.386C98.1367 140.229 98.138 139.842 98.3939 139.687H98.3952Z",
    fill: "url(#paint54_linear_620_3722)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8633 143.305C92.8633 143.305 93.1735 143.279 93.7144 143.235L95.7441 142.092C96.1299 141.858 96.6071 141.86 96.9916 142.098L98.8476 143.222C99.1671 143.188 99.4189 143.16 99.4189 143.16V143.95H99.415C99.3991 144.119 99.3116 144.281 99.1525 144.378L96.5422 145.872C96.2425 146.054 95.8727 146.052 95.5744 145.868L93.0529 144.333C92.9269 144.255 92.8646 144.122 92.8633 143.989V143.305Z",
    fill: "url(#paint55_linear_620_3722)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8633 143.273C92.8633 143.273 93.1735 143.247 93.7144 143.203L95.7441 142.061C96.1299 141.827 96.6071 141.828 96.9916 142.066L98.8476 143.19C99.1671 143.156 99.4189 143.128 99.4189 143.128V143.919H99.415C99.3991 144.088 99.3116 144.25 99.1525 144.347L96.5422 145.841C96.2425 146.022 95.8727 146.021 95.5744 145.837L93.0529 144.301C92.9269 144.223 92.8646 144.09 92.8633 143.958V143.273Z",
    fill: "url(#paint56_linear_620_3722)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0554 142.902L95.7426 141.361C96.1284 141.127 96.6056 141.129 96.9901 141.367L99.155 142.682C99.5063 142.9 99.505 143.433 99.151 143.647L96.5407 145.141C96.2411 145.323 95.8712 145.321 95.5729 145.137L93.0514 143.602C92.7969 143.444 92.7982 143.058 93.0541 142.902H93.0554Z",
    fill: "url(#paint57_linear_620_3722)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M87.523 146.521C87.523 146.521 87.8332 146.494 88.3741 146.45L90.4037 145.308C90.7895 145.074 91.2668 145.075 91.6512 145.313L93.5072 146.437C93.8267 146.403 94.0786 146.375 94.0786 146.375V147.166H94.0746C94.0587 147.335 93.9712 147.497 93.8122 147.594L91.2018 149.088C90.9022 149.269 90.5323 149.268 90.234 149.084L87.7126 147.548C87.5866 147.47 87.5243 147.338 87.523 147.205V146.521Z",
    fill: "url(#paint58_linear_620_3722)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M87.523 146.489C87.523 146.489 87.8332 146.463 88.3741 146.418L90.4037 145.276C90.7895 145.042 91.2668 145.043 91.6512 145.281L93.5072 146.406C93.8267 146.371 94.0786 146.343 94.0786 146.343V147.134H94.0746C94.0587 147.303 93.9712 147.465 93.8122 147.562L91.2018 149.056C90.9022 149.237 90.5323 149.236 90.234 149.052L87.7126 147.516C87.5866 147.439 87.5243 147.306 87.523 147.173V146.489Z",
    fill: "url(#paint59_linear_620_3722)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7165 146.118L90.4037 144.577C90.7895 144.343 91.2668 144.344 91.6512 144.582L93.8161 145.898C94.1674 146.115 94.1661 146.648 93.8121 146.863L91.2018 148.357C90.9022 148.538 90.5323 148.537 90.234 148.353L87.7125 146.817C87.458 146.659 87.4593 146.273 87.7152 146.118H87.7165Z",
    fill: "url(#paint60_linear_620_3722)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1846 149.736C82.1846 149.736 82.4948 149.71 83.0357 149.665L85.0653 148.523C85.4511 148.289 85.9284 148.29 86.3128 148.528L88.1688 149.653C88.4883 149.618 88.7402 149.591 88.7402 149.591V150.381H88.7363C88.7203 150.55 88.6329 150.712 88.4738 150.809L85.8634 152.303C85.5638 152.484 85.194 152.483 84.8957 152.299L82.3742 150.763C82.2482 150.686 82.1859 150.553 82.1846 150.42V149.736Z",
    fill: "url(#paint61_linear_620_3722)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1846 149.704C82.1846 149.704 82.4948 149.678 83.0357 149.634L85.0653 148.491C85.4511 148.257 85.9284 148.259 86.3128 148.497L88.1688 149.621C88.4883 149.586 88.7402 149.559 88.7402 149.559V150.349H88.7363C88.7203 150.518 88.6329 150.68 88.4738 150.777L85.8634 152.271C85.5638 152.453 85.194 152.451 84.8957 152.267L82.3742 150.732C82.2482 150.654 82.1859 150.521 82.1846 150.388V149.704Z",
    fill: "url(#paint62_linear_620_3722)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3767 149.333L85.0639 147.792C85.4497 147.558 85.9269 147.559 86.3114 147.798L88.4763 149.113C88.8276 149.33 88.8263 149.863 88.4723 150.078L85.862 151.572C85.5623 151.754 85.1925 151.752 84.8942 151.568L82.3727 150.032C82.1182 149.875 82.1195 149.488 82.3753 149.333H82.3767Z",
    fill: "url(#paint63_linear_620_3722)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8447 152.949C76.8447 152.949 77.155 152.923 77.6958 152.879L79.7255 151.736C80.1113 151.502 80.5885 151.504 80.973 151.742L82.829 152.866C83.1485 152.832 83.4004 152.804 83.4004 152.804V153.595H83.3964C83.3805 153.763 83.293 153.925 83.1339 154.022L80.5236 155.516C80.224 155.698 79.8541 155.696 79.5558 155.512L77.0343 153.977C76.9084 153.899 76.8461 153.766 76.8447 153.633V152.949Z",
    fill: "url(#paint64_linear_620_3722)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8447 152.919C76.8447 152.919 77.155 152.893 77.6958 152.848L79.7255 151.706C80.1113 151.472 80.5885 151.473 80.973 151.712L82.829 152.836C83.1485 152.801 83.4004 152.774 83.4004 152.774V153.564H83.3964C83.3805 153.733 83.293 153.895 83.1339 153.992L80.5236 155.486C80.224 155.668 79.8541 155.666 79.5558 155.482L77.0343 153.946C76.9084 153.869 76.8461 153.736 76.8447 153.603V152.919Z",
    fill: "url(#paint65_linear_620_3722)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0383 152.546L79.7255 151.005C80.1113 150.771 80.5885 150.773 80.973 151.011L83.1379 152.326C83.4892 152.544 83.4879 153.077 83.1339 153.291L80.5236 154.785C80.224 154.967 79.8541 154.965 79.5558 154.781L77.0343 153.246C76.7798 153.088 76.7811 152.702 77.037 152.546H77.0383Z",
    fill: "url(#paint66_linear_620_3722)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5059 156.165C71.5059 156.165 71.8161 156.138 72.357 156.094L74.3867 154.952C74.7724 154.718 75.2497 154.719 75.6342 154.957L77.4902 156.082C77.8096 156.047 78.0615 156.019 78.0615 156.019V156.81H78.0575C78.0416 156.979 77.9541 157.141 77.7951 157.238L75.1847 158.732C74.8851 158.913 74.5152 158.912 74.217 158.728L71.6955 157.192C71.5695 157.114 71.5072 156.982 71.5059 156.849V156.165Z",
    fill: "url(#paint67_linear_620_3722)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5059 156.134C71.5059 156.134 71.8161 156.108 72.357 156.064L74.3867 154.921C74.7724 154.687 75.2497 154.689 75.6342 154.927L77.4902 156.051C77.8096 156.017 78.0615 155.989 78.0615 155.989V156.78H78.0575C78.0416 156.949 77.9541 157.111 77.7951 157.207L75.1847 158.702C74.8851 158.883 74.5152 158.882 74.217 158.697L71.6955 157.162C71.5695 157.084 71.5072 156.951 71.5059 156.818V156.134Z",
    fill: "url(#paint68_linear_620_3722)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M71.698 155.762L74.3852 154.221C74.771 153.987 75.2482 153.988 75.6327 154.226L77.7976 155.542C78.1489 155.759 78.1475 156.292 77.7936 156.507L75.1833 158.001C74.8837 158.182 74.5138 158.181 74.2155 157.997L71.694 156.461C71.4394 156.303 71.4408 155.917 71.6966 155.762H71.698Z",
    fill: "url(#paint69_linear_620_3722)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M66.166 159.38C66.166 159.38 66.4763 159.354 67.0172 159.309L69.0468 158.167C69.4326 157.933 69.9099 157.934 70.2943 158.173L72.1503 159.297C72.4698 159.262 72.7217 159.235 72.7217 159.235V160.025H72.7177C72.7018 160.194 72.6143 160.356 72.4552 160.453L69.8449 161.947C69.5453 162.129 69.1754 162.127 68.8771 161.943L66.3556 160.407C66.2297 160.33 66.1674 160.197 66.166 160.064V159.38Z",
    fill: "url(#paint70_linear_620_3722)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M66.166 159.35C66.166 159.35 66.4763 159.323 67.0172 159.279L69.0468 158.137C69.4326 157.903 69.9099 157.904 70.2943 158.142L72.1503 159.267C72.4698 159.232 72.7217 159.204 72.7217 159.204V159.995H72.7177C72.7018 160.164 72.6143 160.326 72.4552 160.423L69.8449 161.917C69.5453 162.098 69.1754 162.097 68.8771 161.913L66.3556 160.377C66.2297 160.3 66.1674 160.167 66.166 160.034V159.35Z",
    fill: "url(#paint71_linear_620_3722)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3596 158.977L69.0468 157.436C69.4326 157.202 69.9098 157.203 70.2943 157.442L72.4592 158.757C72.8105 158.974 72.8092 159.507 72.4552 159.722L69.8449 161.216C69.5453 161.398 69.1754 161.396 68.8771 161.212L66.3556 159.676C66.1011 159.519 66.1024 159.132 66.3583 158.977H66.3596Z",
    fill: "url(#paint72_linear_620_3722)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8272 162.595C60.8272 162.595 61.1374 162.569 61.6783 162.525L63.7079 161.382C64.0937 161.148 64.571 161.15 64.9554 161.388L66.8114 162.512C67.1309 162.478 67.3828 162.45 67.3828 162.45V163.241H67.3788C67.3629 163.409 67.2754 163.571 67.1164 163.668L64.506 165.162C64.2064 165.344 63.8365 165.342 63.5382 165.158L61.0168 163.623C60.8908 163.545 60.8285 163.412 60.8272 163.279V162.595Z",
    fill: "url(#paint73_linear_620_3722)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8272 162.565C60.8272 162.565 61.1374 162.539 61.6783 162.494L63.7079 161.352C64.0937 161.118 64.571 161.119 64.9554 161.358L66.8114 162.482C67.1309 162.447 67.3828 162.42 67.3828 162.42V163.21H67.3788C67.3629 163.379 67.2754 163.541 67.1164 163.638L64.506 165.132C64.2064 165.314 63.8365 165.312 63.5382 165.128L61.0168 163.592C60.8908 163.515 60.8285 163.382 60.8272 163.249V162.565Z",
    fill: "url(#paint74_linear_620_3722)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0192 162.192L63.7065 160.651C64.0922 160.417 64.5695 160.419 64.954 160.657L67.1188 161.972C67.4702 162.19 67.4688 162.723 67.1149 162.937L64.5045 164.431C64.2049 164.613 63.8351 164.611 63.5368 164.427L61.0153 162.892C60.7607 162.734 60.7621 162.348 61.0179 162.192H61.0192Z",
    fill: "url(#paint75_linear_620_3722)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4873 165.81C55.4873 165.81 55.7975 165.784 56.3384 165.74L58.3681 164.597C58.7539 164.363 59.2311 164.365 59.6156 164.603L61.4716 165.727C61.7911 165.692 62.043 165.665 62.043 165.665V166.455H62.039C62.0231 166.624 61.9356 166.786 61.7765 166.883L59.1662 168.377C58.8666 168.559 58.4967 168.557 58.1984 168.373L55.6769 166.838C55.551 166.76 55.4886 166.627 55.4873 166.494V165.81Z",
    fill: "url(#paint76_linear_620_3722)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4873 165.78C55.4873 165.78 55.7975 165.754 56.3384 165.709L58.3681 164.567C58.7539 164.333 59.2311 164.334 59.6156 164.572L61.4716 165.697C61.7911 165.662 62.043 165.634 62.043 165.634V166.425H62.039C62.0231 166.594 61.9356 166.756 61.7765 166.853L59.1662 168.347C58.8666 168.528 58.4967 168.527 58.1984 168.343L55.6769 166.807C55.551 166.73 55.4886 166.597 55.4873 166.464V165.78Z",
    fill: "url(#paint77_linear_620_3722)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6809 165.407L58.3681 163.866C58.7539 163.632 59.2311 163.634 59.6156 163.872L61.7805 165.187C62.1318 165.405 62.1305 165.938 61.7765 166.152L59.1662 167.646C58.8665 167.828 58.4967 167.826 58.1984 167.642L55.6769 166.107C55.4224 165.949 55.4237 165.562 55.6795 165.407H55.6809Z",
    fill: "url(#paint78_linear_620_3722)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1484 169.025C50.1484 169.025 50.4587 168.999 50.9996 168.955L53.0292 167.812C53.415 167.578 53.8923 167.58 54.2767 167.818L56.1327 168.942C56.4522 168.908 56.7041 168.88 56.7041 168.88V169.671H56.7001C56.6842 169.84 56.5967 170.002 56.4376 170.099L53.8273 171.593C53.5277 171.774 53.1578 171.773 52.8595 171.588L50.338 170.053C50.2121 169.975 50.1498 169.842 50.1484 169.709V169.025Z",
    fill: "url(#paint79_linear_620_3722)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1484 168.995C50.1484 168.995 50.4587 168.969 50.9996 168.925L53.0292 167.782C53.415 167.548 53.8923 167.55 54.2767 167.788L56.1327 168.912C56.4522 168.877 56.7041 168.85 56.7041 168.85V169.64H56.7001C56.6842 169.809 56.5967 169.971 56.4376 170.068L53.8273 171.562C53.5277 171.744 53.1578 171.742 52.8595 171.558L50.338 170.023C50.2121 169.945 50.1498 169.812 50.1484 169.679V168.995Z",
    fill: "url(#paint80_linear_620_3722)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3405 168.623L53.0278 167.082C53.4135 166.848 53.8908 166.849 54.2752 167.087L56.4401 168.402C56.7915 168.62 56.7901 169.153 56.4362 169.368L53.8258 170.862C53.5262 171.043 53.1564 171.042 52.8581 170.858L50.3366 169.322C50.082 169.164 50.0834 168.778 50.3392 168.623H50.3405Z",
    fill: "url(#paint81_linear_620_3722)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8086 172.241C44.8086 172.241 45.1188 172.214 45.6597 172.17L47.6894 171.028C48.0752 170.794 48.5524 170.795 48.9369 171.033L50.7929 172.158C51.1124 172.123 51.3643 172.095 51.3643 172.095V172.886H51.3603C51.3444 173.055 51.2569 173.217 51.0978 173.314L48.4875 174.808C48.1879 174.989 47.818 174.988 47.5197 174.804L44.9982 173.268C44.8722 173.191 44.8099 173.058 44.8086 172.925V172.241Z",
    fill: "url(#paint82_linear_620_3722)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8086 172.209C44.8086 172.209 45.1188 172.183 45.6597 172.138L47.6894 170.996C48.0752 170.762 48.5524 170.763 48.9369 171.002L50.7929 172.126C51.1124 172.091 51.3643 172.064 51.3643 172.064V172.854H51.3603C51.3444 173.023 51.2569 173.185 51.0978 173.282L48.4875 174.776C48.1879 174.958 47.818 174.956 47.5197 174.772L44.9982 173.236C44.8722 173.159 44.8099 173.026 44.8086 172.893V172.209Z",
    fill: "url(#paint83_linear_620_3722)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0022 171.838L47.6894 170.297C48.0752 170.063 48.5524 170.064 48.9369 170.302L51.1018 171.618C51.4531 171.835 51.4517 172.368 51.0978 172.583L48.4875 174.077C48.1879 174.258 47.818 174.257 47.5197 174.073L44.9982 172.537C44.7436 172.379 44.745 171.993 45.0008 171.838H45.0022Z",
    fill: "url(#paint84_linear_620_3722)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4702 175.456C39.4702 175.456 39.7804 175.429 40.3213 175.385L42.351 174.243C42.7368 174.009 43.2141 174.01 43.5985 174.248L45.4545 175.373C45.774 175.338 46.0259 175.31 46.0259 175.31V176.101H46.0219C46.006 176.27 45.9185 176.432 45.7594 176.529L43.1491 178.023C42.8495 178.204 42.4796 178.203 42.1813 178.019L39.6598 176.483C39.5339 176.406 39.4716 176.273 39.4702 176.14V175.456Z",
    fill: "url(#paint85_linear_620_3722)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4702 175.424C39.4702 175.424 39.7804 175.398 40.3213 175.353L42.351 174.211C42.7368 173.977 43.2141 173.978 43.5985 174.216L45.4545 175.341C45.774 175.306 46.0259 175.279 46.0259 175.279V176.069H46.0219C46.006 176.238 45.9185 176.4 45.7594 176.497L43.1491 177.991C42.8495 178.172 42.4796 178.171 42.1813 177.987L39.6598 176.451C39.5339 176.374 39.4716 176.241 39.4702 176.108V175.424Z",
    fill: "url(#paint86_linear_620_3722)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6623 175.053L42.3495 173.512C42.7353 173.278 43.2126 173.279 43.597 173.517L45.7619 174.833C46.1132 175.05 46.1119 175.583 45.7579 175.798L43.1476 177.292C42.848 177.473 42.4781 177.472 42.1798 177.288L39.6583 175.752C39.4038 175.594 39.4051 175.208 39.661 175.053H39.6623Z",
    fill: "url(#paint87_linear_620_3722)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M114.828 137.336C114.828 137.336 115.138 137.31 115.679 137.265L117.708 136.123C118.094 135.889 118.571 135.89 118.956 136.129L120.812 137.253C121.131 137.218 121.383 137.191 121.383 137.191V137.981H121.379C121.363 138.15 121.276 138.312 121.117 138.409L118.507 139.903C118.207 140.085 117.837 140.083 117.539 139.899L115.017 138.363C114.891 138.286 114.829 138.153 114.828 138.02V137.336Z",
    fill: "url(#paint88_linear_620_3722)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M114.828 137.306C114.828 137.306 115.138 137.279 115.679 137.235L117.708 136.093C118.094 135.859 118.571 135.86 118.956 136.098L120.812 137.223C121.131 137.188 121.383 137.16 121.383 137.16V137.951H121.379C121.363 138.12 121.276 138.282 121.117 138.379L118.507 139.873C118.207 140.054 117.837 140.053 117.539 139.869L115.017 138.333C114.891 138.256 114.829 138.123 114.828 137.99V137.306Z",
    fill: "url(#paint89_linear_620_3722)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M115.021 136.933L117.708 135.392C118.094 135.158 118.571 135.159 118.956 135.398L121.121 136.713C121.472 136.93 121.471 137.464 121.117 137.678L118.507 139.172C118.207 139.354 117.837 139.352 117.539 139.168L115.017 137.632C114.763 137.475 114.764 137.088 115.02 136.933H115.021Z",
    fill: "url(#paint90_linear_620_3722)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M109.489 140.551C109.489 140.551 109.799 140.525 110.34 140.481L112.37 139.338C112.755 139.104 113.233 139.106 113.617 139.344L115.473 140.468C115.793 140.434 116.044 140.406 116.044 140.406V141.197H116.04C116.025 141.366 115.937 141.528 115.778 141.624L113.168 143.118C112.868 143.3 112.498 143.298 112.2 143.114L109.678 141.579C109.552 141.501 109.49 141.368 109.489 141.235V140.551Z",
    fill: "url(#paint91_linear_620_3722)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M109.489 140.521C109.489 140.521 109.799 140.495 110.34 140.45L112.37 139.308C112.755 139.074 113.233 139.075 113.617 139.314L115.473 140.438C115.793 140.403 116.044 140.376 116.044 140.376V141.166H116.04C116.025 141.335 115.937 141.497 115.778 141.594L113.168 143.088C112.868 143.27 112.498 143.268 112.2 143.084L109.678 141.548C109.552 141.471 109.49 141.338 109.489 141.205V140.521Z",
    fill: "url(#paint92_linear_620_3722)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M109.681 140.149L112.368 138.607C112.754 138.373 113.231 138.375 113.616 138.613L115.78 139.928C116.132 140.146 116.13 140.679 115.776 140.893L113.166 142.388C112.867 142.569 112.497 142.568 112.198 142.383L109.677 140.848C109.422 140.69 109.424 140.304 109.68 140.149H109.681Z",
    fill: "url(#paint93_linear_620_3722)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M104.149 143.766C104.149 143.766 104.459 143.74 105 143.696L107.03 142.553C107.416 142.319 107.893 142.321 108.277 142.559L110.133 143.683C110.453 143.648 110.705 143.621 110.705 143.621V144.411H110.701C110.685 144.58 110.597 144.742 110.438 144.839L107.828 146.333C107.528 146.515 107.158 146.513 106.86 146.329L104.339 144.794C104.213 144.716 104.15 144.583 104.149 144.45V143.766Z",
    fill: "url(#paint94_linear_620_3722)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M104.149 143.736C104.149 143.736 104.459 143.71 105 143.665L107.03 142.523C107.416 142.289 107.893 142.29 108.277 142.528L110.133 143.653C110.453 143.618 110.705 143.591 110.705 143.591V144.381H110.701C110.685 144.55 110.597 144.712 110.438 144.809L107.828 146.303C107.528 146.484 107.158 146.483 106.86 146.299L104.339 144.763C104.213 144.686 104.15 144.553 104.149 144.42V143.736Z",
    fill: "url(#paint95_linear_620_3722)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M104.342 143.363L107.03 141.822C107.415 141.588 107.893 141.59 108.277 141.828L110.442 143.143C110.793 143.361 110.792 143.894 110.438 144.108L107.828 145.602C107.528 145.784 107.158 145.782 106.86 145.598L104.339 144.063C104.084 143.905 104.085 143.518 104.341 143.363H104.342Z",
    fill: "url(#paint96_linear_620_3722)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8106 146.982C98.8106 146.982 99.1208 146.955 99.6617 146.911L101.691 145.769C102.077 145.535 102.554 145.536 102.939 145.774L104.795 146.898C105.114 146.864 105.366 146.836 105.366 146.836V147.627H105.362C105.346 147.796 105.259 147.958 105.1 148.055L102.489 149.549C102.19 149.73 101.82 149.729 101.522 149.545L99.0001 148.009C98.8742 147.931 98.8119 147.798 98.8106 147.666V146.982Z",
    fill: "url(#paint97_linear_620_3722)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8106 146.951C98.8106 146.951 99.1208 146.925 99.6617 146.881L101.691 145.738C102.077 145.504 102.554 145.506 102.939 145.744L104.795 146.868C105.114 146.834 105.366 146.806 105.366 146.806V147.596H105.362C105.346 147.765 105.259 147.927 105.1 148.024L102.489 149.518C102.19 149.7 101.82 149.698 101.522 149.514L99.0001 147.979C98.8742 147.901 98.8119 147.768 98.8106 147.635V146.951Z",
    fill: "url(#paint98_linear_620_3722)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0027 146.579L101.69 145.038C102.076 144.804 102.553 144.805 102.937 145.043L105.102 146.359C105.454 146.576 105.452 147.109 105.098 147.324L102.488 148.818C102.188 148.999 101.818 148.998 101.52 148.814L98.9987 147.278C98.7441 147.12 98.7455 146.734 99.0013 146.579H99.0027Z",
    fill: "url(#paint99_linear_620_3722)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4702 150.197C93.4702 150.197 93.7805 150.171 94.3213 150.126L96.351 148.984C96.7368 148.75 97.214 148.751 97.5985 148.989L99.4545 150.114C99.774 150.079 100.026 150.051 100.026 150.051V150.842H100.022C100.006 151.011 99.9185 151.173 99.7594 151.27L97.1491 152.764C96.8495 152.945 96.4796 152.944 96.1813 152.76L93.6598 151.224C93.5339 151.147 93.4716 151.014 93.4702 150.881V150.197Z",
    fill: "url(#paint100_linear_620_3722)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4702 150.167C93.4702 150.167 93.7805 150.14 94.3213 150.096L96.351 148.954C96.7368 148.72 97.214 148.721 97.5985 148.959L99.4545 150.083C99.774 150.049 100.026 150.021 100.026 150.021V150.812H100.022C100.006 150.981 99.9185 151.143 99.7594 151.24L97.1491 152.734C96.8495 152.915 96.4796 152.914 96.1813 152.73L93.6598 151.194C93.5339 151.116 93.4716 150.984 93.4702 150.851V150.167Z",
    fill: "url(#paint101_linear_620_3722)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6638 149.794L96.351 148.253C96.7368 148.019 97.214 148.02 97.5985 148.258L99.7634 149.574C100.115 149.791 100.113 150.324 99.7594 150.539L97.1491 152.033C96.8495 152.214 96.4796 152.213 96.1813 152.029L93.6598 150.493C93.4053 150.335 93.4066 149.949 93.6625 149.794H93.6638Z",
    fill: "url(#paint102_linear_620_3722)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1318 153.412C88.1318 153.412 88.4421 153.386 88.983 153.342L91.0126 152.199C91.3984 151.965 91.8757 151.967 92.2601 152.205L94.1161 153.329C94.4356 153.294 94.6875 153.267 94.6875 153.267V154.057H94.6835C94.6676 154.226 94.5801 154.388 94.421 154.485L91.8107 155.979C91.5111 156.161 91.1412 156.159 90.8429 155.975L88.3214 154.44C88.1955 154.362 88.1332 154.229 88.1318 154.096V153.412Z",
    fill: "url(#paint103_linear_620_3722)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1318 153.38C88.1318 153.38 88.4421 153.354 88.983 153.31L91.0126 152.167C91.3984 151.933 91.8757 151.935 92.2601 152.173L94.1161 153.297C94.4356 153.263 94.6875 153.235 94.6875 153.235V154.026H94.6835C94.6676 154.195 94.5801 154.357 94.421 154.454L91.8107 155.948C91.5111 156.129 91.1412 156.128 90.8429 155.943L88.3214 154.408C88.1955 154.33 88.1332 154.197 88.1318 154.064V153.38Z",
    fill: "url(#paint104_linear_620_3722)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3239 153.009L91.0112 151.468C91.3969 151.234 91.8742 151.236 92.2586 151.474L94.4235 152.789C94.7749 153.007 94.7735 153.54 94.4196 153.754L91.8092 155.248C91.5096 155.43 91.1398 155.428 90.8415 155.244L88.32 153.709C88.0654 153.551 88.0668 153.164 88.3226 153.009H88.3239Z",
    fill: "url(#paint105_linear_620_3722)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M82.792 156.627C82.792 156.627 83.1022 156.601 83.6431 156.556L85.6728 155.414C86.0586 155.18 86.5358 155.181 86.9203 155.42L88.7763 156.544C89.0958 156.509 89.3477 156.482 89.3477 156.482V157.272H89.3437C89.3278 157.441 89.2403 157.603 89.0812 157.7L86.4709 159.194C86.1713 159.376 85.8014 159.374 85.5031 159.19L82.9816 157.654C82.8556 157.577 82.7933 157.444 82.792 157.311V156.627Z",
    fill: "url(#paint106_linear_620_3722)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M82.792 156.595C82.792 156.595 83.1022 156.569 83.6431 156.525L85.6728 155.382C86.0586 155.148 86.5358 155.15 86.9203 155.388L88.7763 156.512C89.0958 156.478 89.3477 156.45 89.3477 156.45V157.241H89.3437C89.3278 157.409 89.2403 157.571 89.0812 157.668L86.4709 159.162C86.1713 159.344 85.8014 159.342 85.5031 159.158L82.9816 157.623C82.8556 157.545 82.7933 157.412 82.792 157.279V156.595Z",
    fill: "url(#paint107_linear_620_3722)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9856 156.224L85.6728 154.683C86.0586 154.449 86.5358 154.45 86.9203 154.689L89.0852 156.004C89.4365 156.221 89.4351 156.755 89.0812 156.969L86.4709 158.463C86.1713 158.645 85.8014 158.643 85.5031 158.459L82.9816 156.923C82.727 156.766 82.7284 156.379 82.9842 156.224H82.9856Z",
    fill: "url(#paint108_linear_620_3722)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4532 159.842C77.4532 159.842 77.7634 159.816 78.3042 159.772L80.3339 158.629C80.7197 158.395 81.197 158.397 81.5814 158.635L83.4374 159.759C83.7569 159.725 84.0088 159.697 84.0088 159.697V160.488H84.0048C83.9889 160.657 83.9014 160.819 83.7423 160.915L81.132 162.41C80.8324 162.591 80.4625 162.59 80.1642 162.405L77.6427 160.87C77.5168 160.792 77.4545 160.659 77.4532 160.526V159.842Z",
    fill: "url(#paint109_linear_620_3722)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4532 159.811C77.4532 159.811 77.7634 159.784 78.3042 159.74L80.3339 158.598C80.7197 158.364 81.197 158.365 81.5814 158.603L83.4374 159.728C83.7569 159.693 84.0088 159.665 84.0088 159.665V160.456H84.0048C83.9889 160.625 83.9014 160.787 83.7423 160.884L81.132 162.378C80.8324 162.559 80.4625 162.558 80.1642 162.374L77.6427 160.838C77.5168 160.76 77.4545 160.628 77.4532 160.495V159.811Z",
    fill: "url(#paint110_linear_620_3722)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6467 159.438L80.3339 157.897C80.7197 157.663 81.197 157.664 81.5814 157.903L83.7463 159.218C84.0976 159.435 84.0963 159.968 83.7423 160.183L81.132 161.677C80.8324 161.858 80.4625 161.857 80.1642 161.673L77.6427 160.137C77.3882 159.98 77.3895 159.593 77.6454 159.438H77.6467Z",
    fill: "url(#paint111_linear_620_3722)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1148 163.056C72.1148 163.056 72.425 163.03 72.9659 162.986L74.9955 161.843C75.3813 161.609 75.8586 161.611 76.243 161.849L78.099 162.973C78.4185 162.939 78.6704 162.911 78.6704 162.911V163.701H78.6664C78.6505 163.87 78.563 164.032 78.4039 164.129L75.7936 165.623C75.494 165.805 75.1241 165.803 74.8258 165.619L72.3043 164.084C72.1784 164.006 72.1161 163.873 72.1148 163.74V163.056Z",
    fill: "url(#paint112_linear_620_3722)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1148 163.026C72.1148 163.026 72.425 163 72.9659 162.955L74.9955 161.813C75.3813 161.579 75.8586 161.58 76.243 161.819L78.099 162.943C78.4185 162.908 78.6704 162.881 78.6704 162.881V163.671H78.6664C78.6505 163.84 78.563 164.002 78.4039 164.099L75.7936 165.593C75.494 165.775 75.1241 165.773 74.8258 165.589L72.3043 164.053C72.1784 163.976 72.1161 163.843 72.1148 163.71V163.026Z",
    fill: "url(#paint113_linear_620_3722)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3069 162.653L74.9941 161.112C75.3799 160.878 75.8571 160.88 76.2416 161.118L78.4065 162.433C78.7578 162.651 78.7564 163.184 78.4025 163.398L75.7922 164.892C75.4925 165.074 75.1227 165.072 74.8244 164.888L72.3029 163.353C72.0483 163.195 72.0497 162.809 72.3055 162.653H72.3069Z",
    fill: "url(#paint114_linear_620_3722)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7744 166.272C66.7744 166.272 67.0846 166.245 67.6255 166.201L69.6552 165.059C70.041 164.825 70.5182 164.826 70.9027 165.064L72.7587 166.188C73.0782 166.154 73.3301 166.126 73.3301 166.126V166.917H73.3261C73.3102 167.086 73.2227 167.248 73.0636 167.345L70.4533 168.839C70.1537 169.02 69.7838 169.019 69.4855 168.835L66.964 167.299C66.8381 167.221 66.7757 167.088 66.7744 166.956V166.272Z",
    fill: "url(#paint115_linear_620_3722)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7744 166.241C66.7744 166.241 67.0846 166.215 67.6255 166.171L69.6552 165.028C70.041 164.794 70.5182 164.796 70.9027 165.034L72.7587 166.158C73.0782 166.124 73.3301 166.096 73.3301 166.096V166.887H73.3261C73.3102 167.055 73.2227 167.217 73.0636 167.314L70.4533 168.808C70.1537 168.99 69.7838 168.988 69.4855 168.804L66.964 167.269C66.8381 167.191 66.7757 167.058 66.7744 166.925V166.241Z",
    fill: "url(#paint116_linear_620_3722)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M66.968 165.869L69.6552 164.328C70.041 164.094 70.5182 164.095 70.9027 164.333L73.0676 165.649C73.4189 165.866 73.4176 166.399 73.0636 166.614L70.4533 168.108C70.1537 168.289 69.7838 168.288 69.4855 168.104L66.964 166.568C66.7095 166.41 66.7108 166.024 66.9667 165.869H66.968Z",
    fill: "url(#paint117_linear_620_3722)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M61.436 169.486C61.436 169.486 61.7463 169.46 62.2872 169.416L64.3168 168.273C64.7026 168.039 65.1799 168.041 65.5643 168.279L67.4203 169.403C67.7398 169.369 67.9917 169.341 67.9917 169.341V170.132H67.9877C67.9718 170.301 67.8843 170.463 67.7252 170.56L65.1149 172.054C64.8153 172.235 64.4454 172.234 64.1471 172.049L61.6256 170.514C61.4997 170.436 61.4374 170.303 61.436 170.17V169.486Z",
    fill: "url(#paint118_linear_620_3722)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M61.436 169.456C61.436 169.456 61.7463 169.43 62.2872 169.386L64.3168 168.243C64.7026 168.009 65.1799 168.011 65.5643 168.249L67.4203 169.373C67.7398 169.338 67.9917 169.311 67.9917 169.311V170.101H67.9877C67.9718 170.27 67.8843 170.432 67.7252 170.529L65.1149 172.023C64.8153 172.205 64.4454 172.203 64.1471 172.019L61.6256 170.484C61.4997 170.406 61.4374 170.273 61.436 170.14V169.456Z",
    fill: "url(#paint119_linear_620_3722)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6281 169.084L64.3154 167.542C64.7011 167.308 65.1784 167.31 65.5628 167.548L67.7277 168.863C68.0791 169.081 68.0777 169.614 67.7238 169.829L65.1134 171.323C64.8138 171.504 64.444 171.503 64.1457 171.318L61.6242 169.783C61.3696 169.625 61.3709 169.239 61.6268 169.084H61.6281Z",
    fill: "url(#paint120_linear_620_3722)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0957 172.702C56.0957 172.702 56.4059 172.675 56.9468 172.631L58.9765 171.489C59.3623 171.255 59.8395 171.256 60.224 171.494L62.08 172.619C62.3995 172.584 62.6514 172.556 62.6514 172.556V173.347H62.6474C62.6315 173.516 62.544 173.678 62.3849 173.775L59.7746 175.269C59.475 175.45 59.1051 175.449 58.8068 175.265L56.2853 173.729C56.1594 173.652 56.0971 173.519 56.0957 173.386V172.702Z",
    fill: "url(#paint121_linear_620_3722)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0957 172.671C56.0957 172.671 56.4059 172.645 56.9468 172.601L58.9765 171.458C59.3623 171.224 59.8395 171.226 60.224 171.464L62.08 172.588C62.3995 172.554 62.6514 172.526 62.6514 172.526V173.317H62.6474C62.6315 173.486 62.544 173.648 62.3849 173.745L59.7746 175.239C59.475 175.42 59.1051 175.419 58.8068 175.234L56.2853 173.699C56.1594 173.621 56.0971 173.488 56.0957 173.355V172.671Z",
    fill: "url(#paint122_linear_620_3722)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2893 172.299L58.9765 170.758C59.3623 170.524 59.8395 170.525 60.224 170.763L62.3889 172.079C62.7402 172.296 62.7389 172.829 62.3849 173.044L59.7746 174.538C59.475 174.719 59.1051 174.718 58.8068 174.534L56.2853 172.998C56.0308 172.84 56.0321 172.454 56.2879 172.299H56.2893Z",
    fill: "url(#paint123_linear_620_3722)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7573 175.917C50.7573 175.917 51.0676 175.891 51.6084 175.846L53.6381 174.704C54.0239 174.47 54.5012 174.471 54.8856 174.71L56.7416 175.834C57.0611 175.799 57.313 175.772 57.313 175.772V176.562H57.309C57.2931 176.731 57.2056 176.893 57.0465 176.99L54.4362 178.484C54.1366 178.666 53.7667 178.664 53.4684 178.48L50.9469 176.944C50.821 176.867 50.7587 176.734 50.7573 176.601V175.917Z",
    fill: "url(#paint124_linear_620_3722)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7573 175.887C50.7573 175.887 51.0676 175.86 51.6084 175.816L53.6381 174.674C54.0239 174.44 54.5012 174.441 54.8856 174.679L56.7416 175.804C57.0611 175.769 57.313 175.741 57.313 175.741V176.532H57.309C57.2931 176.701 57.2056 176.863 57.0465 176.96L54.4362 178.454C54.1366 178.635 53.7667 178.634 53.4684 178.45L50.9469 176.914C50.821 176.837 50.7587 176.704 50.7573 176.571V175.887Z",
    fill: "url(#paint125_linear_620_3722)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9494 175.514L53.6366 173.973C54.0224 173.739 54.4997 173.741 54.8841 173.979L57.049 175.294C57.4003 175.511 57.399 176.045 57.045 176.259L54.4347 177.753C54.1351 177.935 53.7652 177.933 53.467 177.749L50.9454 176.214C50.6909 176.056 50.6922 175.669 50.9481 175.514H50.9494Z",
    fill: "url(#paint126_linear_620_3722)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4175 179.132C45.4175 179.132 45.7277 179.106 46.2686 179.061L48.2983 177.919C48.6841 177.685 49.1613 177.686 49.5458 177.924L51.4018 179.049C51.7213 179.014 51.9731 178.987 51.9731 178.987V179.777H51.9692C51.9533 179.946 51.8658 180.108 51.7067 180.205L49.0964 181.699C48.7967 181.88 48.4269 181.879 48.1286 181.695L45.6071 180.159C45.4811 180.082 45.4188 179.949 45.4175 179.816V179.132Z",
    fill: "url(#paint127_linear_620_3722)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4175 179.102C45.4175 179.102 45.7277 179.075 46.2686 179.031L48.2983 177.889C48.6841 177.655 49.1613 177.656 49.5458 177.894L51.4018 179.019C51.7213 178.984 51.9731 178.956 51.9731 178.956V179.747H51.9692C51.9533 179.916 51.8658 180.078 51.7067 180.175L49.0964 181.669C48.7967 181.85 48.4269 181.849 48.1286 181.665L45.6071 180.129C45.4811 180.052 45.4188 179.919 45.4175 179.786V179.102Z",
    fill: "url(#paint128_linear_620_3722)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M45.611 178.729L48.2983 177.188C48.6841 176.954 49.1613 176.955 49.5458 177.194L51.7107 178.509C52.062 178.726 52.0606 179.259 51.7067 179.474L49.0964 180.968C48.7967 181.149 48.4269 181.148 48.1286 180.964L45.6071 179.428C45.3525 179.271 45.3539 178.884 45.6097 178.729H45.611Z",
    fill: "url(#paint129_linear_620_3722)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M120.776 141.012C120.776 141.012 121.086 140.986 121.627 140.942L123.657 139.799C124.042 139.565 124.52 139.567 124.904 139.805L126.76 140.929C127.08 140.895 127.332 140.867 127.332 140.867V141.658H127.328C127.312 141.826 127.224 141.988 127.065 142.085L124.455 143.579C124.155 143.761 123.785 143.759 123.487 143.575L120.965 142.04C120.84 141.962 120.777 141.829 120.776 141.696V141.012Z",
    fill: "url(#paint130_linear_620_3722)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M120.776 140.982C120.776 140.982 121.086 140.956 121.627 140.911L123.657 139.769C124.042 139.535 124.52 139.536 124.904 139.775L126.76 140.899C127.08 140.864 127.332 140.837 127.332 140.837V141.627H127.328C127.312 141.796 127.224 141.958 127.065 142.055L124.455 143.549C124.155 143.731 123.785 143.729 123.487 143.545L120.965 142.009C120.84 141.932 120.777 141.799 120.776 141.666V140.982Z",
    fill: "url(#paint131_linear_620_3722)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M120.968 140.609L123.655 139.068C124.041 138.834 124.518 138.836 124.903 139.074L127.068 140.389C127.419 140.607 127.418 141.14 127.064 141.354L124.453 142.848C124.154 143.03 123.784 143.028 123.486 142.844L120.964 141.309C120.709 141.151 120.711 140.765 120.967 140.609H120.968Z",
    fill: "url(#paint132_linear_620_3722)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M115.436 144.228C115.436 144.228 115.746 144.201 116.287 144.157L118.317 143.015C118.703 142.781 119.18 142.782 119.564 143.02L121.42 144.145C121.74 144.11 121.992 144.082 121.992 144.082V144.873H121.988C121.972 145.042 121.884 145.204 121.725 145.301L119.115 146.795C118.815 146.976 118.445 146.975 118.147 146.791L115.626 145.255C115.5 145.177 115.437 145.045 115.436 144.912V144.228Z",
    fill: "url(#paint133_linear_620_3722)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M115.436 144.197C115.436 144.197 115.746 144.171 116.287 144.127L118.317 142.984C118.703 142.75 119.18 142.752 119.564 142.99L121.42 144.114C121.74 144.08 121.992 144.052 121.992 144.052V144.843H121.988C121.972 145.012 121.884 145.174 121.725 145.27L119.115 146.765C118.815 146.946 118.445 146.945 118.147 146.76L115.626 145.225C115.5 145.147 115.437 145.014 115.436 144.881V144.197Z",
    fill: "url(#paint134_linear_620_3722)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M115.63 143.825L118.317 142.284C118.703 142.05 119.18 142.051 119.564 142.289L121.729 143.605C122.081 143.822 122.079 144.355 121.725 144.57L119.115 146.064C118.815 146.245 118.445 146.244 118.147 146.06L115.626 144.524C115.371 144.366 115.372 143.98 115.628 143.825H115.63Z",
    fill: "url(#paint135_linear_620_3722)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M110.097 147.442C110.097 147.442 110.407 147.416 110.948 147.372L112.978 146.229C113.364 145.995 113.841 145.997 114.225 146.235L116.081 147.359C116.401 147.325 116.653 147.297 116.653 147.297V148.088H116.649C116.633 148.257 116.545 148.419 116.386 148.516L113.776 150.01C113.476 150.191 113.107 150.19 112.808 150.005L110.287 148.47C110.161 148.392 110.099 148.259 110.097 148.126V147.442Z",
    fill: "url(#paint136_linear_620_3722)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M110.097 147.412C110.097 147.412 110.407 147.386 110.948 147.342L112.978 146.199C113.364 145.965 113.841 145.967 114.225 146.205L116.081 147.329C116.401 147.294 116.653 147.267 116.653 147.267V148.057H116.649C116.633 148.226 116.545 148.388 116.386 148.485L113.776 149.979C113.476 150.161 113.107 150.159 112.808 149.975L110.287 148.44C110.161 148.362 110.099 148.229 110.097 148.096V147.412Z",
    fill: "url(#paint137_linear_620_3722)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M110.289 147.04L112.976 145.499C113.362 145.265 113.84 145.266 114.224 145.504L116.389 146.819C116.74 147.037 116.739 147.57 116.385 147.785L113.775 149.279C113.475 149.46 113.105 149.459 112.807 149.275L110.285 147.739C110.031 147.581 110.032 147.195 110.288 147.04H110.289Z",
    fill: "url(#paint138_linear_620_3722)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M104.757 150.658C104.757 150.658 105.068 150.631 105.608 150.587L107.638 149.445C108.024 149.211 108.501 149.212 108.886 149.45L110.742 150.575C111.061 150.54 111.313 150.512 111.313 150.512V151.303H111.309C111.293 151.472 111.206 151.634 111.047 151.731L108.436 153.225C108.137 153.406 107.767 153.405 107.468 153.221L104.947 151.685C104.821 151.608 104.759 151.475 104.757 151.342V150.658Z",
    fill: "url(#paint139_linear_620_3722)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M104.757 150.628C104.757 150.628 105.068 150.601 105.608 150.557L107.638 149.415C108.024 149.181 108.501 149.182 108.886 149.42L110.742 150.544C111.061 150.51 111.313 150.482 111.313 150.482V151.273H111.309C111.293 151.442 111.206 151.604 111.047 151.701L108.436 153.195C108.137 153.376 107.767 153.375 107.468 153.191L104.947 151.655C104.821 151.577 104.759 151.444 104.757 151.312V150.628Z",
    fill: "url(#paint140_linear_620_3722)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M104.951 150.255L107.638 148.714C108.024 148.48 108.501 148.481 108.886 148.719L111.05 150.035C111.402 150.252 111.4 150.785 111.047 151L108.436 152.494C108.137 152.675 107.767 152.674 107.468 152.49L104.947 150.954C104.692 150.796 104.694 150.41 104.95 150.255H104.951Z",
    fill: "url(#paint141_linear_620_3722)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4185 153.873C99.4185 153.873 99.7287 153.847 100.27 153.802L102.299 152.66C102.685 152.426 103.162 152.428 103.547 152.666L105.403 153.79C105.722 153.755 105.974 153.728 105.974 153.728V154.518H105.97C105.954 154.687 105.867 154.849 105.708 154.946L103.097 156.44C102.798 156.622 102.428 156.62 102.13 156.436L99.6081 154.901C99.4821 154.823 99.4198 154.69 99.4185 154.557V153.873Z",
    fill: "url(#paint142_linear_620_3722)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4185 153.843C99.4185 153.843 99.7287 153.817 100.27 153.772L102.299 152.63C102.685 152.396 103.162 152.397 103.547 152.635L105.403 153.76C105.722 153.725 105.974 153.697 105.974 153.697V154.488H105.97C105.954 154.657 105.867 154.819 105.708 154.916L103.097 156.41C102.798 156.591 102.428 156.59 102.13 156.406L99.6081 154.87C99.4821 154.793 99.4198 154.66 99.4185 154.527V153.843Z",
    fill: "url(#paint143_linear_620_3722)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6106 153.47L102.298 151.929C102.684 151.695 103.161 151.697 103.545 151.935L105.71 153.25C106.061 153.468 106.06 154.001 105.706 154.215L103.096 155.709C102.796 155.891 102.426 155.889 102.128 155.705L99.6066 154.17C99.352 154.012 99.3534 153.625 99.6092 153.47H99.6106Z",
    fill: "url(#paint144_linear_620_3722)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0786 157.088C94.0786 157.088 94.3888 157.062 94.9297 157.018L96.9594 155.875C97.3452 155.641 97.8224 155.643 98.2069 155.881L100.063 157.005C100.382 156.971 100.634 156.943 100.634 156.943V157.734H100.63C100.614 157.903 100.527 158.065 100.368 158.162L97.7575 159.656C97.4579 159.837 97.088 159.836 96.7897 159.651L94.2682 158.116C94.1423 158.038 94.0799 157.905 94.0786 157.772V157.088Z",
    fill: "url(#paint145_linear_620_3722)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0786 157.058C94.0786 157.058 94.3888 157.032 94.9297 156.988L96.9594 155.845C97.3452 155.611 97.8224 155.613 98.2069 155.851L100.063 156.975C100.382 156.94 100.634 156.913 100.634 156.913V157.703H100.63C100.614 157.872 100.527 158.034 100.368 158.131L97.7575 159.625C97.4579 159.807 97.088 159.805 96.7897 159.621L94.2682 158.086C94.1423 158.008 94.0799 157.875 94.0786 157.742V157.058Z",
    fill: "url(#paint146_linear_620_3722)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2722 156.686L96.9594 155.145C97.3452 154.911 97.8224 154.912 98.2069 155.15L100.372 156.465C100.723 156.683 100.722 157.216 100.368 157.431L97.7575 158.925C97.4579 159.106 97.088 159.105 96.7897 158.92L94.2682 157.385C94.0137 157.227 94.015 156.841 94.2709 156.686H94.2722Z",
    fill: "url(#paint147_linear_620_3722)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7403 160.303C88.7403 160.303 89.0505 160.277 89.5914 160.233L91.621 159.09C92.0068 158.856 92.4841 158.858 92.8685 159.096L94.7245 160.22C95.044 160.186 95.2959 160.158 95.2959 160.158V160.949H95.2919C95.276 161.117 95.1885 161.279 95.0294 161.376L92.4191 162.87C92.1195 163.052 91.7496 163.05 91.4513 162.866L88.9298 161.331C88.8039 161.253 88.7416 161.12 88.7403 160.987V160.303Z",
    fill: "url(#paint148_linear_620_3722)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7403 160.273C88.7403 160.273 89.0505 160.247 89.5914 160.202L91.621 159.06C92.0068 158.826 92.4841 158.827 92.8685 159.066L94.7245 160.19C95.044 160.155 95.2959 160.128 95.2959 160.128V160.918H95.2919C95.276 161.087 95.1885 161.249 95.0294 161.346L92.4191 162.84C92.1195 163.022 91.7496 163.02 91.4513 162.836L88.9298 161.3C88.8039 161.223 88.7416 161.09 88.7403 160.957V160.273Z",
    fill: "url(#paint149_linear_620_3722)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9323 159.901L91.6196 158.359C92.0053 158.125 92.4826 158.127 92.8671 158.365L95.0319 159.68C95.3833 159.898 95.3819 160.431 95.028 160.645L92.4176 162.139C92.118 162.321 91.7481 162.319 91.4499 162.135L88.9284 160.6C88.6738 160.442 88.6751 160.056 88.931 159.901H88.9323Z",
    fill: "url(#paint150_linear_620_3722)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3999 163.519C83.3999 163.519 83.7101 163.492 84.251 163.448L86.2807 162.306C86.6665 162.072 87.1437 162.073 87.5282 162.311L89.3842 163.436C89.7037 163.401 89.9556 163.373 89.9556 163.373V164.164H89.9516C89.9357 164.333 89.8482 164.495 89.6891 164.592L87.0788 166.086C86.7792 166.267 86.4093 166.266 86.111 166.082L83.5895 164.546C83.4636 164.468 83.4013 164.336 83.3999 164.203V163.519Z",
    fill: "url(#paint151_linear_620_3722)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3999 163.487C83.3999 163.487 83.7101 163.461 84.251 163.416L86.2807 162.274C86.6665 162.04 87.1437 162.041 87.5282 162.279L89.3842 163.404C89.7037 163.369 89.9556 163.341 89.9556 163.341V164.132H89.9516C89.9357 164.301 89.8482 164.463 89.6891 164.56L87.0788 166.054C86.7792 166.235 86.4093 166.234 86.111 166.05L83.5895 164.514C83.4636 164.437 83.4013 164.304 83.3999 164.171V163.487Z",
    fill: "url(#paint152_linear_620_3722)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5935 163.116L86.2807 161.575C86.6665 161.341 87.1437 161.342 87.5282 161.58L89.6931 162.896C90.0444 163.113 90.0431 163.646 89.6891 163.861L87.0788 165.355C86.7792 165.536 86.4093 165.535 86.111 165.351L83.5895 163.815C83.335 163.657 83.3363 163.271 83.5921 163.116H83.5935Z",
    fill: "url(#paint153_linear_620_3722)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0615 166.734C78.0615 166.734 78.3718 166.708 78.9127 166.663L80.9423 165.521C81.3281 165.287 81.8054 165.288 82.1898 165.527L84.0458 166.651C84.3653 166.616 84.6172 166.589 84.6172 166.589V167.379H84.6132C84.5973 167.548 84.5098 167.71 84.3507 167.807L81.7404 169.301C81.4408 169.482 81.0709 169.481 80.7726 169.297L78.2511 167.761C78.1252 167.684 78.0629 167.551 78.0615 167.418V166.734Z",
    fill: "url(#paint154_linear_620_3722)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0615 166.702C78.0615 166.702 78.3718 166.676 78.9127 166.632L80.9423 165.489C81.3281 165.255 81.8054 165.257 82.1898 165.495L84.0458 166.619C84.3653 166.585 84.6172 166.557 84.6172 166.557V167.347H84.6132C84.5973 167.516 84.5098 167.678 84.3507 167.775L81.7404 169.269C81.4408 169.451 81.0709 169.449 80.7726 169.265L78.2511 167.73C78.1252 167.652 78.0629 167.519 78.0615 167.386V166.702Z",
    fill: "url(#paint155_linear_620_3722)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2536 166.331L80.9408 164.79C81.3266 164.556 81.8039 164.557 82.1883 164.796L84.3532 166.111C84.7045 166.328 84.7032 166.861 84.3493 167.076L81.7389 168.57C81.4393 168.752 81.0694 168.75 80.7712 168.566L78.2497 167.03C77.9951 166.873 77.9964 166.486 78.2523 166.331H78.2536Z",
    fill: "url(#paint156_linear_620_3722)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7217 169.948C72.7217 169.948 73.0319 169.922 73.5728 169.877L75.6025 168.735C75.9882 168.501 76.4655 168.502 76.85 168.74L78.706 169.865C79.0255 169.83 79.2773 169.802 79.2773 169.802V170.593H79.2734C79.2575 170.762 79.17 170.924 79.0109 171.021L76.4005 172.515C76.1009 172.696 75.7311 172.695 75.4328 172.511L72.9113 170.975C72.7853 170.898 72.723 170.765 72.7217 170.632V169.948Z",
    fill: "url(#paint157_linear_620_3722)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7217 169.918C72.7217 169.918 73.0319 169.891 73.5728 169.847L75.6025 168.705C75.9882 168.471 76.4655 168.472 76.85 168.71L78.706 169.834C79.0255 169.8 79.2773 169.772 79.2773 169.772V170.563H79.2734C79.2575 170.732 79.17 170.894 79.0109 170.991L76.4005 172.485C76.1009 172.666 75.7311 172.665 75.4328 172.481L72.9113 170.945C72.7853 170.867 72.723 170.734 72.7217 170.602V169.918Z",
    fill: "url(#paint158_linear_620_3722)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9152 169.545L75.6025 168.004C75.9882 167.77 76.4655 167.771 76.85 168.009L79.0149 169.325C79.3662 169.542 79.3648 170.075 79.0109 170.29L76.4005 171.784C76.1009 171.965 75.7311 171.964 75.4328 171.78L72.9113 170.244C72.6567 170.086 72.6581 169.7 72.9139 169.545H72.9152Z",
    fill: "url(#paint159_linear_620_3722)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3828 173.163C67.3828 173.163 67.693 173.136 68.2339 173.092L70.2636 171.95C70.6494 171.716 71.1266 171.717 71.5111 171.955L73.3671 173.08C73.6866 173.045 73.9385 173.017 73.9385 173.017V173.808H73.9345C73.9186 173.977 73.8311 174.139 73.672 174.236L71.0617 175.73C70.7621 175.911 70.3922 175.91 70.0939 175.726L67.5724 174.19C67.4465 174.113 67.3841 173.98 67.3828 173.847V173.163Z",
    fill: "url(#paint160_linear_620_3722)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3828 173.132C67.3828 173.132 67.693 173.106 68.2339 173.062L70.2636 171.919C70.6494 171.685 71.1266 171.687 71.5111 171.925L73.3671 173.049C73.6866 173.015 73.9385 172.987 73.9385 172.987V173.778H73.9345C73.9186 173.947 73.8311 174.109 73.672 174.206L71.0617 175.7C70.7621 175.881 70.3922 175.88 70.0939 175.695L67.5724 174.16C67.4465 174.082 67.3841 173.949 67.3828 173.816V173.132Z",
    fill: "url(#paint161_linear_620_3722)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5749 172.76L70.2621 171.219C70.6479 170.985 71.1252 170.986 71.5096 171.224L73.6745 172.54C74.0258 172.757 74.0245 173.29 73.6705 173.505L71.0602 174.999C70.7606 175.18 70.3907 175.179 70.0924 174.995L67.5709 173.459C67.3164 173.301 67.3177 172.915 67.5736 172.76H67.5749Z",
    fill: "url(#paint162_linear_620_3722)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M62.043 176.378C62.043 176.378 62.3532 176.352 62.8941 176.307L64.9238 175.165C65.3095 174.931 65.7868 174.932 66.1713 175.171L68.0273 176.295C68.3468 176.26 68.5986 176.233 68.5986 176.233V177.023H68.5947C68.5787 177.192 68.4912 177.354 68.3322 177.451L65.7218 178.945C65.4222 179.127 65.0524 179.125 64.7541 178.941L62.2326 177.405C62.1066 177.328 62.0443 177.195 62.043 177.062V176.378Z",
    fill: "url(#paint163_linear_620_3722)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M62.043 176.348C62.043 176.348 62.3532 176.321 62.8941 176.277L64.9238 175.135C65.3095 174.901 65.7868 174.902 66.1713 175.14L68.0273 176.265C68.3468 176.23 68.5986 176.202 68.5986 176.202V176.993H68.5947C68.5787 177.162 68.4912 177.324 68.3322 177.421L65.7218 178.915C65.4222 179.096 65.0524 179.095 64.7541 178.911L62.2326 177.375C62.1066 177.298 62.0443 177.165 62.043 177.032V176.348Z",
    fill: "url(#paint164_linear_620_3722)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2365 175.975L64.9238 174.434C65.3095 174.2 65.7868 174.201 66.1713 174.44L68.3361 175.755C68.6875 175.972 68.6861 176.506 68.3322 176.72L65.7218 178.214C65.4222 178.396 65.0523 178.394 64.7541 178.21L62.2326 176.674C61.978 176.517 61.9793 176.13 62.2352 175.975H62.2365Z",
    fill: "url(#paint165_linear_620_3722)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7041 179.593C56.7041 179.593 57.0143 179.567 57.5552 179.523L59.5849 178.38C59.9707 178.146 60.4479 178.148 60.8324 178.386L62.6884 179.51C63.0079 179.476 63.2598 179.448 63.2598 179.448V180.239H63.2558C63.2399 180.408 63.1524 180.57 62.9933 180.666L60.383 182.16C60.0834 182.342 59.7135 182.34 59.4152 182.156L56.8937 180.621C56.7678 180.543 56.7055 180.41 56.7041 180.277V179.593Z",
    fill: "url(#paint166_linear_620_3722)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7041 179.563C56.7041 179.563 57.0143 179.537 57.5552 179.492L59.5849 178.35C59.9707 178.116 60.4479 178.117 60.8324 178.356L62.6884 179.48C63.0079 179.445 63.2598 179.418 63.2598 179.418V180.208H63.2558C63.2399 180.377 63.1524 180.539 62.9933 180.636L60.383 182.13C60.0834 182.312 59.7135 182.31 59.4152 182.126L56.8937 180.59C56.7678 180.513 56.7055 180.38 56.7041 180.247V179.563Z",
    fill: "url(#paint167_linear_620_3722)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8962 179.191L59.5834 177.649C59.9692 177.415 60.4465 177.417 60.8309 177.655L62.9958 178.97C63.3471 179.188 63.3458 179.721 62.9918 179.935L60.3815 181.43C60.0819 181.611 59.712 181.61 59.4137 181.425L56.8922 179.89C56.6377 179.732 56.639 179.346 56.8949 179.191H56.8962Z",
    fill: "url(#paint168_linear_620_3722)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3643 182.808C51.3643 182.808 51.6745 182.782 52.2154 182.738L54.2451 181.595C54.6308 181.361 55.1081 181.363 55.4926 181.601L57.3485 182.725C57.668 182.69 57.9199 182.663 57.9199 182.663V183.453H57.916C57.9 183.622 57.8126 183.784 57.6535 183.881L55.0431 185.375C54.7435 185.557 54.3736 185.555 54.0754 185.371L51.5539 183.836C51.4279 183.758 51.3656 183.625 51.3643 183.492V182.808Z",
    fill: "url(#paint169_linear_620_3722)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3643 182.778C51.3643 182.778 51.6745 182.752 52.2154 182.707L54.2451 181.565C54.6308 181.331 55.1081 181.332 55.4926 181.57L57.3485 182.695C57.668 182.66 57.9199 182.632 57.9199 182.632V183.423H57.916C57.9 183.592 57.8126 183.754 57.6535 183.851L55.0431 185.345C54.7435 185.526 54.3736 185.525 54.0754 185.341L51.5539 183.805C51.4279 183.728 51.3656 183.595 51.3643 183.462V182.778Z",
    fill: "url(#paint170_linear_620_3722)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5578 182.405L54.245 180.864C54.6308 180.63 55.1081 180.632 55.4925 180.87L57.6574 182.185C58.0087 182.403 58.0074 182.936 57.6535 183.15L55.0431 184.644C54.7435 184.826 54.3736 184.824 54.0753 184.64L51.5539 183.105C51.2993 182.947 51.3006 182.56 51.5565 182.405H51.5578Z",
    fill: "url(#paint171_linear_620_3722)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M126.723 144.69C126.723 144.69 127.033 144.664 127.574 144.619L129.604 143.477C129.99 143.243 130.467 143.244 130.851 143.483L132.707 144.607C133.027 144.572 133.279 144.545 133.279 144.545V145.335H133.275C133.259 145.504 133.171 145.666 133.012 145.763L130.402 147.257C130.102 147.439 129.733 147.437 129.434 147.253L126.913 145.717C126.787 145.64 126.724 145.507 126.723 145.374V144.69Z",
    fill: "url(#paint172_linear_620_3722)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M126.723 144.658C126.723 144.658 127.033 144.632 127.574 144.588L129.604 143.445C129.99 143.211 130.467 143.213 130.851 143.451L132.707 144.575C133.027 144.541 133.279 144.513 133.279 144.513V145.304H133.275C133.259 145.472 133.171 145.634 133.012 145.731L130.402 147.225C130.102 147.407 129.733 147.405 129.434 147.221L126.913 145.686C126.787 145.608 126.724 145.475 126.723 145.342V144.658Z",
    fill: "url(#paint173_linear_620_3722)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M126.915 144.287L129.602 142.746C129.988 142.512 130.466 142.513 130.85 142.752L133.015 144.067C133.366 144.284 133.365 144.818 133.011 145.032L130.401 146.526C130.101 146.708 129.731 146.706 129.433 146.522L126.911 144.986C126.657 144.829 126.658 144.442 126.914 144.287H126.915Z",
    fill: "url(#paint174_linear_620_3722)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M121.383 147.905C121.383 147.905 121.694 147.879 122.234 147.835L124.264 146.692C124.65 146.458 125.127 146.46 125.512 146.698L127.368 147.822C127.687 147.788 127.939 147.76 127.939 147.76V148.551H127.935C127.919 148.72 127.832 148.882 127.673 148.978L125.062 150.473C124.763 150.654 124.393 150.653 124.094 150.468L121.573 148.933C121.447 148.855 121.385 148.722 121.383 148.589V147.905Z",
    fill: "url(#paint175_linear_620_3722)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M121.383 147.874C121.383 147.874 121.694 147.847 122.234 147.803L124.264 146.661C124.65 146.427 125.127 146.428 125.512 146.666L127.368 147.791C127.687 147.756 127.939 147.728 127.939 147.728V148.519H127.935C127.919 148.688 127.832 148.85 127.673 148.947L125.062 150.441C124.763 150.622 124.393 150.621 124.094 150.437L121.573 148.901C121.447 148.823 121.385 148.691 121.383 148.558V147.874Z",
    fill: "url(#paint176_linear_620_3722)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M121.577 147.503L124.264 145.961C124.65 145.727 125.127 145.729 125.512 145.967L127.676 147.282C128.028 147.5 128.026 148.033 127.672 148.247L125.062 149.742C124.763 149.923 124.393 149.922 124.094 149.737L121.573 148.202C121.318 148.044 121.32 147.658 121.576 147.503H121.577Z",
    fill: "url(#paint177_linear_620_3722)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M116.044 151.119C116.044 151.119 116.355 151.093 116.896 151.049L118.925 149.906C119.311 149.672 119.788 149.674 120.173 149.912L122.029 151.036C122.348 151.002 122.6 150.974 122.6 150.974V151.764H122.596C122.58 151.933 122.493 152.095 122.334 152.192L119.723 153.686C119.424 153.868 119.054 153.866 118.756 153.682L116.234 152.147C116.108 152.069 116.046 151.936 116.044 151.803V151.119Z",
    fill: "url(#paint178_linear_620_3722)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M116.044 151.089C116.044 151.089 116.355 151.063 116.896 151.018L118.925 149.876C119.311 149.642 119.788 149.643 120.173 149.881L122.029 151.006C122.348 150.971 122.6 150.944 122.6 150.944V151.734H122.596C122.58 151.903 122.493 152.065 122.334 152.162L119.723 153.656C119.424 153.837 119.054 153.836 118.756 153.652L116.234 152.116C116.108 152.039 116.046 151.906 116.044 151.773V151.089Z",
    fill: "url(#paint179_linear_620_3722)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M116.237 150.716L118.924 149.175C119.31 148.941 119.787 148.943 120.171 149.181L122.336 150.496C122.687 150.714 122.686 151.247 122.332 151.461L119.722 152.955C119.422 153.137 119.052 153.135 118.754 152.951L116.233 151.416C115.978 151.258 115.979 150.871 116.235 150.716H116.237Z",
    fill: "url(#paint180_linear_620_3722)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M110.705 154.334C110.705 154.334 111.015 154.308 111.556 154.263L113.585 153.121C113.971 152.887 114.448 152.888 114.833 153.127L116.689 154.251C117.008 154.216 117.26 154.189 117.26 154.189V154.979H117.256C117.24 155.148 117.153 155.31 116.994 155.407L114.383 156.901C114.084 157.083 113.714 157.081 113.416 156.897L110.894 155.361C110.768 155.284 110.706 155.151 110.705 155.018V154.334Z",
    fill: "url(#paint181_linear_620_3722)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M110.705 154.304C110.705 154.304 111.015 154.277 111.556 154.233L113.585 153.091C113.971 152.857 114.448 152.858 114.833 153.096L116.689 154.221C117.008 154.186 117.26 154.158 117.26 154.158V154.949H117.256C117.24 155.118 117.153 155.28 116.994 155.377L114.383 156.871C114.084 157.052 113.714 157.051 113.416 156.867L110.894 155.331C110.768 155.254 110.706 155.121 110.705 154.988V154.304Z",
    fill: "url(#paint182_linear_620_3722)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M110.898 153.931L113.585 152.39C113.971 152.156 114.448 152.157 114.833 152.396L116.998 153.711C117.349 153.928 117.348 154.462 116.994 154.676L114.383 156.17C114.084 156.352 113.714 156.35 113.416 156.166L110.894 154.631C110.64 154.473 110.641 154.086 110.897 153.931H110.898Z",
    fill: "url(#paint183_linear_620_3722)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M105.366 157.549C105.366 157.549 105.676 157.523 106.217 157.479L108.247 156.336C108.632 156.102 109.11 156.104 109.494 156.342L111.35 157.466C111.669 157.432 111.921 157.404 111.921 157.404V158.195H111.917C111.901 158.364 111.814 158.526 111.655 158.622L109.045 160.117C108.745 160.298 108.375 160.297 108.077 160.112L105.555 158.577C105.429 158.499 105.367 158.366 105.366 158.233V157.549Z",
    fill: "url(#paint184_linear_620_3722)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M105.366 157.519C105.366 157.519 105.676 157.493 106.217 157.448L108.247 156.306C108.632 156.072 109.11 156.074 109.494 156.312L111.35 157.436C111.669 157.401 111.921 157.374 111.921 157.374V158.164H111.917C111.901 158.333 111.814 158.495 111.655 158.592L109.045 160.086C108.745 160.268 108.375 160.266 108.077 160.082L105.555 158.547C105.429 158.469 105.367 158.336 105.366 158.203V157.519Z",
    fill: "url(#paint185_linear_620_3722)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M105.558 157.147L108.245 155.605C108.631 155.371 109.108 155.373 109.493 155.611L111.657 156.926C112.009 157.144 112.007 157.677 111.653 157.892L109.043 159.386C108.744 159.567 108.374 159.566 108.075 159.381L105.554 157.846C105.299 157.688 105.301 157.302 105.557 157.147H105.558Z",
    fill: "url(#paint186_linear_620_3722)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M100.026 160.765C100.026 160.765 100.336 160.738 100.877 160.694L102.907 159.552C103.292 159.318 103.77 159.319 104.154 159.557L106.01 160.682C106.33 160.647 106.582 160.619 106.582 160.619V161.41H106.578C106.562 161.579 106.474 161.741 106.315 161.838L103.705 163.332C103.405 163.513 103.035 163.512 102.737 163.328L100.215 161.792C100.09 161.715 100.027 161.582 100.026 161.449V160.765Z",
    fill: "url(#paint187_linear_620_3722)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M100.026 160.734C100.026 160.734 100.336 160.708 100.877 160.664L102.907 159.521C103.292 159.287 103.77 159.289 104.154 159.527L106.01 160.651C106.33 160.617 106.582 160.589 106.582 160.589V161.38H106.578C106.562 161.549 106.474 161.711 106.315 161.808L103.705 163.302C103.405 163.483 103.035 163.482 102.737 163.297L100.215 161.762C100.09 161.684 100.027 161.551 100.026 161.418V160.734Z",
    fill: "url(#paint188_linear_620_3722)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M100.219 160.362L102.907 158.821C103.292 158.587 103.77 158.588 104.154 158.826L106.319 160.142C106.67 160.359 106.669 160.892 106.315 161.107L103.705 162.601C103.405 162.782 103.035 162.781 102.737 162.597L100.215 161.061C99.9609 160.903 99.9623 160.517 100.218 160.362H100.219Z",
    fill: "url(#paint189_linear_620_3722)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6875 163.98C94.6875 163.98 94.9977 163.953 95.5386 163.909L97.5683 162.767C97.9541 162.533 98.4313 162.534 98.8158 162.772L100.672 163.896C100.991 163.862 101.243 163.834 101.243 163.834V164.625H101.239C101.223 164.794 101.136 164.956 100.977 165.053L98.3664 166.547C98.0668 166.728 97.6969 166.727 97.3986 166.543L94.8771 165.007C94.7512 164.929 94.6889 164.796 94.6875 164.664V163.98Z",
    fill: "url(#paint190_linear_620_3722)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6875 163.949C94.6875 163.949 94.9977 163.923 95.5386 163.879L97.5683 162.736C97.9541 162.502 98.4313 162.504 98.8158 162.742L100.672 163.866C100.991 163.832 101.243 163.804 101.243 163.804V164.595H101.239C101.223 164.763 101.136 164.925 100.977 165.022L98.3664 166.516C98.0668 166.698 97.6969 166.696 97.3986 166.512L94.8771 164.977C94.7512 164.899 94.6889 164.766 94.6875 164.633V163.949Z",
    fill: "url(#paint191_linear_620_3722)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8811 163.577L97.5683 162.036C97.9541 161.802 98.4313 161.803 98.8158 162.041L100.981 163.357C101.332 163.574 101.331 164.107 100.977 164.322L98.3664 165.816C98.0668 165.997 97.6969 165.996 97.3986 165.812L94.8771 164.276C94.6226 164.118 94.6239 163.732 94.8797 163.577H94.8811Z",
    fill: "url(#paint192_linear_620_3722)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3486 167.195C89.3486 167.195 89.6589 167.169 90.1998 167.124L92.2294 165.982C92.6152 165.748 93.0925 165.749 93.4769 165.987L95.3329 167.112C95.6524 167.077 95.9043 167.05 95.9043 167.05V167.84H95.9003C95.8844 168.009 95.7969 168.171 95.6378 168.268L93.0275 169.762C92.7279 169.943 92.358 169.942 92.0597 169.758L89.5382 168.222C89.4123 168.145 89.35 168.012 89.3486 167.879V167.195Z",
    fill: "url(#paint193_linear_620_3722)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3486 167.165C89.3486 167.165 89.6589 167.138 90.1998 167.094L92.2294 165.952C92.6152 165.718 93.0925 165.719 93.4769 165.957L95.3329 167.082C95.6524 167.047 95.9043 167.019 95.9043 167.019V167.81H95.9003C95.8844 167.979 95.7969 168.141 95.6378 168.238L93.0275 169.732C92.7279 169.913 92.358 169.912 92.0597 169.728L89.5382 168.192C89.4123 168.114 89.35 167.982 89.3486 167.849V167.165Z",
    fill: "url(#paint194_linear_620_3722)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5407 166.792L92.228 165.251C92.6137 165.017 93.091 165.018 93.4755 165.257L95.6403 166.572C95.9916 166.789 95.9903 167.322 95.6364 167.537L93.026 169.031C92.7264 169.212 92.3565 169.211 92.0583 169.027L89.5368 167.491C89.2822 167.334 89.2835 166.947 89.5394 166.792H89.5407Z",
    fill: "url(#paint195_linear_620_3722)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0088 170.41C84.0088 170.41 84.319 170.384 84.8599 170.34L86.8896 169.197C87.2753 168.963 87.7526 168.965 88.1371 169.203L89.9931 170.327C90.3126 170.293 90.5645 170.265 90.5645 170.265V171.055H90.5605C90.5446 171.224 90.4571 171.386 90.298 171.483L87.6876 172.977C87.388 173.159 87.0182 173.157 86.7199 172.973L84.1984 171.438C84.0724 171.36 84.0101 171.227 84.0088 171.094V170.41Z",
    fill: "url(#paint196_linear_620_3722)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0088 170.378C84.0088 170.378 84.319 170.352 84.8599 170.308L86.8896 169.166C87.2753 168.932 87.7526 168.933 88.1371 169.171L89.9931 170.295C90.3126 170.261 90.5645 170.233 90.5645 170.233V171.024H90.5605C90.5446 171.193 90.4571 171.355 90.298 171.452L87.6876 172.946C87.388 173.127 87.0182 173.126 86.7199 172.941L84.1984 171.406C84.0724 171.328 84.0101 171.195 84.0088 171.063V170.378Z",
    fill: "url(#paint197_linear_620_3722)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2024 170.007L86.8896 168.466C87.2754 168.232 87.7526 168.234 88.1371 168.472L90.302 169.787C90.6533 170.005 90.652 170.538 90.298 170.752L87.6877 172.246C87.388 172.428 87.0182 172.426 86.7199 172.242L84.1984 170.707C83.9438 170.549 83.9452 170.163 84.201 170.007H84.2024Z",
    fill: "url(#paint198_linear_620_3722)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 173.626C78.6699 173.626 78.9802 173.599 79.521 173.555L81.5507 172.413C81.9365 172.179 82.4137 172.18 82.7982 172.418L84.6542 173.542C84.9737 173.508 85.2256 173.48 85.2256 173.48V174.271H85.2216C85.2057 174.44 85.1182 174.602 84.9591 174.699L82.3488 176.193C82.0492 176.374 81.6793 176.373 81.381 176.189L78.8595 174.653C78.7336 174.575 78.6713 174.443 78.6699 174.31V173.626Z",
    fill: "url(#paint199_linear_620_3722)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 173.594C78.6699 173.594 78.9802 173.568 79.521 173.523L81.5507 172.381C81.9365 172.147 82.4137 172.148 82.7982 172.386L84.6542 173.511C84.9737 173.476 85.2256 173.448 85.2256 173.448V174.239H85.2216C85.2057 174.408 85.1182 174.57 84.9591 174.667L82.3488 176.161C82.0492 176.342 81.6793 176.341 81.381 176.157L78.8595 174.621C78.7336 174.544 78.6713 174.411 78.6699 174.278V173.594Z",
    fill: "url(#paint200_linear_620_3722)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M78.862 173.223L81.5492 171.682C81.935 171.448 82.4123 171.449 82.7967 171.687L84.9616 173.003C85.3129 173.22 85.3116 173.753 84.9576 173.968L82.3473 175.462C82.0477 175.643 81.6778 175.642 81.3796 175.458L78.858 173.922C78.6035 173.764 78.6048 173.378 78.8607 173.223H78.862Z",
    fill: "url(#paint201_linear_620_3722)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3301 176.84C73.3301 176.84 73.6403 176.814 74.1812 176.77L76.2109 175.627C76.5967 175.393 77.0739 175.395 77.4584 175.633L79.3144 176.757C79.6338 176.723 79.8857 176.695 79.8857 176.695V177.486H79.8818C79.8659 177.655 79.7784 177.817 79.6193 177.914L77.009 179.408C76.7093 179.589 76.3395 179.588 76.0412 179.403L73.5197 177.868C73.3937 177.79 73.3314 177.657 73.3301 177.524V176.84Z",
    fill: "url(#paint202_linear_620_3722)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3301 176.809C73.3301 176.809 73.6403 176.782 74.1812 176.738L76.2109 175.596C76.5967 175.362 77.0739 175.363 77.4584 175.601L79.3144 176.726C79.6338 176.691 79.8857 176.663 79.8857 176.663V177.454H79.8818C79.8659 177.623 79.7784 177.785 79.6193 177.882L77.009 179.376C76.7093 179.557 76.3395 179.556 76.0412 179.372L73.5197 177.836C73.3937 177.759 73.3314 177.626 73.3301 177.493V176.809Z",
    fill: "url(#paint203_linear_620_3722)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5236 176.438L76.2109 174.896C76.5967 174.662 77.0739 174.664 77.4584 174.902L79.6232 176.217C79.9746 176.435 79.9732 176.968 79.6193 177.183L77.0089 178.677C76.7093 178.858 76.3395 178.857 76.0412 178.672L73.5197 177.137C73.2651 176.979 73.2665 176.593 73.5223 176.438H73.5236Z",
    fill: "url(#paint204_linear_620_3722)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9912 180.054C67.9912 180.054 68.3014 180.028 68.8423 179.984L70.872 178.841C71.2578 178.607 71.735 178.609 72.1195 178.847L73.9755 179.971C74.295 179.937 74.5469 179.909 74.5469 179.909V180.7H74.5429C74.527 180.868 74.4395 181.03 74.2804 181.127L71.6701 182.621C71.3705 182.803 71.0006 182.801 70.7023 182.617L68.1808 181.082C68.0549 181.004 67.9926 180.871 67.9912 180.738V180.054Z",
    fill: "url(#paint205_linear_620_3722)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9912 180.024C67.9912 180.024 68.3014 179.998 68.8423 179.953L70.872 178.811C71.2578 178.577 71.735 178.578 72.1195 178.817L73.9755 179.941C74.295 179.906 74.5469 179.879 74.5469 179.879V180.669H74.5429C74.527 180.838 74.4395 181 74.2804 181.097L71.6701 182.591C71.3705 182.773 71.0006 182.771 70.7023 182.587L68.1808 181.051C68.0549 180.974 67.9926 180.841 67.9912 180.708V180.024Z",
    fill: "url(#paint206_linear_620_3722)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1833 179.651L70.8705 178.11C71.2563 177.876 71.7336 177.878 72.118 178.116L74.2829 179.431C74.6342 179.649 74.6329 180.182 74.2789 180.396L71.6686 181.89C71.369 182.072 70.9991 182.07 70.7008 181.886L68.1793 180.351C67.9248 180.193 67.9261 179.807 68.182 179.651H68.1833Z",
    fill: "url(#paint207_linear_620_3722)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6514 183.27C62.6514 183.27 62.9616 183.243 63.5025 183.199L65.5322 182.057C65.9179 181.823 66.3952 181.824 66.7797 182.062L68.6357 183.187C68.9552 183.152 69.207 183.124 69.207 183.124V183.915H69.2031C69.1872 184.084 69.0996 184.246 68.9406 184.343L66.3302 185.837C66.0306 186.018 65.6608 186.017 65.3625 185.833L62.841 184.297C62.715 184.219 62.6527 184.087 62.6514 183.954V183.27Z",
    fill: "url(#paint208_linear_620_3722)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6514 183.239C62.6514 183.239 62.9616 183.213 63.5025 183.169L65.5322 182.026C65.9179 181.792 66.3952 181.794 66.7797 182.032L68.6357 183.156C68.9552 183.122 69.207 183.094 69.207 183.094V183.885H69.2031C69.1872 184.054 69.0996 184.216 68.9406 184.312L66.3302 185.806C66.0306 185.988 65.6608 185.986 65.3625 185.802L62.841 184.267C62.715 184.189 62.6527 184.056 62.6514 183.923V183.239Z",
    fill: "url(#paint209_linear_620_3722)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8449 182.867L65.5322 181.326C65.9179 181.092 66.3952 181.093 66.7797 181.331L68.9445 182.647C69.2959 182.864 69.2945 183.397 68.9406 183.612L66.3302 185.106C66.0306 185.287 65.6607 185.286 65.3625 185.102L62.841 183.566C62.5864 183.408 62.5877 183.022 62.8436 182.867H62.8449Z",
    fill: "url(#paint210_linear_620_3722)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M57.313 186.485C57.313 186.485 57.6232 186.459 58.1641 186.414L60.1938 185.272C60.5795 185.038 61.0568 185.039 61.4413 185.277L63.2973 186.402C63.6168 186.367 63.8687 186.34 63.8687 186.34V187.13H63.8647C63.8488 187.299 63.7613 187.461 63.6022 187.558L60.9918 189.052C60.6922 189.233 60.3224 189.232 60.0241 189.048L57.5026 187.512C57.3766 187.435 57.3143 187.302 57.313 187.169V186.485Z",
    fill: "url(#paint211_linear_620_3722)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M57.313 186.455C57.313 186.455 57.6232 186.428 58.1641 186.384L60.1938 185.242C60.5795 185.008 61.0568 185.009 61.4413 185.247L63.2973 186.372C63.6168 186.337 63.8687 186.309 63.8687 186.309V187.1H63.8647C63.8488 187.269 63.7613 187.431 63.6022 187.528L60.9918 189.022C60.6922 189.203 60.3224 189.202 60.0241 189.018L57.5026 187.482C57.3766 187.405 57.3143 187.272 57.313 187.139V186.455Z",
    fill: "url(#paint212_linear_620_3722)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5051 186.082L60.1923 184.541C60.5781 184.307 61.0553 184.308 61.4398 184.547L63.6047 185.862C63.956 186.079 63.9547 186.612 63.6007 186.827L60.9904 188.321C60.6908 188.503 60.3209 188.501 60.0226 188.317L57.5011 186.781C57.2466 186.624 57.2479 186.237 57.5038 186.082H57.5051Z",
    fill: "url(#paint213_linear_620_3722)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M132.67 148.366C132.67 148.366 132.981 148.34 133.522 148.296L135.551 147.153C135.937 146.919 136.414 146.921 136.799 147.159L138.655 148.283C138.974 148.249 139.226 148.221 139.226 148.221V149.012H139.222C139.206 149.18 139.119 149.342 138.96 149.439L136.349 150.933C136.05 151.115 135.68 151.113 135.382 150.929L132.86 149.394C132.734 149.316 132.672 149.183 132.67 149.05V148.366Z",
    fill: "url(#paint214_linear_620_3722)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M132.67 148.336C132.67 148.336 132.981 148.31 133.522 148.265L135.551 147.123C135.937 146.889 136.414 146.89 136.799 147.129L138.655 148.253C138.974 148.218 139.226 148.191 139.226 148.191V148.981H139.222C139.206 149.15 139.119 149.312 138.96 149.409L136.349 150.903C136.05 151.085 135.68 151.083 135.382 150.899L132.86 149.363C132.734 149.286 132.672 149.153 132.67 149.02V148.336Z",
    fill: "url(#paint215_linear_620_3722)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M132.864 147.963L135.551 146.422C135.937 146.188 136.414 146.19 136.799 146.428L138.964 147.743C139.315 147.961 139.314 148.494 138.96 148.708L136.349 150.202C136.05 150.384 135.68 150.382 135.382 150.198L132.86 148.663C132.605 148.505 132.607 148.119 132.863 147.963H132.864Z",
    fill: "url(#paint216_linear_620_3722)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M127.332 151.582C127.332 151.582 127.642 151.555 128.183 151.511L130.212 150.369C130.598 150.135 131.075 150.136 131.46 150.374L133.316 151.499C133.635 151.464 133.887 151.436 133.887 151.436V152.227H133.883C133.867 152.396 133.78 152.558 133.621 152.655L131.01 154.149C130.711 154.33 130.341 154.329 130.043 154.145L127.521 152.609C127.395 152.531 127.333 152.399 127.332 152.266V151.582Z",
    fill: "url(#paint217_linear_620_3722)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M127.332 151.55C127.332 151.55 127.642 151.524 128.183 151.479L130.212 150.337C130.598 150.103 131.075 150.104 131.46 150.342L133.316 151.467C133.635 151.432 133.887 151.404 133.887 151.404V152.195H133.883C133.867 152.364 133.78 152.526 133.621 152.623L131.01 154.117C130.711 154.298 130.341 154.297 130.043 154.113L127.521 152.577C127.395 152.5 127.333 152.367 127.332 152.234V151.55Z",
    fill: "url(#paint218_linear_620_3722)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M127.524 151.179L130.211 149.638C130.597 149.404 131.074 149.405 131.458 149.643L133.623 150.959C133.975 151.176 133.973 151.709 133.619 151.924L131.009 153.418C130.709 153.599 130.339 153.598 130.041 153.414L127.52 151.878C127.265 151.72 127.266 151.334 127.522 151.179H127.524Z",
    fill: "url(#paint219_linear_620_3722)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M121.992 154.796C121.992 154.796 122.302 154.77 122.843 154.726L124.872 153.583C125.258 153.349 125.736 153.351 126.12 153.589L127.976 154.713C128.295 154.679 128.547 154.651 128.547 154.651V155.442H128.543C128.527 155.611 128.44 155.773 128.281 155.87L125.671 157.364C125.371 157.545 125.001 157.544 124.703 157.359L122.181 155.824C122.055 155.746 121.993 155.613 121.992 155.48V154.796Z",
    fill: "url(#paint220_linear_620_3722)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M121.992 154.765C121.992 154.765 122.302 154.738 122.843 154.694L124.872 153.552C125.258 153.318 125.736 153.319 126.12 153.557L127.976 154.682C128.295 154.647 128.547 154.619 128.547 154.619V155.41H128.543C128.527 155.579 128.44 155.741 128.281 155.838L125.671 157.332C125.371 157.513 125.001 157.512 124.703 157.328L122.181 155.792C122.055 155.715 121.993 155.582 121.992 155.449V154.765Z",
    fill: "url(#paint221_linear_620_3722)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M122.185 154.394L124.872 152.853C125.258 152.619 125.736 152.62 126.12 152.858L128.285 154.173C128.636 154.391 128.635 154.924 128.281 155.139L125.671 156.633C125.371 156.814 125.001 156.813 124.703 156.629L122.181 155.093C121.927 154.935 121.928 154.549 122.184 154.394H122.185Z",
    fill: "url(#paint222_linear_620_3722)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5175 170.817C95.5175 170.817 95.8277 170.791 96.3686 170.747L119.534 156.799C119.92 156.565 120.397 156.566 120.782 156.804L122.638 157.929C122.957 157.894 123.209 157.866 123.209 157.866V158.657H123.205C123.189 158.826 123.102 158.988 122.943 159.085L99.1977 173.386C98.8981 173.567 98.5282 173.566 98.2299 173.382L95.7084 171.846C95.5825 171.768 95.5202 171.635 95.5188 171.503V170.819L95.5175 170.817Z",
    fill: "url(#paint223_linear_620_3722)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5175 170.787C95.5175 170.787 95.8277 170.761 96.3686 170.716L119.534 156.769C119.92 156.535 120.397 156.536 120.782 156.774L122.638 157.898C122.957 157.864 123.209 157.836 123.209 157.836V158.627H123.205C123.189 158.796 123.102 158.958 122.943 159.055L99.1977 173.355C98.8981 173.537 98.5282 173.535 98.2299 173.351L95.7084 171.816C95.5825 171.738 95.5202 171.605 95.5188 171.472V170.788L95.5175 170.787Z",
    fill: "url(#paint224_linear_620_3722)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7111 170.414L119.534 156.066C119.92 155.832 120.397 155.834 120.782 156.072L122.946 157.387C123.298 157.605 123.296 158.138 122.943 158.352L99.1977 172.653C98.8981 172.835 98.5282 172.833 98.2299 172.649L95.7084 171.114C95.4539 170.956 95.4552 170.569 95.7111 170.414Z",
    fill: "url(#paint225_linear_620_3722)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9561 174.086C89.9561 174.086 90.2663 174.06 90.8072 174.016L92.8368 172.874C93.2226 172.64 93.6999 172.641 94.0843 172.879L95.9403 174.003C96.2598 173.969 96.5117 173.941 96.5117 173.941V174.732H96.5077C96.4918 174.901 96.4043 175.063 96.2453 175.16L93.6349 176.654C93.3353 176.835 92.9654 176.834 92.6672 176.65L90.1457 175.114C90.0197 175.036 89.9574 174.903 89.9561 174.771V174.086Z",
    fill: "url(#paint226_linear_620_3722)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9561 174.056C89.9561 174.056 90.2663 174.03 90.8072 173.986L92.8368 172.843C93.2226 172.609 93.6999 172.611 94.0843 172.849L95.9403 173.973C96.2598 173.939 96.5117 173.911 96.5117 173.911V174.701H96.5077C96.4918 174.87 96.4043 175.032 96.2453 175.129L93.6349 176.623C93.3353 176.805 92.9654 176.803 92.6672 176.619L90.1457 175.084C90.0197 175.006 89.9574 174.873 89.9561 174.74V174.056Z",
    fill: "url(#paint227_linear_620_3722)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1496 173.684L92.8368 172.143C93.2226 171.909 93.6999 171.91 94.0843 172.148L96.2492 173.464C96.6005 173.681 96.5992 174.214 96.2452 174.429L93.6349 175.923C93.3353 176.104 92.9654 176.103 92.6672 175.919L90.1456 174.383C89.8911 174.225 89.8924 173.839 90.1483 173.684H90.1496Z",
    fill: "url(#paint228_linear_620_3722)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6172 177.302C84.6172 177.302 84.9274 177.276 85.4683 177.231L87.498 176.089C87.8838 175.855 88.361 175.856 88.7455 176.094L90.6015 177.219C90.921 177.184 91.1729 177.156 91.1729 177.156V177.947H91.1689C91.153 178.116 91.0655 178.278 90.9064 178.375L88.296 179.869C87.9964 180.05 87.6266 180.049 87.3283 179.865L84.8068 178.329C84.6808 178.252 84.6185 178.119 84.6172 177.986V177.302Z",
    fill: "url(#paint229_linear_620_3722)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6172 177.272C84.6172 177.272 84.9274 177.245 85.4683 177.201L87.498 176.059C87.8838 175.825 88.361 175.826 88.7455 176.064L90.6015 177.188C90.921 177.154 91.1729 177.126 91.1729 177.126V177.917H91.1689C91.153 178.086 91.0655 178.248 90.9064 178.345L88.296 179.839C87.9964 180.02 87.6266 180.019 87.3283 179.835L84.8068 178.299C84.6808 178.221 84.6185 178.088 84.6172 177.956V177.272Z",
    fill: "url(#paint230_linear_620_3722)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8093 176.899L87.4965 175.358C87.8823 175.124 88.3595 175.125 88.744 175.363L90.9089 176.679C91.2602 176.896 91.2589 177.429 90.9049 177.644L88.2946 179.138C87.995 179.319 87.6251 179.318 87.3268 179.134L84.8053 177.598C84.5508 177.44 84.5521 177.054 84.808 176.899H84.8093Z",
    fill: "url(#paint231_linear_620_3722)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2774 180.517C79.2774 180.517 79.5876 180.49 80.1285 180.446L82.1581 179.304C82.5439 179.07 83.0212 179.071 83.4056 179.309L85.2616 180.434C85.5811 180.399 85.833 180.371 85.833 180.371V181.162H85.829C85.8131 181.331 85.7256 181.493 85.5665 181.59L82.9562 183.084C82.6566 183.265 82.2867 183.264 81.9884 183.08L79.4669 181.544C79.341 181.467 79.2787 181.334 79.2774 181.201V180.517Z",
    fill: "url(#paint232_linear_620_3722)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2774 180.485C79.2774 180.485 79.5876 180.459 80.1285 180.414L82.1581 179.272C82.5439 179.038 83.0212 179.039 83.4056 179.278L85.2616 180.402C85.5811 180.367 85.833 180.34 85.833 180.34V181.13H85.829C85.8131 181.299 85.7256 181.461 85.5665 181.558L82.9562 183.052C82.6566 183.233 82.2867 183.232 81.9884 183.048L79.4669 181.512C79.341 181.435 79.2787 181.302 79.2774 181.169V180.485Z",
    fill: "url(#paint233_linear_620_3722)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4709 180.114L82.1581 178.573C82.5439 178.339 83.0212 178.34 83.4056 178.578L85.5705 179.894C85.9218 180.111 85.9205 180.644 85.5665 180.859L82.9562 182.353C82.6566 182.534 82.2867 182.533 81.9884 182.349L79.4669 180.813C79.2124 180.655 79.2137 180.269 79.4696 180.114H79.4709Z",
    fill: "url(#paint234_linear_620_3722)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9385 183.732C73.9385 183.732 74.2487 183.706 74.7896 183.661L76.8193 182.519C77.2051 182.285 77.6823 182.286 78.0668 182.525L79.9228 183.649C80.2423 183.614 80.4941 183.587 80.4941 183.587V184.377H80.4902C80.4743 184.546 80.3868 184.708 80.2277 184.805L77.6174 186.299C77.3177 186.481 76.9479 186.479 76.6496 186.295L74.1281 184.759C74.0021 184.682 73.9398 184.549 73.9385 184.416V183.732Z",
    fill: "url(#paint235_linear_620_3722)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9385 183.7C73.9385 183.7 74.2487 183.674 74.7896 183.63L76.8193 182.487C77.2051 182.253 77.6823 182.255 78.0668 182.493L79.9228 183.617C80.2423 183.583 80.4941 183.555 80.4941 183.555V184.346H80.4902C80.4743 184.514 80.3868 184.676 80.2277 184.773L77.6174 186.267C77.3177 186.449 76.9479 186.447 76.6496 186.263L74.1281 184.728C74.0021 184.65 73.9398 184.517 73.9385 184.384V183.7Z",
    fill: "url(#paint236_linear_620_3722)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1306 183.329L76.8178 181.788C77.2036 181.554 77.6808 181.555 78.0653 181.794L80.2302 183.109C80.5815 183.326 80.5802 183.86 80.2262 184.074L77.6159 185.568C77.3163 185.75 76.9464 185.748 76.6481 185.564L74.1266 184.028C73.8721 183.871 73.8734 183.484 74.1293 183.329H74.1306Z",
    fill: "url(#paint237_linear_620_3722)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5987 186.947C68.5987 186.947 68.9089 186.921 69.4498 186.877L71.4794 185.734C71.8652 185.5 72.3425 185.502 72.7269 185.74L74.5829 186.864C74.9024 186.83 75.1543 186.802 75.1543 186.802V187.593H75.1503C75.1344 187.762 75.0469 187.924 74.8878 188.02L72.2775 189.515C71.9779 189.696 71.608 189.695 71.3097 189.51L68.7882 187.975C68.6623 187.897 68.6 187.764 68.5987 187.631V186.947Z",
    fill: "url(#paint238_linear_620_3722)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5987 186.916C68.5987 186.916 68.9089 186.889 69.4498 186.845L71.4794 185.703C71.8652 185.469 72.3425 185.47 72.7269 185.708L74.5829 186.833C74.9024 186.798 75.1543 186.77 75.1543 186.77V187.561H75.1503C75.1344 187.73 75.0469 187.892 74.8878 187.989L72.2775 189.483C71.9779 189.664 71.608 189.663 71.3097 189.479L68.7882 187.943C68.6623 187.865 68.6 187.733 68.5987 187.6V186.916Z",
    fill: "url(#paint239_linear_620_3722)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7922 186.545L71.4794 185.003C71.8652 184.769 72.3425 184.771 72.7269 185.009L74.8918 186.324C75.2431 186.542 75.2418 187.075 74.8878 187.289L72.2775 188.784C71.9779 188.965 71.608 188.964 71.3097 188.779L68.7882 187.244C68.5337 187.086 68.535 186.7 68.7909 186.545H68.7922Z",
    fill: "url(#paint240_linear_620_3722)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2603 190.161C63.2603 190.161 63.5705 190.135 64.1114 190.091L66.141 188.948C66.5268 188.714 67.0041 188.716 67.3885 188.954L69.2445 190.078C69.564 190.044 69.8159 190.016 69.8159 190.016V190.806H69.8119C69.796 190.975 69.7085 191.137 69.5494 191.234L66.9391 192.728C66.6395 192.91 66.2696 192.908 65.9714 192.724L63.4498 191.189C63.3239 191.111 63.2616 190.978 63.2603 190.845V190.161Z",
    fill: "url(#paint241_linear_620_3722)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2603 190.131C63.2603 190.131 63.5705 190.105 64.1114 190.06L66.141 188.918C66.5268 188.684 67.0041 188.685 67.3885 188.923L69.2445 190.048C69.564 190.013 69.8159 189.986 69.8159 189.986V190.776H69.8119C69.796 190.945 69.7085 191.107 69.5494 191.204L66.9391 192.698C66.6395 192.879 66.2696 192.878 65.9714 192.694L63.4498 191.158C63.3239 191.081 63.2616 190.948 63.2603 190.815V190.131Z",
    fill: "url(#paint242_linear_620_3722)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4524 189.758L66.1396 188.217C66.5253 187.983 67.0026 187.985 67.3871 188.223L69.552 189.538C69.9033 189.756 69.9019 190.289 69.548 190.503L66.9376 191.997C66.638 192.179 66.2682 192.177 65.9699 191.993L63.4484 190.458C63.1938 190.3 63.1952 189.913 63.451 189.758H63.4524Z",
    fill: "url(#paint243_linear_620_3722)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 124.183L30.9833 167.943C28.0481 169.728 24.3653 167.517 24.3653 163.969V89.6762C24.3653 86.9498 25.7533 84.4284 28.0084 83.0561L100.199 39.1498C103.537 37.1199 107.726 39.6344 107.726 43.6694V115.473C107.726 119.06 105.901 122.376 102.932 124.182L102.934 124.183Z",
    fill: "url(#paint244_linear_620_3722)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7755 166.262C29.1573 166.262 29.5232 166.154 29.8706 165.945L101.818 122.184C104.096 120.796 105.512 118.226 105.512 115.475V43.6706C105.512 41.865 104.057 40.7476 102.71 40.7476C102.225 40.7476 101.756 40.8833 101.315 41.1505L29.1229 85.0568C27.5545 86.0109 26.5815 87.7805 26.5815 89.6775V163.97C26.5815 164.779 26.9407 165.308 27.2417 165.608C27.654 166.022 28.2147 166.262 28.7755 166.262Z",
    fill: "url(#paint245_linear_620_3722)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3077 101.612L87.2637 69.2925C87.6946 69.0253 88.0459 68.4382 88.0459 67.9882V67.8331C88.0459 67.3831 87.6933 67.2349 87.2637 67.5021L35.3077 99.8216C34.8769 100.089 34.5256 100.676 34.5256 101.126V101.281C34.5256 101.731 34.8782 101.879 35.3077 101.612Z",
    fill: "#C2C8E2"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 106.687L97.8296 67.8413C98.3003 67.5477 98.686 66.9052 98.686 66.4137C98.686 65.9221 98.3003 65.7587 97.8296 66.0523L35.382 104.898C34.9113 105.191 34.5256 105.834 34.5256 106.325C34.5256 106.817 34.9113 106.98 35.382 106.687Z",
    fill: "#C2C8E2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 111.807L97.8296 72.9619C98.3003 72.6683 98.686 72.0258 98.686 71.5343C98.686 71.0427 98.3003 70.8793 97.8296 71.1729L35.382 110.018C34.9113 110.312 34.5256 110.954 34.5256 111.446C34.5256 111.937 34.9113 112.101 35.382 111.807Z",
    fill: "#C2C8E2"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 116.929L97.8296 78.0834C98.3003 77.7899 98.686 77.1474 98.686 76.6559C98.686 76.1643 98.3003 76.0009 97.8296 76.2945L35.382 115.14C34.9113 115.433 34.5256 116.076 34.5256 116.567C34.5256 117.059 34.9113 117.222 35.382 116.929Z",
    fill: "#C2C8E2"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8333 114.925L97.909 83.1529C98.3359 82.887 98.6846 82.3055 98.6846 81.8596V81.6907C98.6846 81.2448 98.3359 81.098 97.909 81.3625L46.8333 113.135C46.4065 113.401 46.0578 113.982 46.0578 114.428V114.597C46.0578 115.043 46.4065 115.19 46.8333 114.925Z",
    fill: "#C2C8E2"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3077 129.794L87.2637 97.4746C87.6946 97.2074 88.0459 96.6203 88.0459 96.1703V96.0152C88.0459 95.5652 87.6933 95.417 87.2637 95.6843L35.3077 128.004C34.8769 128.271 34.5256 128.858 34.5256 129.308V129.463C34.5256 129.913 34.8782 130.061 35.3077 129.794Z",
    fill: "#C2C8E2"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 134.869L97.8296 96.0219C98.3003 95.7284 98.686 95.0859 98.686 94.5943C98.686 94.1028 98.3003 93.9394 97.8296 94.2329L35.382 133.08C34.9113 133.373 34.5256 134.016 34.5256 134.507C34.5256 134.999 34.9113 135.162 35.382 134.869Z",
    fill: "#C2C8E2"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 139.991L97.8296 101.144C98.3003 100.85 98.686 100.208 98.686 99.7164C98.686 99.2249 98.3003 99.0615 97.8296 99.355L35.382 138.202C34.9113 138.495 34.5256 139.138 34.5256 139.629C34.5256 140.121 34.9113 140.284 35.382 139.991Z",
    fill: "#C2C8E2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M35.382 145.111L97.8296 106.266C98.3003 105.972 98.686 105.33 98.686 104.838C98.686 104.346 98.3003 104.183 97.8296 104.477L35.382 143.323C34.9113 143.617 34.5256 144.259 34.5256 144.751C34.5256 145.243 34.9113 145.406 35.382 145.112V145.111Z",
    fill: "#C2C8E2"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8333 143.108L97.909 111.335C98.3359 111.069 98.6846 110.488 98.6846 110.042V109.873C98.6846 109.427 98.3359 109.28 97.909 109.545L46.8333 141.317C46.4065 141.583 46.0578 142.165 46.0578 142.61V142.779C46.0578 143.225 46.4065 143.372 46.8333 143.108Z",
    fill: "#C2C8E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M106.643 140.091C102.853 130.639 120.263 120.84 145.53 118.203C170.797 115.567 194.353 121.092 198.143 130.542C201.934 139.994 184.524 149.793 159.256 152.429C133.99 155.066 110.433 149.541 106.641 140.091H106.643Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M107.103 139.91C103.363 130.585 120.541 120.916 145.473 118.314C170.404 115.712 193.648 121.163 197.388 130.489C201.127 139.815 183.949 149.484 159.018 152.086C134.086 154.688 110.843 149.236 107.103 139.91Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M107.561 139.729C103.872 130.53 120.82 120.991 145.416 118.423C170.012 115.856 192.942 121.234 196.632 130.435C200.321 139.635 183.373 149.174 158.777 151.741C134.182 154.308 111.251 148.93 107.561 139.729Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M108.02 139.549C104.381 130.474 121.097 121.065 145.357 118.534C169.618 116.003 192.235 121.306 195.875 130.381C199.514 139.456 182.798 148.865 158.538 151.396C134.277 153.927 111.661 148.624 108.02 139.549Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.48 139.369C104.891 130.42 121.377 121.141 145.3 118.645C169.225 116.148 191.529 121.38 195.119 130.329C198.708 139.278 182.223 148.556 158.299 151.053C134.374 153.55 112.07 148.318 108.48 139.369Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M108.939 139.188C105.401 130.364 121.654 121.216 145.244 118.754C168.832 116.292 190.824 121.45 194.362 130.273C197.901 139.096 181.648 148.245 158.058 150.707C134.469 153.169 112.477 148.011 108.939 139.188Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M109.398 139.008C105.91 130.309 121.932 121.291 145.185 118.865C168.438 116.439 190.118 121.522 193.606 130.221C197.094 138.919 181.071 147.938 157.818 150.363C134.565 152.789 112.886 147.706 109.398 139.008Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M109.858 138.828C106.42 130.255 122.211 121.367 145.128 118.976C168.046 116.584 189.411 121.595 192.85 130.168C196.287 138.74 180.497 147.628 157.579 150.02C134.662 152.411 113.297 147.4 109.858 138.828Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M110.316 138.646C106.929 130.2 122.489 121.442 145.071 119.085C167.653 116.728 188.706 121.666 192.094 130.113C195.481 138.559 179.921 147.317 157.339 149.674C134.757 152.03 113.705 147.093 110.316 138.646Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.775 138.466C107.438 130.144 122.766 121.516 145.013 119.196C167.26 116.874 187.999 121.738 191.336 130.06C194.673 138.382 179.345 147.01 157.098 149.33C134.851 151.652 114.112 146.788 110.775 138.466Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M111.235 138.286C107.948 130.091 123.046 121.593 144.956 119.307C166.867 117.021 187.294 121.81 190.58 130.006C193.866 138.202 178.769 146.7 156.859 148.986C134.948 151.272 114.521 146.482 111.235 138.286Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M111.694 138.105C108.458 130.035 123.323 121.667 144.899 119.416C166.474 117.164 186.589 121.882 189.825 129.952C193.061 138.022 178.196 146.389 156.62 148.641C135.045 150.892 114.93 146.174 111.694 138.105Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M112.152 137.925C108.965 129.98 123.601 121.742 144.841 119.527C166.08 117.31 185.881 121.954 189.068 129.899C192.255 137.845 177.619 146.082 156.38 148.297C135.14 150.514 115.339 145.87 112.152 137.925Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M112.611 137.745C109.474 129.926 123.878 121.818 144.782 119.637C165.686 117.457 185.174 122.026 188.31 129.845C191.447 137.664 177.043 145.772 156.139 147.952C135.235 150.133 115.747 145.564 112.611 137.745Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M113.071 137.565C109.985 129.872 124.158 121.895 144.727 119.748C165.295 117.602 184.47 122.1 187.555 129.793C190.641 137.486 176.468 145.463 155.9 147.609C135.331 149.755 116.156 145.258 113.071 137.565Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M113.53 137.383C110.494 129.815 124.435 121.969 144.668 119.858C164.901 117.746 183.763 122.17 186.798 129.738C189.834 137.307 175.892 145.153 155.659 147.264C135.426 149.376 116.564 144.952 113.53 137.383Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M113.989 137.204C111.003 129.761 124.714 122.044 144.61 119.969C164.506 117.893 183.055 122.242 186.041 129.685C189.026 137.127 175.316 144.844 155.42 146.92C135.523 148.995 116.974 144.646 113.989 137.204Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.449 137.023C111.513 129.707 124.992 122.12 144.554 120.079C164.115 118.038 182.351 122.315 185.287 129.632C188.222 136.948 174.743 144.535 155.181 146.576C135.62 148.617 117.384 144.34 114.449 137.023Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M114.907 136.842C112.023 129.65 125.27 122.195 144.496 120.189C163.721 118.182 181.645 122.386 184.528 129.577C187.413 136.769 174.165 144.224 154.94 146.23C135.714 148.236 117.791 144.033 114.907 136.842Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M115.366 136.662C112.531 129.596 125.547 122.27 144.437 120.299C163.327 118.327 180.938 122.458 183.771 129.524C186.605 136.59 173.59 143.916 154.7 145.886C135.81 147.858 118.199 143.728 115.366 136.662Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M115.826 136.482C113.042 129.542 125.827 122.346 144.382 120.41C162.936 118.475 180.233 122.53 183.017 129.472C185.801 136.411 173.016 143.608 154.461 145.543C135.906 147.479 118.61 143.423 115.826 136.482Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M116.285 136.301C113.551 129.486 126.104 122.421 144.323 120.52C162.541 118.619 179.526 122.602 182.26 129.416C184.994 136.232 172.44 143.296 154.221 145.197C136.003 147.098 119.018 143.115 116.285 136.301Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M116.743 136.121C114.06 129.431 126.383 122.496 144.265 120.63C162.148 118.764 178.82 122.674 181.502 129.363C184.185 136.053 171.862 142.989 153.98 144.854C136.097 146.72 119.425 142.81 116.743 136.121Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M117.203 135.94C114.57 129.377 126.662 122.571 144.208 120.741C161.755 118.91 178.114 122.746 180.746 129.311C183.379 135.874 171.288 142.68 153.741 144.51C136.194 146.341 119.835 142.505 117.203 135.94Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M117.662 135.761C115.08 129.322 126.94 122.648 144.151 120.852C161.363 119.056 177.408 122.82 179.991 129.257C182.573 135.696 170.713 142.37 153.502 144.166C136.29 145.961 120.245 142.198 117.662 135.761Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M118.121 135.579C115.589 129.267 127.218 122.721 144.093 120.962C160.969 119.2 176.701 122.89 179.233 129.203C181.765 135.516 170.136 142.061 153.261 143.821C136.385 145.582 120.653 141.892 118.121 135.579Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M118.581 135.399C116.099 129.213 127.496 122.797 144.036 121.072C160.575 119.345 175.996 122.962 178.478 129.149C180.959 135.336 169.562 141.751 153.023 143.476C136.483 145.203 121.062 141.586 118.581 135.399Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M119.039 135.219C116.608 129.157 127.775 122.874 143.979 121.183C160.183 119.492 175.291 123.036 177.721 129.096C180.152 135.158 168.986 141.442 152.781 143.133C136.577 144.823 121.469 141.28 119.039 135.219Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M119.498 135.038C117.117 129.102 128.052 122.947 143.921 121.292C159.789 119.636 174.583 123.106 176.964 129.042C179.345 134.978 168.41 141.133 152.542 142.788C136.673 144.444 121.879 140.974 119.498 135.038Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M119.957 134.858C117.626 129.048 128.33 123.023 143.862 121.403C159.395 119.782 173.876 123.178 176.207 128.988C178.537 134.798 167.834 140.823 152.301 142.443C136.768 144.065 122.287 140.668 119.957 134.858Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M120.417 134.678C118.137 128.992 128.608 123.099 143.806 121.514C159.004 119.928 173.172 123.25 175.452 128.936C177.733 134.621 167.261 140.514 152.063 142.1C136.865 143.685 122.697 140.363 120.417 134.678Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M120.876 134.496C118.646 128.937 128.887 123.174 143.748 121.622C158.609 120.071 172.466 123.321 174.694 128.88C176.924 134.44 166.683 140.203 151.822 141.755C136.96 143.306 123.104 140.056 120.876 134.496Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M121.334 134.316C119.155 128.883 129.164 123.249 143.69 121.732C158.216 120.216 171.758 123.393 173.937 128.826C176.117 134.259 166.108 139.894 151.582 141.41C137.056 142.926 123.514 139.75 121.334 134.316Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M121.794 134.137C119.665 128.828 129.444 123.325 143.634 121.843C157.825 120.363 171.054 123.465 173.183 128.774C175.312 134.083 165.534 139.585 151.343 141.067C137.153 142.547 123.924 139.445 121.794 134.137Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M122.253 133.955C120.174 128.772 129.721 123.399 143.576 121.952C157.431 120.507 170.347 123.537 172.426 128.718C174.504 133.901 164.958 139.273 151.103 140.72C137.248 142.166 124.332 139.136 122.253 133.955Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M122.712 133.775C120.683 128.718 129.999 123.475 143.517 122.064C157.037 120.653 169.641 123.609 171.669 128.666C173.697 133.722 164.382 138.966 150.863 140.377C137.344 141.788 124.74 138.832 122.712 133.775Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M123.172 133.595C121.194 128.664 130.277 123.55 143.462 122.174C156.644 120.798 168.935 123.681 170.913 128.613C172.891 133.544 163.807 138.657 150.623 140.034C137.44 141.41 125.15 138.527 123.172 133.595Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M123.631 133.415C121.703 128.609 130.556 123.627 143.404 122.285C156.251 120.945 168.229 123.753 170.156 128.559C172.084 133.365 163.231 138.347 150.383 139.689C137.536 141.029 125.558 138.221 123.631 133.415Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M124.089 133.233C122.212 128.553 130.833 123.7 143.345 122.394C155.857 121.088 167.522 123.825 169.399 128.505C171.276 133.185 162.655 138.038 150.143 139.344C137.631 140.65 125.966 137.914 124.089 133.233Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M124.549 133.054C122.722 128.499 131.113 123.776 143.289 122.505C155.466 121.234 166.818 123.897 168.645 128.452C170.472 133.007 162.081 137.73 149.904 139.001C137.728 140.272 126.376 137.609 124.549 133.054Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M125.008 132.873C123.231 128.444 131.39 123.852 143.231 122.616C155.072 121.381 166.11 123.969 167.886 128.398C169.663 132.828 161.505 137.419 149.663 138.656C137.822 139.891 126.784 137.303 125.008 132.873Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M125.467 132.692C123.74 128.389 131.668 123.926 143.173 122.725C154.677 121.525 165.404 124.041 167.13 128.344C168.856 132.648 160.928 137.111 149.424 138.311C137.919 139.512 127.193 136.996 125.467 132.692Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M125.927 132.512C124.251 128.334 131.947 124.002 143.117 122.836C154.286 121.67 164.7 124.113 166.375 128.29C168.051 132.468 160.355 136.8 149.185 137.966C138.016 139.132 127.602 136.689 125.927 132.512Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M126.385 132.332C124.76 128.279 132.225 124.078 143.059 122.947C153.893 121.817 163.993 124.185 165.619 128.238C167.244 132.291 159.779 136.492 148.945 137.623C138.111 138.753 128.011 136.385 126.385 132.332Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M126.844 132.151C125.269 128.224 132.502 124.152 143 123.056C153.499 121.961 163.285 124.257 164.86 128.184C166.435 132.111 159.202 136.183 148.703 137.278C138.205 138.374 128.419 136.078 126.844 132.151Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M127.303 131.971C125.778 128.17 132.781 124.228 142.944 123.167C153.106 122.106 162.58 124.329 164.105 128.13C165.629 131.931 158.627 135.873 148.464 136.933C138.301 137.994 128.827 135.772 127.303 131.971Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M127.763 131.791C126.288 128.114 133.06 124.304 142.886 123.278C152.714 122.252 161.875 124.401 163.349 128.077C164.823 131.753 158.051 135.564 148.225 136.59C138.398 137.616 129.237 135.467 127.763 131.791Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M128.222 131.609C126.798 128.059 133.337 124.377 142.828 123.387C152.319 122.397 161.168 124.471 162.592 128.023C164.016 131.573 157.476 135.255 147.985 136.245C138.494 137.235 129.645 135.161 128.222 131.609Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M128.68 131.43C127.307 128.005 133.616 124.454 142.771 123.498C151.926 122.543 160.463 124.545 161.836 127.969C163.21 131.394 156.901 134.945 147.745 135.901C138.59 136.856 130.054 134.854 128.68 131.43Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M129.14 131.249C127.817 127.95 133.894 124.53 142.714 123.609C151.534 122.688 159.756 124.617 161.079 127.916C162.402 131.216 156.325 134.636 147.505 135.557C138.685 136.478 130.463 134.549 129.14 131.249Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.599 131.069C128.326 127.895 134.172 124.605 142.656 123.719C151.14 122.835 159.049 124.689 160.322 127.862C161.595 131.036 155.748 134.326 147.265 135.212C138.781 136.097 130.871 134.243 129.599 131.069Z",
    fill: "#0F0A26"
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M152.967 66.8684C152.967 66.8684 166.419 68.638 172.332 78.9385C178.244 89.239 185.281 103.155 185.281 103.155C185.281 103.155 182.5 117.251 167.444 118.155C152.389 119.059 144.457 65.7842 152.967 66.8684Z",
    fill: "url(#paint246_linear_620_3722)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M150.767 66.5149C152.064 66.6312 153.297 67.0702 154.389 67.8096C157.295 69.7758 162.847 74.2635 164.991 81.0027C167.953 90.3145 172.333 113.767 172.333 113.767C172.333 113.767 175.617 126.093 153.496 135.903C131.375 145.714 111.867 130.709 111.867 130.709C111.867 130.709 97.3121 102.152 100.1 88.88C102.887 75.6066 129.514 64.6138 129.514 64.6138L150.77 66.5149H150.767Z",
    fill: "url(#paint247_linear_620_3722)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M153.327 31.6629C153.327 31.6629 155.443 38.6735 154.886 40.2714L154.33 41.8707C154.33 41.8707 156 44.6995 156 46.7904C156 48.8812 157.002 59.4808 155.109 60.6384C153.216 61.7946 145.978 63.1488 144.975 63.7636C143.973 64.3784 144.737 70.8877 144.737 70.8877C144.737 70.8877 144.283 74.9821 135.151 74.2441C126.019 73.5061 121.632 69.7523 121.632 69.7523L120.344 43.2609L131.477 28.5903L153.327 31.6657V31.6629Z",
    fill: "url(#paint248_linear_620_3722)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M111.942 28.6667C111.942 28.6667 114.895 14.3562 131.57 14.8823C148.245 15.4085 148.912 21.6173 154.342 19.7231C159.773 17.8289 161.011 29.719 151.293 35.086C141.574 40.4529 137 39.1901 135.666 39.1901C134.333 39.1901 138.7 42.8733 135.23 46.3461C131.76 49.8188 136.333 56.7629 133.19 58.1309C130.047 59.499 127.854 46.2408 124.234 47.1879C120.613 48.1351 127.923 60.0086 123.947 62.2351C119.971 64.4616 108.711 56.0138 105.175 44.7675C101.641 33.5213 111.942 28.668 111.942 28.668V28.6667Z",
    fill: "#0F0A26"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M103.787 83.9992C110.123 83.1476 118.679 88.8787 120.479 108.577C122.28 128.275 122.935 136.046 122.935 136.046C122.935 136.046 122.117 142.01 110.006 143.455C97.8972 144.901 93.1511 135.865 93.1511 135.865C93.1511 135.865 91.6783 85.6234 103.787 83.9978V83.9992Z",
    fill: "url(#paint249_linear_620_3722)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M137.056 78.2001L140.082 71.7254L141.847 70.6772L147.806 73.5504L146.004 74.33L166.562 126.82L163.77 136.501L154.733 135.327L139.887 76.9761L137.056 78.2001Z",
    fill: "url(#paint250_linear_620_3722)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M140.083 71.7256L135.087 82.411C134.692 83.2571 133.767 83.6171 132.979 83.2308L114.227 74.056C113.513 73.707 113.308 72.6948 113.82 72.0427L118.776 65.73L139.876 70.9419L140.083 71.7242V71.7256Z",
    fill: "url(#paint251_linear_620_3722)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M139.875 70.9434L134.88 81.6288C134.485 82.4748 133.56 82.8349 132.772 82.4485L114.02 73.2737C113.306 72.9248 113.101 71.9126 113.613 71.2604L118.569 64.9478L139.875 70.9434Z",
    fill: "url(#paint252_linear_620_3722)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M141.847 70.6772L149.515 74.3743C149.947 74.5834 150.428 74.2206 150.411 73.6999L150.19 67.2419C150.18 66.9746 150.043 66.7323 149.829 66.6063L144.977 63.7622L141.848 70.6772H141.847Z",
    fill: "url(#paint253_linear_620_3722)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M142.047 70.2094L149.715 73.9065C150.147 74.1156 150.629 73.7528 150.611 73.2322L150.39 66.7741C150.381 66.5069 150.243 66.2645 150.029 66.1385L145.177 63.2944L142.049 70.2094H142.047Z",
    fill: "url(#paint254_linear_620_3722)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0513 72.9539L24.657 69.6791L18.2803 55.6968L23.6733 58.9715L30.0513 72.9539Z",
    fill: "url(#paint255_linear_620_3722)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00283601 36.9635C0.00681315 36.868 0.010787 36.7711 0.0160899 36.6742C0.0227185 36.5772 0.0293367 36.4803 0.0386166 36.3834C0.0478966 36.2864 0.058501 36.1881 0.0704324 36.0912C0.0810381 35.9915 0.0956274 35.8918 0.11021 35.7907C0.126119 35.691 0.142027 35.59 0.159261 35.4889C0.177821 35.385 0.199027 35.2812 0.220239 35.1773C0.24145 35.0735 0.265317 34.9696 0.290505 34.8658C0.314368 34.7605 0.342205 34.6553 0.370045 34.5501C0.38993 34.4711 0.412466 34.3936 0.435003 34.3147C0.437655 34.3064 0.440314 34.2981 0.442965 34.2898C0.448268 34.2718 0.452243 34.2538 0.457546 34.2371C0.488038 34.1347 0.518524 34.0322 0.551667 33.9297C0.583484 33.8287 0.616628 33.7276 0.652422 33.6279C0.685565 33.531 0.720037 33.434 0.755831 33.3371C0.791626 33.2416 0.828741 33.1446 0.867187 33.0491C0.896352 32.9771 0.925524 32.9051 0.956015 32.8331C0.957341 32.8276 0.959999 32.822 0.96265 32.8179C0.969279 32.7999 0.975896 32.7832 0.98385 32.7666C1.02495 32.6711 1.06605 32.5755 1.10848 32.48C1.15488 32.3762 1.20392 32.2723 1.25297 32.1685C1.30998 32.0494 1.36832 31.9303 1.42798 31.8126C1.49294 31.6852 1.56186 31.5606 1.6308 31.4346C1.64273 31.4138 1.65466 31.393 1.66527 31.3709C1.67985 31.3446 1.69312 31.3169 1.7077 31.2906C1.8416 31.0524 1.98211 30.8184 2.12927 30.5899C2.2446 30.4085 2.36525 30.2313 2.48855 30.0568C2.48855 30.0568 2.49119 30.0527 2.49384 30.0499C2.57471 29.9364 2.6569 29.8228 2.74042 29.7121C2.81201 29.6165 2.88492 29.5224 2.95916 29.4296C3.03075 29.3382 3.105 29.2496 3.17924 29.161C3.25215 29.0737 3.32638 28.9879 3.40062 28.9048C3.41653 28.8868 3.43245 28.8702 3.44836 28.8536C3.45499 28.8466 3.4616 28.8383 3.46823 28.8314C3.52391 28.7705 3.57827 28.7096 3.63395 28.65C3.71216 28.5656 3.79304 28.4839 3.87258 28.4022C3.9561 28.3191 4.0383 28.2374 4.12314 28.1585C4.20666 28.0795 4.29284 28.002 4.37769 27.9272C4.42276 27.8885 4.46782 27.8511 4.51157 27.8123C4.51952 27.8054 4.52881 27.7984 4.53676 27.7915C4.56858 27.7652 4.59907 27.7375 4.63088 27.7112C4.7144 27.6434 4.79793 27.5755 4.88277 27.5118C4.96497 27.4481 5.04849 27.3872 5.13068 27.3277C5.21155 27.2695 5.29241 27.2141 5.37461 27.1601C5.45548 27.1061 5.53503 27.0549 5.61722 27.005C5.63578 26.994 5.65433 26.9815 5.67289 26.9704L49.0383 0.819641C49.0992 0.782255 49.1602 0.747639 49.2199 0.713022C49.2994 0.668713 49.3763 0.625788 49.4559 0.585633C49.5327 0.545478 49.611 0.508092 49.6879 0.472091C49.7647 0.436089 49.8416 0.402857 49.9172 0.37101C49.9941 0.339163 50.071 0.3087 50.1479 0.279622C50.1625 0.274083 50.1757 0.269929 50.1903 0.264391C50.1956 0.263006 50.1983 0.261621 50.2036 0.260237C50.2619 0.239467 50.3189 0.218697 50.3759 0.200696C50.4568 0.175772 50.535 0.153618 50.6119 0.132848C50.6901 0.112078 50.7683 0.094077 50.8452 0.0788457C50.9287 0.0622297 51.0122 0.0469984 51.0944 0.0359211C51.1501 0.0276131 51.2032 0.0234591 51.2575 0.0179205C51.2668 0.0179205 51.2747 0.0151511 51.284 0.0151511C51.3052 0.0137665 51.3264 0.00961247 51.349 0.00822781C51.4391 0.00130449 51.5279 -0.00146484 51.6154 -0.00146484C51.7162 -0.00146484 51.8143 0.00407382 51.9111 0.0123818C52.0238 0.0234591 52.1311 0.0400751 52.2385 0.0622297C52.2398 0.0622297 52.2425 0.0622297 52.2438 0.0636144C52.2478 0.0636144 52.2505 0.0663837 52.2544 0.0663837C52.3857 0.094077 52.5116 0.130078 52.6349 0.175772C52.7953 0.235313 52.9491 0.3087 53.0949 0.397319L58.4893 3.67067C58.2321 3.51558 57.951 3.40481 57.6488 3.33973C57.6448 3.33973 57.6421 3.33696 57.6382 3.33696C57.3386 3.27327 57.0177 3.25804 56.681 3.28711C56.6717 3.28711 56.6624 3.2885 56.6532 3.28988C56.3164 3.32312 55.9651 3.40204 55.5992 3.53082C55.5939 3.5322 55.5912 3.53358 55.5859 3.53497C55.2147 3.6679 54.829 3.85206 54.4352 4.08884L11.0699 30.2396C10.6801 30.475 10.301 30.7519 9.93373 31.0621C9.92445 31.0704 9.91518 31.0773 9.90722 31.0856C9.54531 31.393 9.19664 31.7337 8.86522 32.102C8.85859 32.1103 8.85063 32.1172 8.844 32.1255C8.50727 32.4994 8.18778 32.9023 7.88817 33.3246C7.59121 33.7442 7.31677 34.1873 7.06356 34.6415C7.05163 34.6622 7.04104 34.683 7.02911 34.7052C6.78253 35.1552 6.55582 35.6177 6.35962 36.0884C6.35962 36.0926 6.35696 36.0967 6.35431 36.1009C6.1528 36.5814 5.98178 37.0688 5.83993 37.559C5.83861 37.5673 5.83597 37.5756 5.83331 37.5839C5.69279 38.074 5.58275 38.567 5.50851 39.053C5.43427 39.5446 5.39582 40.0292 5.39582 40.5028L5.45813 63.1102C5.45813 63.574 5.50055 64.0005 5.57346 64.3938C5.57612 64.4048 5.57877 64.4173 5.5801 64.4284C5.65434 64.8133 5.76173 65.1636 5.90093 65.4766C5.9049 65.4835 5.90755 65.4918 5.9102 65.4987C6.003 65.705 6.12762 65.8684 6.24428 66.0415C6.49086 66.4029 6.77058 66.7214 7.11527 66.9291L1.72228 63.6543C1.3776 63.4453 1.09786 63.1296 0.851279 62.7668C0.819462 62.7211 0.770415 62.7017 0.739923 62.6532C0.661706 62.5258 0.590119 62.3901 0.525159 62.2475C0.521182 62.2406 0.519863 62.2323 0.515886 62.224C0.513234 62.2171 0.510575 62.2101 0.507924 62.2032C0.465501 62.1077 0.425728 62.0107 0.389934 61.9083C0.354139 61.8072 0.319671 61.702 0.290505 61.594C0.262665 61.4957 0.237484 61.3932 0.214947 61.2893C0.204341 61.245 0.197703 61.1979 0.188423 61.1536C0.185771 61.1426 0.183128 61.1315 0.180477 61.119C0.172523 61.0789 0.164563 61.0387 0.157934 60.9972C0.142025 60.9044 0.127451 60.8089 0.116845 60.7119C0.10624 60.6178 0.0956216 60.5222 0.0876673 60.4239C0.0810388 60.3312 0.0757366 60.237 0.0717594 60.1415C0.0664566 60.0459 0.0651393 59.9504 0.0638136 59.8521V59.8341L0.00283601 37.228C0.00283601 37.138 0.00282242 37.048 0.00547384 36.958L0.00283601 36.9635Z",
    fill: "url(#paint256_linear_620_3722)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0671 30.2438C7.91451 32.145 5.38372 36.7254 5.393 40.5083L5.45399 63.1158C5.4646 66.8987 8.01261 68.4163 11.1652 66.5151L23.6732 58.9728L30.0499 72.9552L37.4288 50.6787L54.5305 40.3657C57.6817 38.466 60.2138 33.8841 60.2046 30.1012L60.1436 7.49377C60.133 3.71087 57.5836 2.19466 54.4324 4.09442L11.0671 30.2452V30.2438Z",
    fill: "url(#paint257_linear_620_3722)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9917 59.2124L30.1377 72.6907L30.0515 72.9538L23.8286 59.3093L23.9917 59.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0672 30.2439L54.4325 4.09314C56.152 3.05603 57.6752 3.06711 58.7212 3.87852C57.6938 3.29973 56.2965 3.40081 54.7494 4.33407L11.384 30.4849C8.23146 32.386 5.69934 36.9665 5.70995 40.7494L5.77093 63.3568C5.77623 65.0752 6.32244 66.2951 7.19343 66.9708C6.12756 66.3712 5.46071 65.0419 5.45541 63.1159L5.3931 40.5084C5.38382 36.7255 7.91594 32.1451 11.0672 30.2439Z",
    fill: "white"
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M38.069 33.819C38.069 35.0459 38.9121 35.5402 39.9515 34.924C40.9908 34.3078 41.834 32.8152 41.834 31.5883C41.834 30.3615 40.9908 29.8672 39.9515 30.4834C38.9121 31.0996 38.069 32.5922 38.069 33.819Z",
    fill: "#FCFCFE"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7203 37.5798C31.7203 38.8066 32.5635 39.3009 33.6028 38.6847C34.6422 38.0686 35.4854 36.5759 35.4854 35.3491C35.4854 34.1223 34.6422 33.628 33.6028 34.2441C32.5635 34.8603 31.7203 36.353 31.7203 37.5798Z",
    fill: "#FCFCFE"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3712 41.3405C25.3712 42.5673 26.2144 43.0617 27.2537 42.4455C28.2931 41.8293 29.1362 40.3366 29.1362 39.1098C29.1362 37.883 28.2931 37.3887 27.2537 38.0049C26.2144 38.621 25.3712 40.1137 25.3712 41.3405Z",
    fill: "#FCFCFE"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8047 90.7772L59.4104 87.5038L53.035 73.5215L58.428 76.7948L64.8047 90.7772Z",
    fill: "url(#paint258_linear_620_3722)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7561 54.7883C34.7601 54.6927 34.7641 54.5958 34.7694 54.4989C34.776 54.4019 34.7826 54.305 34.7919 54.2081C34.8012 54.1112 34.8118 54.0128 34.8237 53.9159C34.8343 53.8162 34.8489 53.7165 34.8635 53.6154C34.8794 53.5157 34.8953 53.4147 34.9125 53.3136C34.9311 53.2097 34.9523 53.1059 34.9735 53.002C34.9947 52.8982 35.0186 52.7943 35.0438 52.6905C35.0676 52.5853 35.0955 52.48 35.1233 52.3748C35.1432 52.2959 35.1657 52.2183 35.1883 52.1394C35.1909 52.1311 35.1936 52.1228 35.1962 52.1145C35.2015 52.0965 35.2055 52.0785 35.2108 52.0618C35.2413 51.9594 35.2718 51.8569 35.3049 51.7545C35.3368 51.6534 35.3699 51.5523 35.4057 51.4526C35.4388 51.3557 35.4733 51.2587 35.5091 51.1618C35.5449 51.0663 35.582 50.9693 35.6205 50.8738C35.6496 50.8018 35.6788 50.7298 35.7093 50.6578C35.7106 50.6523 35.7133 50.6467 35.7159 50.6426C35.7225 50.6246 35.7292 50.6079 35.7358 50.5913C35.7769 50.4958 35.818 50.4002 35.8604 50.3047C35.9068 50.2009 35.9559 50.097 36.0049 49.9932C36.0619 49.8741 36.1203 49.755 36.1799 49.6373C36.2449 49.5099 36.3138 49.3853 36.3828 49.2593C36.3947 49.2385 36.4066 49.2177 36.4172 49.1956C36.4318 49.1693 36.4451 49.1416 36.4597 49.1153C36.5935 48.8771 36.7341 48.6431 36.8812 48.4146C36.9966 48.2332 37.1172 48.056 37.2405 47.8815C37.2405 47.8815 37.2431 47.8774 37.2458 47.8746C37.3267 47.7611 37.4089 47.6475 37.4924 47.5368C37.564 47.4412 37.6369 47.3471 37.7111 47.2543C37.7827 47.1629 37.8569 47.0743 37.9312 46.9857C38.0041 46.8984 38.0783 46.8126 38.1526 46.7295C38.1685 46.7115 38.1844 46.6949 38.2003 46.6783C38.2069 46.6713 38.2136 46.663 38.2202 46.6561C38.2759 46.5952 38.3302 46.5343 38.3859 46.4747C38.4641 46.3903 38.545 46.3086 38.6245 46.2269C38.7081 46.1438 38.7903 46.0621 38.8751 45.9832C38.9586 45.9042 39.0448 45.8267 39.1296 45.7519C39.1747 45.7132 39.2198 45.6758 39.2635 45.637C39.2715 45.6301 39.2808 45.6232 39.2887 45.6162C39.3205 45.5899 39.351 45.5622 39.3828 45.5359C39.4664 45.4681 39.5499 45.4002 39.6347 45.3365C39.7169 45.2728 39.8004 45.2119 39.8826 45.1524C39.9635 45.0942 40.0444 45.0388 40.1266 44.9848C40.2074 44.9308 40.287 44.8796 40.3692 44.8297C40.3877 44.8187 40.4063 44.8062 40.4248 44.7951L83.7902 18.6443C83.8512 18.607 83.9122 18.5723 83.9718 18.5377C84.0514 18.4934 84.1283 18.4505 84.2078 18.4103C84.2847 18.3702 84.3629 18.3328 84.4398 18.2968C84.5167 18.2608 84.5936 18.2276 84.6692 18.1957C84.746 18.1639 84.8229 18.1334 84.8998 18.1043C84.9144 18.0988 84.9277 18.0946 84.9423 18.0891C84.9476 18.0877 84.9502 18.0863 84.9555 18.0849C85.0138 18.0642 85.0709 18.0434 85.1279 18.0254C85.2087 18.0005 85.2869 17.9783 85.3638 17.9576C85.442 17.9368 85.5203 17.9188 85.5972 17.9036C85.6807 17.8869 85.7642 17.8717 85.8464 17.8606C85.9021 17.8523 85.9551 17.8482 86.0094 17.8426C86.0187 17.8426 86.0267 17.8399 86.036 17.8399C86.0572 17.8385 86.0784 17.8343 86.1009 17.8329C86.1911 17.826 86.2799 17.8232 86.3674 17.8232C86.4682 17.8232 86.5663 17.8288 86.663 17.8371C86.7757 17.8482 86.8831 17.8648 86.9905 17.8869C86.9918 17.8869 86.9945 17.8869 86.9958 17.8883C86.9998 17.8883 87.0024 17.8911 87.0064 17.8911C87.1376 17.9188 87.2636 17.9548 87.3869 18.0005C87.5473 18.06 87.7011 18.1334 87.8469 18.222L93.2412 21.4954C92.984 21.3403 92.703 21.2295 92.4007 21.1644C92.3967 21.1644 92.3941 21.1617 92.3901 21.1617C92.0905 21.098 91.7697 21.0827 91.4329 21.1118C91.4237 21.1118 91.4144 21.1132 91.4051 21.1146C91.0684 21.1478 90.717 21.2267 90.3512 21.3555C90.3458 21.3569 90.3432 21.3583 90.3379 21.3597C89.9667 21.4926 89.5809 21.6768 89.1872 21.9135L45.8218 48.0643C45.4321 48.2997 45.0529 48.5766 44.6857 48.8868C44.6764 48.8951 44.6671 48.902 44.6592 48.9104C44.2973 49.2177 43.9486 49.5584 43.6172 49.9267C43.6105 49.935 43.6026 49.9419 43.596 49.9502C43.2592 50.3241 42.9397 50.727 42.6401 51.1494C42.3432 51.5689 42.0687 52.012 41.8155 52.4662C41.8036 52.4869 41.793 52.5077 41.781 52.5299C41.5345 52.9799 41.3078 53.4424 41.1116 53.9131C41.1116 53.9173 41.1089 53.9215 41.1063 53.9256C40.9048 54.4061 40.7337 54.8935 40.5919 55.3837C40.5906 55.392 40.5879 55.4003 40.5853 55.4086C40.4447 55.8988 40.3347 56.3917 40.2605 56.8777C40.1862 57.3693 40.1478 57.8539 40.1478 58.3275L40.2101 80.9349C40.2101 81.3987 40.2525 81.8252 40.3254 82.2185C40.3281 82.2295 40.3307 82.242 40.3321 82.2531C40.4063 82.638 40.5137 82.9883 40.6529 83.3013C40.6568 83.3082 40.6595 83.3165 40.6622 83.3234C40.755 83.5297 40.8796 83.6931 40.9962 83.8662C41.2428 84.2276 41.5225 84.5461 41.8672 84.7538L36.4742 81.4791C36.1295 81.27 35.8498 80.9543 35.6032 80.5915C35.5714 80.5458 35.5224 80.5264 35.4919 80.4779C35.4137 80.3506 35.3421 80.2149 35.2771 80.0722C35.2731 80.0653 35.2718 80.057 35.2678 80.0487C35.2652 80.0418 35.2625 80.0348 35.2599 80.0279C35.2175 79.9324 35.1777 79.8355 35.1419 79.733C35.1061 79.6319 35.0716 79.5267 35.0425 79.4187C35.0146 79.3204 34.9894 79.2179 34.9669 79.114C34.9563 79.0697 34.9497 79.0227 34.9404 78.9783C34.9377 78.9673 34.9351 78.9562 34.9324 78.9437C34.9245 78.9036 34.9165 78.8634 34.9099 78.8219C34.894 78.7291 34.8794 78.6336 34.8688 78.5366C34.8582 78.4425 34.8489 78.3469 34.8396 78.2486C34.833 78.1559 34.8277 78.0617 34.8237 77.9662C34.8184 77.8706 34.8171 77.7751 34.8158 77.6768V77.6588L34.7548 55.0527C34.7548 54.9627 34.7548 54.8727 34.7574 54.7827L34.7561 54.7883Z",
    fill: "url(#paint259_linear_620_3722)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8205 48.0671C42.6679 49.9682 40.1372 54.5487 40.1464 58.3316L40.2074 80.939C40.218 84.7219 42.766 86.2395 45.9186 84.3384L58.4267 76.7961L64.8033 90.7784L72.1823 68.5019L89.2839 58.189C92.4352 56.2892 94.9673 51.7073 94.958 47.9244L94.897 25.317C94.8864 21.5341 92.3371 20.0179 89.1858 21.9177L45.8205 48.0684V48.0671Z",
    fill: "url(#paint260_linear_620_3722)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7451 77.0356L64.8911 90.514L64.8049 90.7771L58.5834 77.134L58.7451 77.0356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.822 48.0672L89.1874 21.9164C90.9068 20.8793 92.4301 20.8903 93.4761 21.7018C92.4486 21.123 91.0514 21.2241 89.5042 22.1573L46.1389 48.3081C42.9863 50.2092 40.4542 54.7897 40.4648 58.5726L40.5258 81.1801C40.5311 82.8984 41.0773 84.1183 41.9483 84.794C40.8824 84.1945 40.2156 82.8652 40.2103 80.9391L40.148 58.3317C40.1387 54.5488 42.6708 49.9683 45.822 48.0672Z",
    fill: "white"
  }))), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8775 61.4152L86.2294 38.8521C86.6788 38.5807 87.0474 37.9742 87.0474 37.5048C87.0474 37.0354 86.6788 36.8734 86.2294 37.1448L48.8775 59.7079C48.428 59.9793 48.0595 60.5858 48.0595 61.0552C48.0595 61.5246 48.428 61.6866 48.8775 61.4152Z",
    fill: "#FCFCFE"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8775 66.756L86.2294 44.1929C86.6788 43.9215 87.0474 43.315 87.0474 42.8456C87.0474 42.3762 86.6788 42.2142 86.2294 42.4856L48.8775 65.0487C48.428 65.3201 48.0595 65.9266 48.0595 66.396C48.0595 66.8654 48.428 67.0274 48.8775 66.756Z",
    fill: "#FCFCFE"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8775 72.0964L86.2294 49.5332C86.6788 49.2619 87.0474 48.6554 87.0474 48.186C87.0474 47.7166 86.6788 47.5546 86.2294 47.826L48.8775 70.3891C48.428 70.6605 48.0595 71.2669 48.0595 71.7363C48.0595 72.2057 48.428 72.3678 48.8775 72.0964Z",
    fill: "#FCFCFE"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M176.966 117.298C176.966 104.124 187.9 86.8435 201.386 78.6975C214.873 70.5529 225.806 74.6294 225.806 87.8031C225.806 98.0759 219.145 110.829 209.822 119.817L206.582 147.259L201.387 143.294L195.106 129.371C184.669 132.963 176.968 128.346 176.968 117.298H176.966Z",
    fill: "url(#paint261_linear_620_3722)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M182.161 121.264C182.161 108.09 193.094 90.8093 206.58 82.6633C220.067 74.5187 231 78.5952 231 91.7689C231 102.042 224.34 114.794 215.016 123.782L206.58 147.259L200.299 133.337C189.862 136.928 182.161 132.312 182.161 121.264Z",
    fill: "url(#paint262_linear_620_3722)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M207.087 98.2713L210.689 95.4826V91.5723L207.087 94.361V98.2713ZM207.087 116.881L210.689 114.092V97.4294L207.087 100.218V116.881Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4149 165.006L45.5104 146.014C49.4968 143.656 52.7275 138.369 52.7275 134.206V101.823C52.7275 97.6588 49.4968 96.1966 45.5104 98.5547L13.4149 117.547C9.42846 119.905 6.19771 125.192 6.19771 129.355V161.738C6.19771 165.902 9.42846 167.364 13.4149 165.006Z",
    fill: "url(#paint263_linear_620_3722)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M45.562 107.444L38.3528 111.71C37.1079 112.447 36.0407 114.049 35.814 115.521L32.5356 136.758L17.3601 145.737C16.3208 146.352 15.4352 146.05 15.2722 145.026L13.387 133.239C13.2133 132.156 14.0512 130.588 15.1489 129.938L34.9961 118.193",
    stroke: "#F1F1F2",
    strokeWidth: 9.97,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M27.897 122.395V139.502",
    stroke: "#F1F1F2",
    strokeWidth: 9.97,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9917 127.072L21.3638 143.368",
    stroke: "#F1F1F2",
    strokeWidth: 9.97,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6157 123.274L13.7649 135.613",
    stroke: "#F1F1F2",
    strokeWidth: 9.97,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5469 130.196L14.7496 141.32",
    stroke: "#F1F1F2",
    strokeWidth: 9.97,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5342 136.758L34.2629 141.018C34.6978 142.092 33.7963 144.026 32.5037 144.79L17.6531 153.577",
    stroke: "#F1F1F2",
    strokeWidth: 9.97,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M101.699 136.383C106.782 131.086 111.703 130.023 112.984 134.781C113.726 137.54 114.153 140.077 116.074 140.143C118.047 140.213 120.431 138.746 122.591 136.97C125.018 134.975 127.505 132.641 129.718 129.952C131.286 128.046 132.527 125.991 132.604 124.177C132.69 122.171 130.304 121.528 127.727 120.539C126.719 120.153 126.279 122.756 125.852 122.067C125.485 121.473 125.057 117.618 125.09 116.856C125.191 114.603 126.988 111.732 130.137 108.914C135.59 104.036 144.921 115.91 142.477 125.593C138.912 139.716 126.615 147.484 117.942 149.291C111.206 150.693 103.321 148.687 101.181 144.065C100.926 143.517 100.603 140.452 100.527 139.911C100.351 138.649 100.69 137.432 101.697 136.383H101.699Z",
    fill: "url(#paint264_linear_620_3722)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M102.318 140.336C107.401 135.039 112.322 133.976 113.603 138.734C114.345 141.493 114.772 144.03 116.693 144.097C118.666 144.166 121.051 142.699 123.21 140.923C125.638 138.928 128.125 136.594 130.337 133.905C131.906 131.999 133.147 129.944 133.223 128.13C133.31 126.124 130.923 125.481 128.346 124.493C123.905 122.788 125.305 117.745 130.758 112.867C136.21 107.989 145.542 119.864 143.097 129.547C139.532 143.669 127.235 151.437 118.562 153.244C109.166 155.202 97.2343 145.632 102.317 140.336H102.318Z",
    fill: "url(#paint265_linear_620_3722)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.214 127.804C133.244 127.963 133.263 128.128 133.255 128.308C133.177 130.122 131.937 132.176 130.369 134.083C128.156 136.772 125.668 139.105 123.242 141.101C121.082 142.876 118.697 144.342 116.725 144.274C114.804 144.208 114.377 141.671 113.634 138.911C112.354 134.154 107.433 135.217 102.35 140.514C101.281 141.627 100.973 142.93 101.226 144.274C100.909 142.867 101.203 141.499 102.32 140.336C107.402 135.04 112.323 133.977 113.604 138.734C114.346 141.494 114.773 144.031 116.694 144.097C118.667 144.166 121.052 142.7 123.211 140.923C125.639 138.928 128.126 136.595 130.338 133.906C131.907 131.999 133.148 129.944 133.224 128.13C133.23 128.017 133.225 127.909 133.214 127.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.789 113.043C127.385 116.089 125.562 119.198 125.752 121.52C125.448 119.181 127.266 115.992 130.759 112.867C135.191 108.901 142.185 116.005 143.336 124.003C142.108 116.077 135.188 109.106 130.788 113.043H130.789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_620_3722",
    x1: 79.7401,
    y1: 68.963,
    x2: -9.63938,
    y2: 224.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#969FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#7F8AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_620_3722",
    x1: 20.5059,
    y1: 157.274,
    x2: 123.36,
    y2: 174.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_620_3722",
    x1: 19.7105,
    y1: 156.956,
    x2: 123.133,
    y2: 174.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_620_3722",
    x1: 167.781,
    y1: 166.349,
    x2: 25.7062,
    y2: 166.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_620_3722",
    x1: 106.268,
    y1: 130.641,
    x2: 105.053,
    y2: 130.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_620_3722",
    x1: 106.268,
    y1: 130.611,
    x2: 105.053,
    y2: 130.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_620_3722",
    x1: 109.874,
    y1: 126.022,
    x2: 54.7228,
    y2: 179.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_620_3722",
    x1: 100.928,
    y1: 133.857,
    x2: 99.7148,
    y2: 133.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_620_3722",
    x1: 100.928,
    y1: 133.825,
    x2: 99.7148,
    y2: 133.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_620_3722",
    x1: 108.695,
    y1: 124.812,
    x2: 53.5445,
    y2: 178.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_620_3722",
    x1: 95.5891,
    y1: 137.071,
    x2: 94.376,
    y2: 137.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_620_3722",
    x1: 95.5891,
    y1: 137.04,
    x2: 94.376,
    y2: 137.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_620_3722",
    x1: 107.515,
    y1: 123.603,
    x2: 52.3642,
    y2: 177.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_620_3722",
    x1: 90.2506,
    y1: 140.287,
    x2: 89.0361,
    y2: 140.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_620_3722",
    x1: 90.2506,
    y1: 140.255,
    x2: 89.0361,
    y2: 140.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_620_3722",
    x1: 106.337,
    y1: 122.393,
    x2: 51.1859,
    y2: 176.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_620_3722",
    x1: 84.9104,
    y1: 143.501,
    x2: 83.6973,
    y2: 143.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_620_3722",
    x1: 84.9104,
    y1: 143.47,
    x2: 83.6973,
    y2: 143.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_620_3722",
    x1: 105.158,
    y1: 121.184,
    x2: 50.0057,
    y2: 174.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_620_3722",
    x1: 79.5718,
    y1: 146.716,
    x2: 78.3574,
    y2: 146.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_620_3722",
    x1: 79.5718,
    y1: 146.686,
    x2: 78.3574,
    y2: 146.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_620_3722",
    x1: 103.978,
    y1: 119.974,
    x2: 48.8273,
    y2: 173.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_620_3722",
    x1: 74.2321,
    y1: 149.931,
    x2: 73.019,
    y2: 149.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_620_3722",
    x1: 74.2321,
    y1: 149.9,
    x2: 73.019,
    y2: 149.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_620_3722",
    x1: 102.8,
    y1: 118.765,
    x2: 47.6476,
    y2: 172.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_620_3722",
    x1: 68.8931,
    y1: 153.146,
    x2: 67.6787,
    y2: 153.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_620_3722",
    x1: 68.8931,
    y1: 153.116,
    x2: 67.6787,
    y2: 153.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_620_3722",
    x1: 101.62,
    y1: 117.555,
    x2: 46.4688,
    y2: 171.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_620_3722",
    x1: 63.5534,
    y1: 156.361,
    x2: 62.3403,
    y2: 156.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_620_3722",
    x1: 63.5534,
    y1: 156.331,
    x2: 62.3403,
    y2: 156.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_620_3722",
    x1: 100.441,
    y1: 116.346,
    x2: 45.2905,
    y2: 170.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_620_3722",
    x1: 58.2149,
    y1: 159.577,
    x2: 57.0005,
    y2: 159.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_620_3722",
    x1: 58.2149,
    y1: 159.546,
    x2: 57.0005,
    y2: 159.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_620_3722",
    x1: 99.2616,
    y1: 115.136,
    x2: 44.1108,
    y2: 168.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_620_3722",
    x1: 52.8747,
    y1: 162.792,
    x2: 51.6616,
    y2: 162.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_620_3722",
    x1: 52.8747,
    y1: 162.761,
    x2: 51.6616,
    y2: 162.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_620_3722",
    x1: 98.0828,
    y1: 113.927,
    x2: 42.9307,
    y2: 167.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_620_3722",
    x1: 47.5363,
    y1: 166.007,
    x2: 46.3219,
    y2: 165.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_620_3722",
    x1: 47.5363,
    y1: 165.975,
    x2: 46.3219,
    y2: 165.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_620_3722",
    x1: 96.9031,
    y1: 112.717,
    x2: 41.7522,
    y2: 166.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_620_3722",
    x1: 42.196,
    y1: 169.222,
    x2: 40.9829,
    y2: 169.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_620_3722",
    x1: 42.196,
    y1: 169.19,
    x2: 40.9829,
    y2: 169.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_620_3722",
    x1: 95.7243,
    y1: 111.508,
    x2: 40.5734,
    y2: 165.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_620_3722",
    x1: 36.8576,
    y1: 172.437,
    x2: 35.6432,
    y2: 172.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_620_3722",
    x1: 36.8576,
    y1: 172.406,
    x2: 35.6432,
    y2: 172.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_620_3722",
    x1: 94.5445,
    y1: 110.298,
    x2: 39.3937,
    y2: 164.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_620_3722",
    x1: 112.215,
    y1: 134.317,
    x2: 111.001,
    y2: 134.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_620_3722",
    x1: 112.215,
    y1: 134.287,
    x2: 111.001,
    y2: 134.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_620_3722",
    x1: 114.662,
    y1: 130.932,
    x2: 59.511,
    y2: 184.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_620_3722",
    x1: 106.876,
    y1: 137.533,
    x2: 105.661,
    y2: 137.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_620_3722",
    x1: 106.876,
    y1: 137.503,
    x2: 105.661,
    y2: 137.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_620_3722",
    x1: 113.482,
    y1: 129.723,
    x2: 58.3308,
    y2: 183.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_620_3722",
    x1: 101.536,
    y1: 140.748,
    x2: 100.323,
    y2: 140.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_620_3722",
    x1: 101.536,
    y1: 140.717,
    x2: 100.323,
    y2: 140.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_620_3722",
    x1: 112.303,
    y1: 128.513,
    x2: 57.1525,
    y2: 182.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_620_3722",
    x1: 96.1975,
    y1: 143.963,
    x2: 94.983,
    y2: 143.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_620_3722",
    x1: 96.1975,
    y1: 143.931,
    x2: 94.983,
    y2: 143.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_620_3722",
    x1: 111.124,
    y1: 127.304,
    x2: 55.9727,
    y2: 181.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_620_3722",
    x1: 90.8571,
    y1: 147.178,
    x2: 89.644,
    y2: 147.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_620_3722",
    x1: 90.8571,
    y1: 147.147,
    x2: 89.644,
    y2: 147.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_620_3722",
    x1: 109.945,
    y1: 126.094,
    x2: 54.7939,
    y2: 179.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_620_3722",
    x1: 85.5187,
    y1: 150.394,
    x2: 84.3043,
    y2: 150.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_620_3722",
    x1: 85.5187,
    y1: 150.362,
    x2: 84.3043,
    y2: 150.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_620_3722",
    x1: 108.765,
    y1: 124.885,
    x2: 53.6142,
    y2: 178.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_620_3722",
    x1: 80.1789,
    y1: 153.607,
    x2: 78.9658,
    y2: 153.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_620_3722",
    x1: 80.1789,
    y1: 153.577,
    x2: 78.9658,
    y2: 153.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_620_3722",
    x1: 107.587,
    y1: 123.675,
    x2: 52.4359,
    y2: 177.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_620_3722",
    x1: 74.84,
    y1: 156.822,
    x2: 73.6256,
    y2: 156.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_620_3722",
    x1: 74.84,
    y1: 156.792,
    x2: 73.6256,
    y2: 156.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_620_3722",
    x1: 106.406,
    y1: 122.466,
    x2: 51.2557,
    y2: 176.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_620_3722",
    x1: 69.5002,
    y1: 160.038,
    x2: 68.2871,
    y2: 160.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_620_3722",
    x1: 69.5002,
    y1: 160.007,
    x2: 68.2871,
    y2: 159.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_620_3722",
    x1: 105.228,
    y1: 121.256,
    x2: 50.0773,
    y2: 175.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_620_3722",
    x1: 64.1613,
    y1: 163.253,
    x2: 62.9469,
    y2: 163.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_620_3722",
    x1: 64.1613,
    y1: 163.223,
    x2: 62.9469,
    y2: 163.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_620_3722",
    x1: 104.048,
    y1: 120.047,
    x2: 48.8971,
    y2: 173.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_620_3722",
    x1: 58.8215,
    y1: 166.468,
    x2: 57.6084,
    y2: 166.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_620_3722",
    x1: 58.8215,
    y1: 166.438,
    x2: 57.6084,
    y2: 166.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_620_3722",
    x1: 102.87,
    y1: 118.837,
    x2: 47.7188,
    y2: 172.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_620_3722",
    x1: 53.4826,
    y1: 169.683,
    x2: 52.2695,
    y2: 169.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_620_3722",
    x1: 53.4826,
    y1: 169.653,
    x2: 52.2695,
    y2: 169.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_620_3722",
    x1: 101.689,
    y1: 117.628,
    x2: 46.5386,
    y2: 171.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_620_3722",
    x1: 48.1441,
    y1: 172.899,
    x2: 46.9297,
    y2: 172.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_620_3722",
    x1: 48.1441,
    y1: 172.867,
    x2: 46.9297,
    y2: 172.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_620_3722",
    x1: 100.511,
    y1: 116.418,
    x2: 45.3602,
    y2: 170.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_620_3722",
    x1: 42.8044,
    y1: 176.113,
    x2: 41.5913,
    y2: 176.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_620_3722",
    x1: 42.8044,
    y1: 176.082,
    x2: 41.5913,
    y2: 176.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_620_3722",
    x1: 99.3313,
    y1: 115.209,
    x2: 44.1805,
    y2: 168.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_620_3722",
    x1: 118.162,
    y1: 137.994,
    x2: 116.949,
    y2: 137.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_620_3722",
    x1: 118.162,
    y1: 137.963,
    x2: 116.949,
    y2: 137.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_620_3722",
    x1: 119.449,
    y1: 135.842,
    x2: 64.2983,
    y2: 189.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_620_3722",
    x1: 112.823,
    y1: 141.209,
    x2: 111.61,
    y2: 141.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_620_3722",
    x1: 112.823,
    y1: 141.179,
    x2: 111.61,
    y2: 141.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_620_3722",
    x1: 118.269,
    y1: 134.633,
    x2: 63.118,
    y2: 188.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_620_3722",
    x1: 107.484,
    y1: 144.424,
    x2: 106.27,
    y2: 144.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_620_3722",
    x1: 107.484,
    y1: 144.394,
    x2: 106.27,
    y2: 144.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_620_3722",
    x1: 117.091,
    y1: 133.423,
    x2: 61.9397,
    y2: 187.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_620_3722",
    x1: 102.145,
    y1: 147.639,
    x2: 100.932,
    y2: 147.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_620_3722",
    x1: 102.145,
    y1: 147.609,
    x2: 100.932,
    y2: 147.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_620_3722",
    x1: 115.911,
    y1: 132.214,
    x2: 60.7599,
    y2: 185.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_620_3722",
    x1: 96.8057,
    y1: 150.855,
    x2: 95.5913,
    y2: 150.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_620_3722",
    x1: 96.8057,
    y1: 150.824,
    x2: 95.5913,
    y2: 150.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_620_3722",
    x1: 114.732,
    y1: 131.004,
    x2: 59.5813,
    y2: 184.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_620_3722",
    x1: 91.466,
    y1: 154.07,
    x2: 90.2529,
    y2: 154.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_620_3722",
    x1: 91.466,
    y1: 154.038,
    x2: 90.2529,
    y2: 154.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_620_3722",
    x1: 113.552,
    y1: 129.795,
    x2: 58.4014,
    y2: 183.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_620_3722",
    x1: 86.1275,
    y1: 157.285,
    x2: 84.9131,
    y2: 157.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_620_3722",
    x1: 86.1275,
    y1: 157.253,
    x2: 84.9131,
    y2: 157.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_620_3722",
    x1: 112.374,
    y1: 128.585,
    x2: 57.2231,
    y2: 182.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_620_3722",
    x1: 80.7873,
    y1: 160.5,
    x2: 79.5742,
    y2: 160.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_620_3722",
    x1: 80.7873,
    y1: 160.468,
    x2: 79.5742,
    y2: 160.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_620_3722",
    x1: 111.194,
    y1: 127.376,
    x2: 56.043,
    y2: 181.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_620_3722",
    x1: 75.4489,
    y1: 163.714,
    x2: 74.2345,
    y2: 163.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_620_3722",
    x1: 75.4489,
    y1: 163.684,
    x2: 74.2345,
    y2: 163.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_620_3722",
    x1: 110.015,
    y1: 126.168,
    x2: 54.8647,
    y2: 179.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_620_3722",
    x1: 70.1086,
    y1: 166.929,
    x2: 68.8955,
    y2: 166.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_620_3722",
    x1: 70.1086,
    y1: 166.899,
    x2: 68.8955,
    y2: 166.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_620_3722",
    x1: 108.835,
    y1: 124.958,
    x2: 53.6845,
    y2: 178.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_620_3722",
    x1: 64.7702,
    y1: 170.144,
    x2: 63.5558,
    y2: 170.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_620_3722",
    x1: 64.7702,
    y1: 170.114,
    x2: 63.5558,
    y2: 170.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_620_3722",
    x1: 107.657,
    y1: 123.748,
    x2: 52.5061,
    y2: 177.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_620_3722",
    x1: 59.4299,
    y1: 173.359,
    x2: 58.2168,
    y2: 173.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_620_3722",
    x1: 59.4299,
    y1: 173.329,
    x2: 58.2168,
    y2: 173.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_620_3722",
    x1: 106.478,
    y1: 122.538,
    x2: 51.3259,
    y2: 176.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_620_3722",
    x1: 54.0915,
    y1: 176.575,
    x2: 52.8771,
    y2: 176.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_620_3722",
    x1: 54.0915,
    y1: 176.544,
    x2: 52.8771,
    y2: 176.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_620_3722",
    x1: 105.298,
    y1: 121.328,
    x2: 50.1476,
    y2: 175.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_620_3722",
    x1: 48.7517,
    y1: 179.79,
    x2: 47.5386,
    y2: 179.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_620_3722",
    x1: 48.7517,
    y1: 179.759,
    x2: 47.5386,
    y2: 179.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_620_3722",
    x1: 104.119,
    y1: 120.119,
    x2: 48.9678,
    y2: 173.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_620_3722",
    x1: 124.11,
    y1: 141.67,
    x2: 122.896,
    y2: 141.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_620_3722",
    x1: 124.11,
    y1: 141.64,
    x2: 122.896,
    y2: 141.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_620_3722",
    x1: 124.236,
    y1: 140.753,
    x2: 69.085,
    y2: 194.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_620_3722",
    x1: 118.77,
    y1: 144.885,
    x2: 117.557,
    y2: 144.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_620_3722",
    x1: 118.77,
    y1: 144.855,
    x2: 117.557,
    y2: 144.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_620_3722",
    x1: 123.056,
    y1: 139.543,
    x2: 67.9054,
    y2: 193.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_620_3722",
    x1: 113.431,
    y1: 148.1,
    x2: 112.217,
    y2: 148.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_620_3722",
    x1: 113.431,
    y1: 148.07,
    x2: 112.217,
    y2: 148.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_620_3722",
    x1: 121.877,
    y1: 138.334,
    x2: 66.7265,
    y2: 192.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_620_3722",
    x1: 108.092,
    y1: 151.315,
    x2: 106.878,
    y2: 151.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_620_3722",
    x1: 108.092,
    y1: 151.285,
    x2: 106.878,
    y2: 151.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_620_3722",
    x1: 120.698,
    y1: 137.124,
    x2: 65.5469,
    y2: 190.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_620_3722",
    x1: 102.753,
    y1: 154.531,
    x2: 101.538,
    y2: 154.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_620_3722",
    x1: 102.753,
    y1: 154.501,
    x2: 101.538,
    y2: 154.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_620_3722",
    x1: 119.519,
    y1: 135.916,
    x2: 64.3679,
    y2: 189.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_620_3722",
    x1: 97.4128,
    y1: 157.746,
    x2: 96.1997,
    y2: 157.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_620_3722",
    x1: 97.4128,
    y1: 157.716,
    x2: 96.1997,
    y2: 157.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_620_3722",
    x1: 118.34,
    y1: 134.705,
    x2: 63.1883,
    y2: 188.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_620_3722",
    x1: 92.0744,
    y1: 160.961,
    x2: 90.86,
    y2: 160.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_620_3722",
    x1: 92.0744,
    y1: 160.931,
    x2: 90.86,
    y2: 160.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_620_3722",
    x1: 117.161,
    y1: 133.496,
    x2: 62.01,
    y2: 187.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_620_3722",
    x1: 86.7341,
    y1: 164.176,
    x2: 85.521,
    y2: 164.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_620_3722",
    x1: 86.7341,
    y1: 164.145,
    x2: 85.521,
    y2: 164.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_620_3722",
    x1: 115.982,
    y1: 132.286,
    x2: 60.8299,
    y2: 186.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_620_3722",
    x1: 81.3957,
    y1: 167.392,
    x2: 80.1813,
    y2: 167.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_620_3722",
    x1: 81.3957,
    y1: 167.36,
    x2: 80.1813,
    y2: 167.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_620_3722",
    x1: 114.802,
    y1: 131.078,
    x2: 59.6513,
    y2: 184.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_620_3722",
    x1: 76.0559,
    y1: 170.607,
    x2: 74.8427,
    y2: 170.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_620_3722",
    x1: 76.0559,
    y1: 170.575,
    x2: 74.8427,
    y2: 170.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_620_3722",
    x1: 113.624,
    y1: 129.867,
    x2: 58.4731,
    y2: 183.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_620_3722",
    x1: 70.717,
    y1: 173.82,
    x2: 69.5039,
    y2: 173.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_620_3722",
    x1: 70.717,
    y1: 173.79,
    x2: 69.5039,
    y2: 173.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_620_3722",
    x1: 112.444,
    y1: 128.658,
    x2: 57.2928,
    y2: 182.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_620_3722",
    x1: 65.3785,
    y1: 177.036,
    x2: 64.164,
    y2: 177.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_620_3722",
    x1: 65.3785,
    y1: 177.005,
    x2: 64.164,
    y2: 176.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_620_3722",
    x1: 111.264,
    y1: 127.448,
    x2: 56.1132,
    y2: 181.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_620_3722",
    x1: 60.0383,
    y1: 180.251,
    x2: 58.8252,
    y2: 180.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_620_3722",
    x1: 60.0383,
    y1: 180.221,
    x2: 58.8252,
    y2: 180.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_620_3722",
    x1: 110.085,
    y1: 126.24,
    x2: 54.9343,
    y2: 180.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_620_3722",
    x1: 54.6998,
    y1: 183.466,
    x2: 53.4853,
    y2: 183.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_620_3722",
    x1: 54.6998,
    y1: 183.436,
    x2: 53.4853,
    y2: 183.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_620_3722",
    x1: 108.907,
    y1: 125.029,
    x2: 53.756,
    y2: 178.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_620_3722",
    x1: 130.057,
    y1: 145.348,
    x2: 128.844,
    y2: 145.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_620_3722",
    x1: 130.057,
    y1: 145.316,
    x2: 128.844,
    y2: 145.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_620_3722",
    x1: 129.023,
    y1: 145.664,
    x2: 73.8723,
    y2: 199.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_620_3722",
    x1: 124.719,
    y1: 148.563,
    x2: 123.504,
    y2: 148.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_620_3722",
    x1: 124.719,
    y1: 148.531,
    x2: 123.504,
    y2: 148.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_620_3722",
    x1: 127.845,
    y1: 144.455,
    x2: 72.6941,
    y2: 198.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_620_3722",
    x1: 119.379,
    y1: 151.777,
    x2: 118.166,
    y2: 151.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_620_3722",
    x1: 119.379,
    y1: 151.747,
    x2: 118.166,
    y2: 151.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_620_3722",
    x1: 126.665,
    y1: 143.245,
    x2: 71.5137,
    y2: 197.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_620_3722",
    x1: 114.04,
    y1: 154.992,
    x2: 112.826,
    y2: 154.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_620_3722",
    x1: 114.04,
    y1: 154.961,
    x2: 112.826,
    y2: 154.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_620_3722",
    x1: 125.486,
    y1: 142.036,
    x2: 70.3356,
    y2: 195.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_620_3722",
    x1: 108.7,
    y1: 158.207,
    x2: 107.487,
    y2: 158.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_620_3722",
    x1: 108.7,
    y1: 158.177,
    x2: 107.487,
    y2: 158.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_620_3722",
    x1: 124.306,
    y1: 140.826,
    x2: 69.1552,
    y2: 194.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_620_3722",
    x1: 103.361,
    y1: 161.422,
    x2: 102.147,
    y2: 161.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_620_3722",
    x1: 103.361,
    y1: 161.392,
    x2: 102.147,
    y2: 161.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_620_3722",
    x1: 123.128,
    y1: 139.617,
    x2: 67.977,
    y2: 193.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_620_3722",
    x1: 98.0217,
    y1: 164.637,
    x2: 96.8086,
    y2: 164.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_620_3722",
    x1: 98.0217,
    y1: 164.607,
    x2: 96.8086,
    y2: 164.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_620_3722",
    x1: 121.948,
    y1: 138.406,
    x2: 66.7973,
    y2: 192.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_620_3722",
    x1: 92.6828,
    y1: 167.853,
    x2: 91.4684,
    y2: 167.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_620_3722",
    x1: 92.6828,
    y1: 167.822,
    x2: 91.4684,
    y2: 167.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_620_3722",
    x1: 120.769,
    y1: 137.198,
    x2: 65.6184,
    y2: 190.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_620_3722",
    x1: 87.343,
    y1: 171.068,
    x2: 86.1299,
    y2: 171.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_620_3722",
    x1: 87.343,
    y1: 171.036,
    x2: 86.1299,
    y2: 171.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_620_3722",
    x1: 119.59,
    y1: 135.988,
    x2: 64.4387,
    y2: 189.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_620_3722",
    x1: 82.0041,
    y1: 174.283,
    x2: 80.7897,
    y2: 174.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_620_3722",
    x1: 82.0041,
    y1: 174.252,
    x2: 80.7897,
    y2: 174.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_620_3722",
    x1: 118.411,
    y1: 134.779,
    x2: 63.2599,
    y2: 188.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_620_3722",
    x1: 76.6643,
    y1: 177.498,
    x2: 75.4512,
    y2: 177.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_620_3722",
    x1: 76.6643,
    y1: 177.466,
    x2: 75.4512,
    y2: 177.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_620_3722",
    x1: 117.231,
    y1: 133.568,
    x2: 62.0802,
    y2: 187.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_620_3722",
    x1: 71.3254,
    y1: 180.712,
    x2: 70.111,
    y2: 180.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_620_3722",
    x1: 71.3254,
    y1: 180.682,
    x2: 70.111,
    y2: 180.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_620_3722",
    x1: 116.052,
    y1: 132.36,
    x2: 60.9015,
    y2: 186.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_620_3722",
    x1: 65.9856,
    y1: 183.927,
    x2: 64.7724,
    y2: 183.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_620_3722",
    x1: 65.9856,
    y1: 183.897,
    x2: 64.7724,
    y2: 183.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_620_3722",
    x1: 114.872,
    y1: 131.15,
    x2: 59.7216,
    y2: 184.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_620_3722",
    x1: 60.6472,
    y1: 187.143,
    x2: 59.4327,
    y2: 187.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_620_3722",
    x1: 60.6472,
    y1: 187.112,
    x2: 59.4327,
    y2: 187.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_620_3722",
    x1: 113.694,
    y1: 129.941,
    x2: 58.5432,
    y2: 183.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_620_3722",
    x1: 136.005,
    y1: 149.024,
    x2: 134.791,
    y2: 148.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_620_3722",
    x1: 136.005,
    y1: 148.994,
    x2: 134.791,
    y2: 148.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_620_3722",
    x1: 133.811,
    y1: 150.574,
    x2: 78.6597,
    y2: 204.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_620_3722",
    x1: 130.666,
    y1: 152.239,
    x2: 129.451,
    y2: 152.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_620_3722",
    x1: 130.666,
    y1: 152.208,
    x2: 129.451,
    y2: 152.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_620_3722",
    x1: 132.632,
    y1: 149.365,
    x2: 77.4809,
    y2: 203.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_620_3722",
    x1: 125.326,
    y1: 155.454,
    x2: 124.113,
    y2: 155.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_620_3722",
    x1: 125.326,
    y1: 155.422,
    x2: 124.113,
    y2: 155.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_620_3722",
    x1: 131.452,
    y1: 148.154,
    x2: 76.3012,
    y2: 201.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_620_3722",
    x1: 109.627,
    y1: 165.078,
    x2: 104.576,
    y2: 164.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_620_3722",
    x1: 109.627,
    y1: 165.047,
    x2: 104.576,
    y2: 164.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_620_3722",
    x1: 168.965,
    y1: 100.959,
    x2: -149.63,
    y2: 411.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_620_3722",
    x1: 93.2902,
    y1: 174.744,
    x2: 92.0771,
    y2: 174.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_620_3722",
    x1: 93.2902,
    y1: 174.714,
    x2: 92.0771,
    y2: 174.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_620_3722",
    x1: 124.377,
    y1: 140.898,
    x2: 69.226,
    y2: 194.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_620_3722",
    x1: 87.9514,
    y1: 177.96,
    x2: 86.7383,
    y2: 177.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_620_3722",
    x1: 87.9514,
    y1: 177.929,
    x2: 86.7383,
    y2: 177.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_620_3722",
    x1: 123.198,
    y1: 139.689,
    x2: 68.0472,
    y2: 193.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_620_3722",
    x1: 82.6129,
    y1: 181.174,
    x2: 81.3984,
    y2: 181.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_620_3722",
    x1: 82.6129,
    y1: 181.143,
    x2: 81.3984,
    y2: 181.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_620_3722",
    x1: 122.018,
    y1: 138.478,
    x2: 66.8675,
    y2: 192.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_620_3722",
    x1: 77.2727,
    y1: 184.39,
    x2: 76.0596,
    y2: 184.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_620_3722",
    x1: 77.2727,
    y1: 184.358,
    x2: 76.0596,
    y2: 184.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_620_3722",
    x1: 120.839,
    y1: 137.27,
    x2: 65.6886,
    y2: 191.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_620_3722",
    x1: 71.9341,
    y1: 187.605,
    x2: 70.7197,
    y2: 187.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_620_3722",
    x1: 71.9341,
    y1: 187.573,
    x2: 70.7197,
    y2: 187.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_620_3722",
    x1: 119.661,
    y1: 136.06,
    x2: 64.5089,
    y2: 189.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_620_3722",
    x1: 66.5944,
    y1: 190.819,
    x2: 65.3813,
    y2: 190.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_620_3722",
    x1: 66.5944,
    y1: 190.789,
    x2: 65.3813,
    y2: 190.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F69AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_620_3722",
    x1: 118.481,
    y1: 134.851,
    x2: 63.3306,
    y2: 188.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABAED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_620_3722",
    x1: 36.0104,
    y1: 67.3637,
    x2: 83.0009,
    y2: 119.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_620_3722",
    x1: 36.0829,
    y1: 79.2426,
    x2: 80.4242,
    y2: 112.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_620_3722",
    x1: 177.216,
    y1: 85.6597,
    x2: 164.056,
    y2: 90.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858AC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_620_3722",
    x1: 168.589,
    y1: 93.0202,
    x2: 121.888,
    y2: 104.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858AC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_620_3722",
    x1: 153.854,
    y1: 50.4694,
    x2: 137.701,
    y2: 51.2324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D19797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_620_3722",
    x1: 121.751,
    y1: 114.484,
    x2: 97.5274,
    y2: 113.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858AC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_620_3722",
    x1: 143.165,
    y1: 72.3527,
    x2: 167.267,
    y2: 149.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#701616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C43A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_620_3722",
    x1: 113.241,
    y1: 71.601,
    x2: 136.032,
    y2: 76.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_620_3722",
    x1: 129.575,
    y1: 67.1798,
    x2: 123.316,
    y2: 77.1484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_620_3722",
    x1: 150.411,
    y1: 69.0987,
    x2: 141.847,
    y2: 69.0987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_620_3722",
    x1: 142.873,
    y1: 67.0372,
    x2: 151.085,
    y2: 69.6143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_620_3722",
    x1: 21.3069,
    y1: 54.5074,
    x2: 30.683,
    y2: 84.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#701616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C43A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_620_3722",
    x1: 58.4866,
    y1: 33.4673,
    x2: 0.000182897,
    y2: 33.4673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#701616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C43A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_620_3722",
    x1: 51.1963,
    y1: 60.291,
    x2: 18.8073,
    y2: 19.9653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#701616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C43A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EA5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_620_3722",
    x1: 60.1541,
    y1: 89.1364,
    x2: 57.139,
    y2: 73.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_620_3722",
    x1: 93.2399,
    y1: 51.2906,
    x2: 34.7534,
    y2: 51.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_620_3722",
    x1: 51.5767,
    y1: 38.992,
    x2: 95.508,
    y2: 74.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9196C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_620_3722",
    x1: 338.317,
    y1: 65.0543,
    x2: 333.94,
    y2: 4.83604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_620_3722",
    x1: 344.206,
    y1: 64.0488,
    x2: 340.041,
    y2: 6.75543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_620_3722",
    x1: 154.162,
    y1: 37.0297,
    x2: 143.362,
    y2: 97.1575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_620_3722",
    x1: 142.617,
    y1: 113.981,
    x2: 104.764,
    y2: 147.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_620_3722",
    x1: 143.224,
    y1: 117.94,
    x2: 106.472,
    y2: 150.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B419"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUslogo);
export default __webpack_public_path__ + "static/media/contactUslogo.183e507078166367f05937c58de89fb8.svg";
export { ForwardRef as ReactComponent };